<template>
  <div v-if="screenIsLoading" class="loading-container">
    <div class="loading-content">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <p>Loading Screen... </p>
    </div>
  </div>
  <div
    v-if="screen"
    ref="displayRoot"
    class="screen-display-root"
    :class="{ 'screen-display-root--embedded': embedded }"
    :style="screenDisplayRootStyle"
  >
    <!-- {{ renderMinyanimCountdownContent() }} -->
    <div class="image-container" ref="containerRef">
      <nav 
        v-if="showControls"
        @mouseenter="showNavbar" 
        @mouseleave="hideNavbar"
        :class="[!isNavbarVisible ? 'transparent' : null, 'navbar']"
        style="position: absolute; top: 0; left: 0; width: 100%; z-index: 10;"
      >
        <a v-if="isNavbarVisible" v-on:click="getScreen({ silent: true })" class="navbar-brand"><i class="pi pi-refresh"></i></a>
        <a v-if="isNavbarVisible" class="fullscreen-toggle" v-on:click="toggleFullScreen()">
          <i v-if="isFullScreen" class="pi pi-window-minimize"></i>
          <i v-else class="pi pi-window-maximize"></i>
        </a>
      </nav>
      <div v-if="showControls && isBackgroundLoading" class="loading-container">
        <div class="loading-content">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <p>Loading Background...</p>
        </div>
      </div>
      <img @mouseenter="showControls && showNavbar()"
      @mouseleave="showControls && hideNavbar()" :src="getScreenImage(screen.image)" class="col-12 screen-background-image" style="padding: 0px" ref="imageEl" @load="onImageLoad" />
    </div>
    
    <template :key="artboard.id" v-for="artboard in screen.artboards">
      <div
        class="artboard-wrapper"
        :style="getArtboardStyle(artboard)"
        :ref="'artboardWrapper' + artboard.id"
      >
        <div class="dropdown-container">
          <!-- <div class="dropdown">
            <button
              class="col-12 btn btn-custom-primary dropdown-toggle"
              type="button"
              data-toggle="dropdown"
            >
              <div class="row justify-content-between align-items-center">
                <span><i class="pi pi-plus"></i> New Announcement</span>
                <span><i class="pi pi-ellipsis-h"></i></span>
              </div> 
            </button>
            <div class="dropdown-menu">
              <a v-on:click="selectAddDonationModal(artboard)" class="dropdown-item">Add Donation</a>
              <a class="dropdown-item" href="#">Add Announcement</a>
            </div>
          </div> -->

        </div>
        <div
          class="artboard-box-inner"
          :ref="'artboardContent' + artboard.id"
        >
          <div
            :ref="'artboardScrollContent' + artboard.id"
            :key="displayItemIndexes[artboard.id] + '-scroll'"
            class="scaled-content"
            :style="getScaledContentStyle(artboard)"
          >
          <!--
            Inner scroller sized to its own content (like the Zmanim_N ticker).
            The animation lives here, NOT on the scaled viewport above, so the
            translate distance always equals exactly one content copy (seamless,
            never cut off) and the viewport's scale transform is never clobbered.
          -->
          <div
            class="credits-scroller"
            :class="{
              'credits-scroll-vertical': getArtboardScrollDirection(artboard) === 'vertical' && !isCurrentZmanimNHorizontalTicker(artboard) && !isCurrentRecentPhotoDisplay(artboard) && shouldDuplicateScrollTracks(artboard),
              'credits-vertical-static': getArtboardScrollDirection(artboard) === 'vertical' && !isCurrentZmanimNHorizontalTicker(artboard) && !isCurrentRecentPhotoDisplay(artboard) && !shouldDuplicateScrollTracks(artboard),
              'credits-scroll-horizontal': getArtboardScrollDirection(artboard) === 'horizontal' && !isCurrentZmanimNHorizontalTicker(artboard) && !isCurrentRecentPhotoDisplay(artboard) && shouldDuplicateScrollTracks(artboard),
              'credits-horizontal-static': getArtboardScrollDirection(artboard) === 'horizontal' && !isCurrentZmanimNHorizontalTicker(artboard) && !isCurrentRecentPhotoDisplay(artboard) && !shouldDuplicateScrollTracks(artboard),
              'credits-recent-photo': isCurrentRecentPhotoDisplay(artboard),
              'credits-no-scroll': artboard.scrollDirection === 'noscroll' || isCurrentRecentPhotoDisplay(artboard),
            }"
            :style="getCreditsScrollerStyle(artboard)"
          >
          <div
              class="credits-track"
              v-for="copy in (shouldDuplicateScrollTracks(artboard) ? 2 : 1)"
              :key="'track-' + copy"
              :style="getNoScrollTrackStyle(artboard)"
            >
              <template v-for="(displayElement, index) in getDisplayElements(artboard)" :key="index + '-' + copy">
                <!-- Donation -->
                <div
                  v-if="artboard.features.includes('Donation') && displayElement.type == 'Donation'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Donation UI here -->
                  <div v-if="true">
                    <!-- Add your donation UI here -->
                    <div v-html="renderDonationContent(displayElement.template?.content, displayElement)"></div>
                  </div>
                </div>

                <!-- Announcement -->
                <div
                  v-if="artboard.features.includes('Announcement') && displayElement.type == 'Announcement'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Announcement UI here -->
                  <div v-if="true">
                    <!-- Add your announcement UI here -->
                    <div v-html="displayElement?.content"></div>
                  </div>
                </div>

                <!-- Recent Photos: one aggregate item owns the artboard's whole
                     gallery and cycles it internally, rather than each photo
                     taking a turn in the outer element rotation. Speed and
                     direction come from the organization, so the Recent Photos
                     settings modal drives what a screen plays. -->
                <div
                  v-if="displayElement && displayElement._isRecentPhotoCarousel"
                  class="display-item recent-photo-display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <RecentPhotoCarousel
                    :photos="displayElement.photos"
                    :speed="recentPhotoCarouselSettings.speed"
                    :direction="recentPhotoCarouselSettings.direction"
                    :mode="recentPhotoCarouselSettings.mode"
                    :visible-count="recentPhotoCarouselSettings.visibleCount"
                    :spacing="recentPhotoCarouselSettings.spacing"
                  />
                </div>

                <!-- Modern Yurtzeiten: one aggregate item owns every approved
                     record at the organization's central destination. The shared renderer uses
                     the exact saved template/settings as the Design preview;
                     keeping it inside the generic track gives it the same
                     no-scroll, vertical and horizontal behavior as every other
                     artboard feature.

                     The item holds ONE screenful — the page the board's own
                     rotation timer currently has due — and the page is keyed by
                     its index INSIDE the item rather than on it, so a rotation
                     swaps the page while the item itself stays put: the swipe
                     below is between two pages of one board, not the board
                     fading out and back in. The item keeps the artboard's own
                     fade for when the carousel hands the surface over to
                     another feature entirely. -->
                <div
                  v-if="displayElement && displayElement._isYurtzeitenN"
                  class="display-item yurtzeiten-n-display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  :style="getYurtzeitenDisplayItemStyle(artboard)"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <Transition
                    :name="getYurtzeitenPageTransitionName(artboard)"
                    @before-leave="holdYurtzeitenPageBox"
                    @after-leave="releaseYurtzeitenPageBox"
                    @after-enter="releaseYurtzeitenPageBox"
                  >
                    <div
                      :key="`yurtzeiten-page-${displayElement.pageIndex}`"
                      class="yurtzeiten-n-page"
                      :style="{ '--yz-page-swipe-duration': yurtzeitenPageSwipeDuration }"
                    >
                      <YurtzeitenDisplayRender
                        :records="displayElement.records"
                        :design="displayElement.design"
                        :horizontal="getArtboardScrollDirection(artboard) === 'horizontal'"
                        :vertical-scrolling="getArtboardScrollDirection(artboard) === 'vertical' && Boolean(isOverflowing[artboard.id])"
                        :viewport-width="getYurtzeitenDisplayViewportWidth(artboard)"
                        :viewport-height="getYurtzeitenDisplayViewportHeight(artboard)"
                        :scroll-speed="effectiveDefaultScrollSpeed"
                      />
                    </div>
                  </Transition>
                </div>

                <!-- Weekly Schedule board: one schedule's day (or week)
                     timetable, the live Now & Next guide and the day notes,
                     drawn with that schedule's own design and settings by the
                     same renderer the admin page previews with. An artboard
                     with several schedules shows them in turn. -->
                <div
                  v-if="displayElement && displayElement._isWeeklySchedule"
                  class="display-item weekly-schedule-display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <WeeklyScheduleRender
                    :columns="getWeeklyScheduleColumns(displayElement)"
                    :design="displayElement.design"
                    :header-preset="displayElement.settings.headerPreset"
                    :layout="displayElement.design.layout"
                    :show-now-next="displayElement.settings.showNowNext"
                    :show-countdown="displayElement.settings.showCountdown"
                    :now-minutes="weeklyScheduleNowMinutes"
                    :horizontal="getArtboardScrollDirection(artboard) === 'horizontal'"
                  />
                </div>

                <!-- Event: a quick event (or any event) drawn through the Event
                     Template it is linked to. Same substitution model as a
                     donation — the template owns the layout, the event owns the
                     values — and the same `ql-editor` wrapper so authored
                     alignment and lists render the way they were written. An
                     event with no template never reaches here: it is filtered
                     out of the rotation, so it can't hold the artboard on an
                     empty slot. -->
                <div
                  v-if="displayElement && displayElement.eventTemplate && artboard.features.includes('Event')"
                  class="ql-editor display-item event-template-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <div v-html="renderEventContent(displayElement.eventTemplate.content, displayElement)"></div>
                </div>

                <!-- Zmanim -->
                <div
                  v-if="artboard.features.includes('Zmanim') && displayElement.type == 'Zmanim'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Yurtzeiten UI here -->
                  <div v-if="true">
                    <!-- Add your yurtzeiten UI here -->
                    <div style="margin-bottom: 30px">
                        <h6 v-if="displayElement?.zmanimList?.length" class="text-center" style="font-size: 0.9rem; font-weight: 600"
                          :style="{ 
                            fontFamily: getLegacyFontFamily(artboard?.zmanimFont),
                            fontSize: artboard?.zmanimFontSize ? artboard.zmanimFontSize + 'px' : undefined,
                            color: artboard?.zmanimColor ? artboard.zmanimColor : '#000000'
                          }">
                        </h6>
                        <div v-if="displayElement?.zmanimList?.length" class="minyanim-preview-list" dir="rtl">
                          <div
                            v-for="(zmanim, index2) in displayElement?.zmanimList"
                            :key="index2"
                          >
                            <div 
                              class="minyanim-preview-row"
                              :class="{ 'text-danger': artboard?.defaultZmanimLabelDelay ? getNearestFutureZmanimIndex(displayElement?.zmanimList)?.includes(index2) : nearestFutureZmanimIndexes[displayElement.id || index2] == index2 }"
                              :style="{ 
                                fontFamily: getLegacyFontFamily(artboard?.zmanimFont),
                                fontSize: artboard?.zmanimFontSize ? artboard.zmanimFontSize + 'px' : undefined,
                                color: artboard?.zmanimColor ? artboard.zmanimColor : '#000000'
                              }">
                              <span class="minyanim-room">{{ ZMANIM_YIDDISH_MAPPING[zmanim.name] }}</span>
                              <span 
                                class="minyanim-dots"
                                :style="{
                                  color: artboard?.zmanimColor ? artboard.zmanimColor : '#000000'
                                }"
                              ></span>
                              <span class="minyanim-time">{{ getZmanimTime(zmanim.name) }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- <h6 v-else class="text-center" style="font-size: 0.7rem">No Scheduled Minyanim</h6> -->
                      </div>
                  </div>
                </div>

                <!-- Minyanim -->
                <div
                  v-if="artboard.features.includes('Minyunim') && (displayElement.type == 'Minyanim' || displayElement.type == 'MinyanimType' || displayElement.type == 'MinyanimRoom')"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Minyanim UI here -->
                  <div v-if="true">
                    <!-- Add your minyanim UI here -->
                    <!-- <template v-for="(minyanimType, index1) in displayElement" :key="index1"> -->
                      <div style="margin-bottom: 30px">
                        <h6 v-if="displayElement?.minyanimRooms?.length && this.organization.displayMinyanimHeader" class="text-center" style="font-size: 0.9rem; font-weight: 600"
                          :style="{ 
                            fontFamily: getLegacyFontFamily(artboard?.minyanimFont),
                            fontSize: artboard?.minyanimFontSize ? artboard.minyanimFontSize + 'px' : undefined,
                            color: artboard?.minyanimColor ? artboard.minyanimColor : '#000000'
                          }">
                          {{ displayElement.name }}
                        </h6>
                        <div v-if="displayElement?.minyanimRooms?.length" class="minyanim-preview-list" dir="rtl">
                          <div
                            v-for="(minyanimRoom, index2) in getSortedMinyanimRooms(displayElement?.minyanimRooms)"
                            :key="index2"
                          >
                            <div 
                              v-if="minyanimRoom.minyanim.dayOfTheWeek == today"
                              class="minyanim-preview-row"
                              :class="{ 'text-danger': getNearestFutureRoomIndex(getSortedMinyanimRooms(displayElement?.minyanimRooms))?.includes(index2) }"
                              :style="{ 
                                fontFamily: getLegacyFontFamily(artboard?.minyanimFont),
                                fontSize: artboard?.minyanimFontSize ? artboard.minyanimFontSize + 'px' : undefined,
                                color: artboard?.minyanimColor ? artboard.minyanimColor : '#000000'
                              }"
                            >
                              <span class="minyanim-room">{{ minyanimRoom.room?.name }}</span>
                              <span 
                                class="minyanim-dots"
                                :style="{
                                  color: artboard?.minyanimColor ? artboard.minyanimColor : '#000000'
                                }"
                              ></span>
                              <span v-if="minyanimRoom.useZmanim" class="minyanim-time">{{ formatZmanClock(zmanims?.[minyanimRoom.zmanimName]) || '-' }}</span>
                              <span v-else class="minyanim-time">{{ formatZmanClock(minyanimRoom.time) || '-' }}</span>
                            </div>
                          </div>
                        </div>
                        <!-- <h6 v-else class="text-center" style="font-size: 0.7rem">No Scheduled Minyanim</h6> -->
                      </div>
                    <!-- </template> -->
                  </div>
                </div>

                <!-- Minyanim Roll -->
                <div
                  v-if="artboard.features.includes('MinyanRoll') && displayElement && displayElement._isMinyanRoll"
                  class="ql-editor display-item roll-display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <div class="roll-container" :style="getRollContainerStyle(displayElement.design || {})">
                    <!-- Optional roll title -->
                    <div
                      v-if="(displayElement.design || {}).showTitle"
                      class="roll-title"
                      :style="getRollTitleStyle(displayElement.design || {})"
                    >{{ displayElement.name }}</div>

                    <div v-if="(displayElement.minyanim || []).length">
                      <template
                        v-for="(group, gIdx) in getRollGroups(displayElement, artboard)"
                        :key="group.key || gIdx"
                      >
                        <!-- Group header (header grouping) -->
                        <div
                          v-if="group.label"
                          class="roll-group-header"
                          :style="getRollHeaderStyle(displayElement.design || {})"
                        >{{ group.label }}</div>

                        <!-- Items, split into sections by any Text-type minyan. A
                             Text minyan renders as a full-width header that splits
                             the surrounding minyanim; the others continue below it
                             — identically in card and list view. -->
                        <template v-for="seg in getRollItemSegments(group.items)" :key="seg.key">
                          <!-- Text-type minyan → full-width header (splits minyanim). -->
                          <div v-if="seg.type === 'text'" class="roll-text-header" dir="rtl">
                            <div class="roll-text-header__body" v-html="getRollTextHtml(seg.item, displayElement.design || {})"></div>
                          </div>

                          <!-- Card view -->
                          <div
                            v-else-if="getRollViewMode(displayElement.design || {}) === 'card'"
                            class="roll-cards"
                            dir="rtl"
                            :style="getRollCardsContainerStyle(displayElement.design || {})"
                          >
                            <template v-for="(item, idx) in seg.items" :key="item.id || idx">
                            <div
                              class="roll-card"
                              :style="getRollCardStyle(displayElement.design || {}, item, idx, seg.items.length)"
                            >
                              <!-- Grid-designer template card -->
                              <!-- dir="ltr" keeps the cells in the same left-to-right
                                   column order as the grid designer; the surrounding
                                   card container is dir="rtl" (for card ordering),
                                   which would otherwise mirror the grid. Each cell's
                                   own <p dir="rtl"> still aligns Hebrew within it. -->
                              <div
                                v-if="rollHasGrid(displayElement.design || {})"
                                class="roll-grid"
                                dir="ltr"
                                :style="getRollGridContainerStyle(displayElement.design || {})"
                              >
                                <div
                                  v-for="(cell, cIdx) in getRollGridCells(displayElement.design || {})"
                                  :key="cIdx"
                                  class="roll-grid-cell"
                                  :style="getRollGridCellStyle(displayElement.design || {}, cIdx)"
                                  v-html="renderRollCellHtml(cell, item, displayElement.design || {})"
                                ></div>
                              </div>
                              <!-- Simple card fallback -->
                              <template v-else>
                                <span class="roll-card-minyan">{{ getRollFieldValue(item, 'minyan', displayElement.design || {}) }}</span>
                                <span
                                  v-if="getRollFieldValue(item, 'room', displayElement.design || {})"
                                  class="roll-card-room"
                                >{{ getRollFieldValue(item, 'room', displayElement.design || {}) }}</span>
                                <span class="roll-card-time minyanim-time">
                                  <span class="minyanim-time-primary">{{ formatRollTime(item) }}</span>
                                  <span
                                    v-for="sec in getRollSecondaryTimes(item)"
                                    :key="sec.key"
                                    class="minyanim-secondary-time"
                                  >{{ sec.label }} · {{ sec.time }}</span>
                                </span>
                                <span
                                  v-if="getRollCountdown(item, displayElement.design || {})"
                                  class="roll-card-countdown"
                                  :style="getRollCountdownStyle(displayElement.design || {})"
                                >{{ getRollCountdown(item, displayElement.design || {}) }}</span>
                              </template>
                            </div>
                            </template>
                          </div>

                          <!-- List view -->
                          <div
                            v-else
                            class="minyanim-preview-list roll-list"
                            dir="rtl"
                            :style="getRollListStyle(displayElement.design || {})"
                          >
                            <template v-for="(item, idx) in seg.items" :key="item.id || idx">
                            <div>
                              <div
                                class="minyanim-preview-row"
                                :style="getRollRowStyle(displayElement.design || {}, item, idx, seg.items.length)"
                              >
                                <!-- Right field -->
                                <span
                                  v-if="getRollRightField(displayElement.design || {})"
                                  class="roll-side"
                                  :class="getRollRightField(displayElement.design || {}) === 'time' ? 'minyanim-time' : 'minyanim-room'"
                                  :style="getRollSideStyle(displayElement.design || {}, getRollRightField(displayElement.design || {}))"
                                >
                                  <template v-if="getRollRightField(displayElement.design || {}) === 'time'">
                                    <span class="minyanim-time-primary">{{ formatRollTime(item) }}</span>
                                  </template>
                                  <template v-else-if="getRollRightField(displayElement.design || {}) === 'countdown'"><span v-if="getRollCountdown(item, displayElement.design || {})" :style="getRollCountdownStyle(displayElement.design || {})">{{ getRollCountdown(item, displayElement.design || {}) }}</span></template>
                                  <template v-else>{{ getRollFieldValue(item, getRollRightField(displayElement.design || {}), displayElement.design || {}) }}</template>
                                </span>

                                <!-- Time / Name divider -->
                                <span class="roll-divider" :class="getRollDividerClass(displayElement.design || {})"></span>

                                <!-- Left field -->
                                <span
                                  v-if="getRollLeftField(displayElement.design || {})"
                                  class="roll-side"
                                  :class="getRollLeftField(displayElement.design || {}) === 'time' ? 'minyanim-time' : 'minyanim-room'"
                                  :style="getRollSideStyle(displayElement.design || {}, getRollLeftField(displayElement.design || {}))"
                                >
                                  <template v-if="getRollLeftField(displayElement.design || {}) === 'time'">
                                    <span class="minyanim-time-primary">{{ formatRollTime(item) }}</span>
                                  </template>
                                  <template v-else-if="getRollLeftField(displayElement.design || {}) === 'countdown'"><span v-if="getRollCountdown(item, displayElement.design || {})" :style="getRollCountdownStyle(displayElement.design || {})">{{ getRollCountdown(item, displayElement.design || {}) }}</span></template>
                                  <template v-else>{{ getRollFieldValue(item, getRollLeftField(displayElement.design || {}), displayElement.design || {}) }}</template>
                                </span>
                              </div>

                              <!-- "Underline" fields: up to 3, shown side by side
                                   (centered) below the row, matching the row text. -->
                              <div
                                v-if="getRollUnderlineValues(item, displayElement.design || {}).length"
                                class="roll-underline"
                                :style="getRollUnderlineStyle(displayElement.design || {})"
                              >
                                <span
                                  v-for="(val, uIdx) in getRollUnderlineValues(item, displayElement.design || {})"
                                  :key="uIdx"
                                  class="roll-underline-value"
                                >{{ val }}</span>
                              </div>
                            </div>
                            </template>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>

                <!-- Upcoming Minyan -->
                <div
                  v-if="hasFeature(artboard, 'UpcomingMinyanim', 'UpcomingMinyan') && displayElement && displayElement._isUpcomingMinyan"
                  class="ql-editor display-item upcoming-minyan-display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <UpcomingMinyanRender :content="getUpcomingMinyanContent(displayElement)" />
                </div>

                <!-- DateTimeBanner -->
                <div
                  v-if="artboard.features.includes('DateTimeBanner') && displayElement.type == 'DateTimeBanner'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Donation UI here -->
                  <div v-if="true">
                    <!-- Add your donation UI here -->
                    <div v-html="renderDateTimeBanner(displayElement.content)"></div>
                  </div>
                </div>

                <!-- Poster -->
                <div
                  v-if="artboard.features.includes('Poster') && displayElement.type == 'Poster'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Poster UI here -->
                  <div v-if="true">
                    <!-- Add your donation UI here -->
                    <div class="ql-editor" style="overflow-x: hidden; padding: 0px">
                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <div style="width: 100%; display: flex; justify-content: center; margin-bottom: 10px">
                          <img :src="getPosterImage(displayElement.image)" style="padding-left: 0px; padding-right: 0px; max-width: 100%;" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Minyanim Countdown -->
                <div
                  v-if="artboard.features.includes('MinyunimCountdown') && displayElement.type == 'MinyanimCountdown'"
                  class="ql-editor display-item"
                  :class="{ fadeIn: displayItemIndexes[artboard.id] === index, fadeOut: displayItemIndexes[artboard.id] !== index }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <!-- Minyanim Countdown here -->
                  <div v-if="true">
                    <!-- Add your donation UI here -->
                    <div class="ql-editor" style="overflow-x: hidden; padding: 0px">
                      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <div style="width: 100%; display: flex; justify-content: center; margin-bottom: 10px">
                          <div v-html="renderMinyanimCountdownContent(displayElement)" ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Zmanim_N -->
                <div
                  v-if="artboard.features.includes('Zmanim_N') && displayElement.type == 'Zmanim_N'"
                  class="ql-editor display-item zmanim-n-display-item"
                  :class="{
                    fadeIn: displayItemIndexes[artboard.id] === index,
                    fadeOut: displayItemIndexes[artboard.id] !== index,
                    'zmanim-n-display-item--horizontal-ticker': isZmanimNHorizontalList(displayElement),
                  }"
                  v-show="displayItemIndexes[artboard.id] === index"
                >
                  <div v-if="true">
                    <div class="ql-editor" style="overflow: visible; padding: 0px">
                      <div
                        class="zmanim-n-display"
                        :class="getZmanimNDisplayClasses(displayElement, artboard)"
                        :style="getZmanimNDisplayStyle(displayElement, artboard)"
                        dir="rtl"
                      >
                        <template v-if="isZmanimNHorizontalList(displayElement)">
                          <div
                            v-for="copyIndex in getZmanimNTickerCopies(displayElement, artboard)"
                            :key="`ticker-copy-${copyIndex}`"
                            class="zmanim-n-ticker-track"
                          >
                            <span
                              v-for="(item, index2) in getZmanimNItems(displayElement)"
                              :key="`${copyIndex}-${item.key}`"
                              class="zmanim-n-ticker-item"
                              :class="getZmanimNRowClasses(displayElement, index2, getZmanimNItems(displayElement))"
                              :style="getZmanimNRowStyle(displayElement, index2, getZmanimNItems(displayElement))"
                            >
                              <span class="zmanim-n-ticker-content">
                                <span
                                  class="zmanim-n-label"
                                  :style="getZmanimNLabelStyle(displayElement, artboard, index2, getZmanimNItems(displayElement))"
                                >
                                  {{ item.label }}
                                </span>
                                <span
                                  class="zmanim-n-time-label-divider"
                                  :class="`zmanim-n-time-label-divider--${getZmanimNHorizontalDividerLine(displayElement)}`"
                                  :style="getZmanimNLabelStyle(displayElement, artboard, index2, getZmanimNItems(displayElement))"
                                ></span>
                                <span
                                  class="zmanim-n-time"
                                  :style="getZmanimNTimeStyle(displayElement, artboard, index2, getZmanimNItems(displayElement))"
                                >
                                  {{ item.time }}
                                </span>
                              </span>
                              <span
                                class="zmanim-n-divider-symbol"
                                :style="getZmanimNLabelStyle(displayElement, artboard, index2, getZmanimNItems(displayElement))"
                              >
                                {{ getZmanimNDividerSymbol(displayElement) }}
                              </span>
                            </span>
                          </div>
                        </template>
                        <template v-else-if="isZmanimNVerticalList(displayElement)">
                          <div
                            v-for="column in getZmanimNVerticalListColumns(displayElement)"
                            :key="column.key"
                            class="zmanim-n-list-column"
                          >
                            <div
                              v-for="item in column.items"
                              :key="item.key"
                              class="zmanim-n-row"
                              :class="getZmanimNRowClasses(displayElement, item.sourceIndex, column.sourceItems)"
                              :style="getZmanimNRowStyle(displayElement, item.sourceIndex, column.sourceItems)"
                            >
                              <span
                                class="zmanim-n-label"
                                :style="getZmanimNLabelStyle(displayElement, null, item.sourceIndex, column.sourceItems)"
                              >
                                {{ item.label }}
                              </span>
                              <span
                                class="zmanim-n-time-label-divider"
                                :class="`zmanim-n-time-label-divider--${getZmanimNHorizontalDividerLine(displayElement)}`"
                                :style="getZmanimNLabelStyle(displayElement, null, item.sourceIndex, column.sourceItems)"
                              ></span>
                              <span
                                class="zmanim-n-time"
                                :style="getZmanimNTimeStyle(displayElement, null, item.sourceIndex, column.sourceItems)"
                              >
                                {{ item.time }}
                              </span>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-for="(item, index2) in getZmanimNItems(displayElement)"
                            :key="item.key"
                            class="zmanim-n-row"
                            :class="getZmanimNRowClasses(displayElement, index2, getZmanimNItems(displayElement))"
                            :style="getZmanimNRowStyle(displayElement, index2, getZmanimNItems(displayElement))"
                          >
                            <!-- Grid-designer card: dir="ltr" keeps the cells in the
                                 same left-to-right order as the Grid Designer. -->
                            <div
                              v-if="isZmanimNGridActive(displayElement)"
                              class="zmanim-n-grid"
                              dir="ltr"
                              :style="getZmanimGridContainerStyle((displayElement.design || {}).grid)"
                            >
                              <div
                                v-for="(cell, cIdx) in getZmanimGridCells((displayElement.design || {}).grid)"
                                :key="cIdx"
                                class="zmanim-n-grid-cell"
                                :style="getZmanimGridCellStyle((displayElement.design || {}).grid, cIdx)"
                                v-html="renderZmanimGridCell(cell, item, index2, displayElement)"
                              ></div>
                            </div>
                            <template v-else>
                              <span
                                class="zmanim-n-label"
                                :style="getZmanimNLabelStyle(displayElement, null, index2, getZmanimNItems(displayElement))"
                              >
                                {{ item.label }}
                              </span>
                              <span
                                class="zmanim-n-time"
                                :style="getZmanimNTimeStyle(displayElement, null, index2, getZmanimNItems(displayElement))"
                              >
                                {{ item.time }}
                              </span>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import io from 'socket.io-client';

import addTemplateModal from '@/components/template/Add_Template_Modal.vue';
import addDonationModal from '@/components/donation/Add_Donation_Modal.vue';
import UpcomingMinyanRender from '@/components/minyanim_rolls_N/Upcoming_Minyan_Render.vue';
import YurtzeitenDisplayRender from '@/components/yurtzeiten_N/Yurtzeiten_Display_Render.vue';
import { getYurtzeitenCardCapacity_N } from '@/utils/yurtzeiten_design_render';
import {
  buildYurtzeitenDisplayPages_N,
  dedupeYurtzeitenDisplayRecords_N,
  resolveYurtzeitenDesign_N,
  resolveYurtzeitenDisplayColumns_N,
  resolveYurtzeitenDisplayRows_N,
} from '@/utils/yurtzeiten_design_templates';
import RecentPhotoCarousel from '@/components/recent_photo/Recent_Photo_Carousel.vue';
import { readRecentPhotoCarouselSettings } from '@/utils/recent_photo_carousel';
import Yurtzeiten_N from '@/services/yurtzeiten_N';
import WeeklyScheduleRender from '@/components/weekly_schedule_N/Weekly_Schedule_Render_N.vue';
import WeeklySchedule_N from '@/services/weekly_schedule_N';
import {
  WEEKLY_SCHEDULE_FEATURE_N,
  buildScheduleWeek,
  createScheduleZmanResolver,
  filterOccurrencesForDisplay,
  itemsInSeason,
  minutesOfDayInTimeZone,
  normalizeWeeklyScheduleDesign,
  normalizeWeeklyScheduleSettings,
  resolveDayOccurrences,
  todayIsoInTimeZone,
} from '@/utils/weekly_schedule_N';
import { API_URL, ADVANCED_ZMANIM_YIDDISH_MAPPING, BANNER_EREV_SHABBOS_LABEL, BANNER_MOTZEI_SHABBOS_LABEL, BANNER_SHABBOS_LABEL, BANNER_WEEKDAY_NAMES, DAYS_OF_THE_WEEK, PARSHA_NAMES, REFRESH_SCREEN_SOCKET_EVENT, POSTER_IMAGES_DIR, RECENT_PHOTO_IMAGES_DIR, SCREEN_IMAGES_DIR, STORAGE_URL, TOAST_GLOBAL_CONFIG, EVENT_IMAGES_DIR, YURTZEITEN_IMAGES_DIR, ZMANIM_ENGLISH_OFFSETS, ZMANIM_YIDDISH_MAPPING } from '@/utils/const';
import { ZmanimDisplayOverrideRoundTo } from '@/utils/enums';
import { normalizeAutomatedOffsetMinutes, normalizeAutomatedZmanKey } from '@/utils/automated_rule_zmanim';
import {
  MOTZEI_SHABBOS_LONDON_KEY,
  resolveMotzeiShabbosLondonFrom,
} from '@/utils/motzei_shabbos_london';
import {
  buildRollContext,
  getActiveRolls,
  isRollActiveNow,
  buildSlotWinners,
  compareRollDayMinutes,
  getVisibleMinyanim,
  resolveRollDisplay,
  MINYAN_DISPLAY_TOGGLES,
  NETZ_ZMAN_KEY,
  ROLL_FIELD_TOKEN_REGEX,
  ROLL_FIELD_TOKEN_REGEX_GLOBAL,
  resolveMinyanSecondaryTimes,
  formatClockFromMinutes,
  formatRollCountdown,
  normalizeRollCountdownTarget,
  resolveRollCountdownTargetMinutes,
  generateRollAutomatedMinyanim,
  getMinyanRoundToMinutes,
  getMinyanRoundDirection,
  getMinyanWeeklyZmanMode,
  getWeeklyZmanWeekDates,
  isMinyanActive,
  isWeeklyZmanTimingMode,
  resolveWeeklyZmanMinutes,
  roundMinutesToGridDirectional,
} from '@/utils/minyanRollEngine';
import {
  zmanimGridHasContent,
  getZmanimGridCells,
  getZmanimGridContainerStyle,
  getZmanimGridCellStyle,
  getZmanimCountdownCss,
  getZmanimCountdownString,
  getZmanimHighlightAccentColor,
  getZmanimHighlightStyle,
  getZmanimHighlightTextColor,
  getNearestFutureZmanIndex,
  isZmanimHighlightActive,
  normalizeZmanimCountdownDesign,
  normalizeZmanimHighlightDesign,
  renderZmanimGridCellHtml,
} from '@/utils/zmanimNGrid';
import { toWallClockDate } from '@/utils/wall_clock_date';
import { renderDonationTemplate } from '@/utils/donation_template';
import {
  SPECIAL_ZMAN_CANDLE_KEY,
  SPECIAL_ZMAN_MOTZEI_KEY,
  isSpecialZmanKey,
  resolveSpecialZmanIsoFromOverrides,
} from '@/utils/special_zmanim';
import { getLegacyArtboardFontFamily } from '@/utils/text_editor_options';
import { isSafeFontFamily } from '@/utils/custom_fonts';
import { markAuthoredBlankLinesHtml } from '@/utils/authored_blank_lines';
import {
  getAnnouncementDisplayDurationMs as resolveAnnouncementDisplayDurationMs,
  getDonationDisplayDurationMs as resolveDonationDisplayDurationMs,
  getEventDisplayDurationMs as resolveEventDisplayDurationMs,
  getYurtzeitenDisplayDurationMs as resolveYurtzeitenDisplayDurationMs,
} from '@/utils/display_duration';
import {
  filterYurtzeitenByDisplayWindow,
  normalizeYurtzeitenCarouselDirection,
} from '@/utils/yurtzeiten_display_window';
import {
  getPreviewInstant,
  getPreviewOpeningInstant,
  getPreviewRange,
  getZonedDateTimeParts,
  parseDateValue,
  toLocalNoon,
} from '@/utils/display_preview';
import { GET_CUSTOM_FONTS, GET_ORGANIZATION, GET_SCREEN, GET_ZMANIM_DISPLAY_OVERRIDES_N } from '@/store/action_types';
import { SCREEN_REQUEST_STALE } from '@/store/modules/screen';

import '@vueup/vue-quill/dist/vue-quill.core.css'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const OPENCAGE_API_KEY = '90c0651192b34be4bc936b853387edbf';
const ALL_ZMANIM_YIDDISH_MAPPING = {
  ...ZMANIM_YIDDISH_MAPPING,
  ...ADVANCED_ZMANIM_YIDDISH_MAPPING,
};

// Minyanim-Roll grid-designer layouts. Mirrors GRID_LAYOUTS in
// Minyanim_Roll_Grid_Designer.vue so the live display lays each card's cells
// out exactly as they were arranged in the editor.
const ROLL_GRID_LAYOUTS = {
  'grid-2': { cells: 2, container: { gridTemplateColumns: '1fr' }, cellStyles: {} },
  'grid-3': { cells: 3, container: { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }, cellStyles: {} },
  'grid-4': { cells: 4, container: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }, cellStyles: {} },
  'grid-5': {
    cells: 5,
    container: { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
    cellStyles: { 0: { gridColumn: '1 / -1' }, 4: { gridColumn: '1 / -1' } },
  },
  'grid-6': { cells: 6, container: { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }, cellStyles: {} },
};

// --- Shabbos Schedule Engine (Weekly Static Lock) ---
// Dynamic zmanim on a Shabbos-type roll are calculated against the upcoming
// weekend's anchor dates (Friday = Sunday + 5, Shabbos/Motzei = Sunday + 6)
// rather than today's date, so candle-lighting / motzei times are locked on
// Sunday and shown unchanged for the whole week.
const SHABBOS_CANDLE_OFFSET_MINUTES = 18; // candle lighting = sunset − 18m
const SHABBOS_MOTZEI_OFFSET_MINUTES = 72; // fallback motzei = sunset + 72m

// The roll `{token}` keys that resolve to a minyan's secondary display time
// (one per display toggle: bruches / hoidy / ashrei / borchy / netz).
const ROLL_SECONDARY_TIME_FIELDS = new Set(MINYAN_DISPLAY_TOGGLES.map((def) => def.key));

// Fixed design-baseline width (CSS px) that artboard content was authored
// against. The vertical / noscroll content is scaled by
// currentDisplayWidth / DESIGN_BASE_WIDTH so it keeps the SAME proportion of
// the artboard on every screen resolution (image-like scaling): identical to
// the authored look at this width, proportionally larger/smaller elsewhere.
// Tune this single value if the layout was designed at a different width.
const DESIGN_BASE_WIDTH = 1920;

// Floor between two background refetches of the yahrzeit board. The board asks
// for one every time it rotates a page, and "Time on screen" can be as short as
// a second — this is what keeps that from becoming a request per second while
// still picking up a newly approved record within about a minute.
const YURTZEITEN_PAGE_REFRESH_MIN_INTERVAL_MS = 60 * 1000;

// How long one page of yahrzeits takes to give way to the next, and the floor
// under that for a board paced faster than the sweep. Long enough to read as
// the row travelling rather than as a cut, short enough to be over well inside
// the shortest dwell the settings modal allows.
const YURTZEITEN_PAGE_SWIPE_MS = 700;
const YURTZEITEN_PAGE_SWIPE_MIN_MS = 240;

export default {
  name: 'Screen Display',
  emits: ['screen-refresh'],
  components: {
    addTemplateModal,
    addDonationModal,
    UpcomingMinyanRender,
    YurtzeitenDisplayRender,
    WeeklyScheduleRender,
    RecentPhotoCarousel,
  },
  props: {
    screenOverride: {
      type: Object,
      default: null,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    // The screen to show when it is not the one in the URL — set by a screen
    // schedule link (Screen_Schedule_Display.vue), which switches this one
    // display between screens in place. Unset, /display/:id decides.
    screenId: {
      type: String,
      default: null,
    },
    // Dashboard date preview ("YYYY-MM-DD"): the display runs on that date at
    // the current time of day on the screen's own clock, so everything read off
    // the clock shows what this screen will on that date. The Dashboard fetches
    // the screen for the same moment (`filterDate`). Unset, the real clock.
    previewDate: {
      type: String,
      default: null,
    },
    // A time range on the previewed date ("HH:mm", "24:00" being the next
    // midnight; either end may be empty): the Dashboard fetched everything on
    // air across it. The display keeps the current time of day while that falls
    // inside the range, and otherwise runs from the range's start.
    previewStartTime: {
      type: String,
      default: '',
    },
    previewEndTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ZMANIM_YIDDISH_MAPPING,
      REFRESH_SCREEN_SOCKET_EVENT,
      imageWidth: 1,
      imageHeight: 1,
      imageNaturalWidth: 1920, // Original design width for scale calculation
      imageNaturalHeight: 1080,
      imageReady: false,
      embeddedFitWidth: 0,
      embeddedFitHeight: 0,
      // Letterbox offset (px) of the object-fit:contain background image within
      // the embedded (dashboard) card, so the absolutely-positioned artboard
      // overlay lines up with the centered image. Stays 0 for the full-screen
      // (non-embedded) display, where the image is not letterboxed.
      embeddedOffsetX: 0,
      embeddedOffsetY: 0,
      embeddedResizeObserver: null,
      embeddedResizeObserverTarget: null,
      showAddTemplateModal: false,
      showAddDonationModal: false,
      selectedArtboard: null,
      isFullScreen: false,
      isNavbarVisible: false,
      isBackgroundLoading: true,
      // While true, a getScreen() refresh runs silently: the current screen stays
      // on-screen and its content is swapped in place (no "Loading Screen..."
      // overlay), mirroring the Dashboard's selected-screen background refresh.
      isSilentRefreshing: false,
      // A switch whose fetch failed is retried on a backoff until the screen
      // asked for is the one on air (see loadRequestedScreen).
      screenSwitchRetryTimer: null,
      screenSwitchRetryDelay: 0,
      displayItemIndex: -1, // Start before the first item
      isOverflowing: {}, // { [artboardId]: true/false } — vertical
      // The same judgement across instead of down. Kept apart from the vertical
      // flag because a horizontal artboard is measured against its own width.
      isOverflowingHorizontally: {}, // { [artboardId]: true/false }
      noScrollFitScales: {}, // { [artboardId]: number 0<scale<=1 — shrink-to-fit scale for noscroll artboards }
      zmanimNHorizontalFitScales: {}, // { [artboardId]: number 0<scale<=1 } for static horizontal Zmanim_N rows
      displayItemIndexes: {}, // { [artboardId]: number }
      artboardTimers: {},
      parshaName: '',
      currentTime: new Date(),
      today: null,
      zmanims: null,
      kosherZmanimLookup: {},
      // Per-week Shabbos anchor zmanim maps (Friday / Saturday). Rebuilt only
      // when the week changes — see ensureShabbosAnchorZmanim().
      fridayAnchorZmanim: null,
      shabbosAnchorZmanim: null,
      jewishCalendarConstructor: null,
      deviceSunrise: null,
      geoLocationName: '',
      geoLocationCoords: null,
      geoLocationTimezone: '',
      zmanimsArray: [],
      nearestFutureZmanimIndexes: {},
      zmanimDisplayOverrides: [],
      lastDonationActivityShabbosState: null,
      // Which artboards are down to their fallback items (see
      // handleFallbackItemClockTick), so emptying out restarts carousels.
      lastFallbackItemKey: null,
      overflowObservers: {}, // { [artboardId]: ResizeObserver }
      intervalIds: [],
      socket: null,
      // --- Generic auto-scroll tuning (every feature EXCEPT Zmanim_N) ---------
      // Default scroll speed in content pixels per second. Higher = faster.
      // Zmanim_N is unaffected — it keeps its own rotationSpeed setting.
      // Tweak this single variable to change the scroll speed everywhere else.
      defaultScrollSpeed: 25,
      // Floor (seconds) for one scroll loop so a barely-overflowing artboard
      // never whips past too fast to read.
      minScrollDuration: 24,
      // Measured single-copy track size per artboard, used to derive a
      // constant-speed animation duration: { [artboardId]: { height, width } }.
      scrollTrackSizes: {},
      // Modern Yurtzeiten are loaded independently because the populated
      // screen endpoint does not include the Yurtzeiten_N/design relations.
      // The organization owns one central screen/artboard destination; every
      // eligible record is rendered there as a single aggregate display item.
      yurtzeitenDisplayRecords: [],
      // The Weekly Schedule boards on this screen (one per schedule on each
      // artboard), read from the public endpoint like the yahrzeit board
      // above. The zmanim resolver and the per-minute column cache are kept
      // off the reactive graph on purpose — see loadWeeklyScheduleDisplay.
      weeklySchedulePayload: null,
      weeklyScheduleRequestId: 0,
      weeklyScheduleVersion: 0,
      // Today, as a plain `YYYY-M-D` key. The yahrzeit display window is
      // measured in whole days, so it can only change at midnight — held on its
      // own rather than read off `currentTime` so the filter it drives is not
      // recomputed once a second for an answer that cannot have moved.
      yurtzeitenDisplayDayKey: '',
      yurtzeitenDisplayDesign: null,
      yurtzeitenDisplayContextKey: '',
      yurtzeitenDisplayRequestId: 0,
      // Which screenful of yahrzeits is on the board right now, and the timer
      // that moves it on. Both live here rather than inside the artboard
      // carousel: that carousel is restarted from index 0 by every screen
      // refresh (the 30-minute poll, a socket push, the Dashboard re-selecting
      // this screen), and a board whose rows were carousel elements therefore
      // fell back to the first row each time and never reached the later ones.
      yurtzeitenPageIndex: 0,
      // Whether the page index standing in `yurtzeitenPageIndex` got there by
      // the rotation timer advancing the row — the one change a viewer should
      // see travel. Every other way the index moves is the board being re-set
      // rather than turned over: coming back on screen at the first page, or a
      // refetch clamping it to a shorter list. Sliding those would show a page
      // the viewer has no reason to be shown leaving, so they swap in place.
      yurtzeitenPageSwipes: false,
      yurtzeitenPageTimer: null,
      // Guards for the background refetch each rotation asks for, so a short
      // "time on screen" can never turn the board into a request loop.
      yurtzeitenPageRefreshAt: 0,
      yurtzeitenPageRefreshInFlight: false,
    }
  },
  watch: {
    // A schedule link handed over another screen (or the URL changed): load it
    // silently, so the screen on air stays up until the next one has landed.
    displayScreenId(newId, oldId) {
      if (this.screenOverride || !newId || newId === oldId) return;
      this.loadRequestedScreen();
    },
    screen: {
      immediate: true,
      handler(newVal, oldVal) {
        const screenChanged = oldVal && oldVal !== newVal;
        // Another screen altogether, not the same one refreshed: the per-second
        // fingerprints describe the old one, so they are re-taken from scratch
        // rather than read as a change that restarts the fresh carousels.
        if (oldVal && newVal && String(oldVal.id) !== String(newVal.id)) {
          this.lastDonationActivityShabbosState = null;
          this.lastFallbackItemKey = null;
        }
        if (screenChanged) {
          Object.values(this.artboardTimers).forEach((timerId) => clearTimeout(timerId));
          this.artboardTimers = {};
          Object.values(this.overflowObservers).forEach((observer) => observer.disconnect());
          this.overflowObservers = {};
          this.displayItemIndexes = {};
          this.isOverflowing = {};
          this.isOverflowingHorizontally = {};
          this.noScrollFitScales = {};
          this.zmanimNHorizontalFitScales = {};
          this.scrollTrackSizes = {};
        }
        if (newVal) {
          this.imageReady = false;
          // A different screen may sit at its own latitude / longitude / timezone,
          // so rebuild the zmanim calendar for it. Skipped on the first (immediate)
          // run — mounted() performs the initial fetch once the screen has loaded.
          if (screenChanged) {
            this.fetchOpenCageLocationAndZmanim();
          }
          this.$nextTick(async () => {
            this.onImageLoad();
            if (this.screenOverride) {
              if (screenChanged && this._displayMounted) {
                await Promise.allSettled([
                  this.getOrganization(),
                  this.loadCustomFonts(),
                  this.loadZmanimDisplayOverrides(),
                ]);
                await this.loadYurtzeitenDisplay({ force: true });
              }
              // Re-read on every refresh, not only a screen change: the
              // Dashboard replaces the screen object when a schedule is saved.
              if (this._displayMounted) await this.loadWeeklyScheduleDisplay();
              // Unmounted while that was in flight: no carousels for a dead view.
              if (!this._displayMounted) return;
              this.refreshCurrentScreenArtboards();
            }
          });
        }
      }
    },
    // The rotation runs only while the board is the element on screen, so every
    // page gets the full "time on screen" it was promised — never a slice of it
    // spent behind another feature — and an artboard showing something else is
    // not paying for a timer whose work nobody can see.
    yurtzeitenBoardIsOnScreen: {
      immediate: true,
      handler(isOnScreen) {
        if (!isOnScreen) {
          this.stopYurtzeitenPageRotation();
          return;
        }
        // Sharing the artboard means the carousel hands the board off once its
        // last page has shown (see getYurtzeitenRotationDurationMs), so each
        // visit walks the pages from the top — the same order the board had when
        // every page was its own carousel element.
        if (this.yurtzeitenBoardSharesArtboard) {
          // Not a turn of the row — the board is being re-set to its first page
          // as it comes back. Sliding here would run the page the board left on
          // out across a surface the viewer has only just been given.
          this.yurtzeitenPageSwipes = false;
          this.yurtzeitenPageIndex = 0;
        }
        this.startYurtzeitenPageRotation();
      },
    },
    // A saved change to "Time on screen" reaches a running board without a
    // reload: the socket refresh re-reads the organization, and the timer is
    // rebuilt here against the new interval.
    yurtzeitenPageIntervalMs() {
      if (this.yurtzeitenBoardIsOnScreen) this.startYurtzeitenPageRotation();
    },
    // Records entering or leaving the display window (midnight, an approval, a
    // background refetch) change how many pages there are. Hold the board where
    // it is and clamp — restarting at the first page would replay rows that had
    // just had their turn — then re-pace the timer against the new page count.
    yurtzeitenDisplayPageCount(pageCount) {
      const pages = Math.max(Number(pageCount) || 0, 0);
      const clamped = pages ? Math.min(this.yurtzeitenPageIndex, pages - 1) : 0;
      if (clamped !== this.yurtzeitenPageIndex) {
        // The list got shorter under the board rather than the board moving
        // along it: the page it was holding is gone, so the one taking its
        // place appears rather than arrives.
        this.yurtzeitenPageSwipes = false;
        this.yurtzeitenPageIndex = clamped;
      }
      if (this.yurtzeitenBoardIsOnScreen) this.startYurtzeitenPageRotation();
    },
  },
  computed: {
    screen() {
      return this.screenOverride || this.$store.getters.screen.data;
    },
    displayScreenId() {
      return this.screenId || this.$route.params.id || null;
    },
    screenIsLoading() {
      if (this.screenOverride) return false;
      // Background/triggered refreshes swap the screen content underneath the
      // current display — keep it visible instead of showing the loading spinner
      // (same feel as the Dashboard's selected-screen refresh).
      if (this.isSilentRefreshing) return false;
      return this.$store.getters.screen.isLoading;
    },
    organization() {
      return this.$store.getters.organization.data;
    },
    // Display mode, speed and direction for Recent Photos, read straight off the
    // organization so a save in the settings modal reaches every screen without
    // this view knowing anything about that modal.
    recentPhotoCarouselSettings() {
      return readRecentPhotoCarouselSettings(this.organization);
    },
    organizationIsLoading() {
      return this.$store.getters.organization.isLoading;
    },
    yurtzeitenDisplayOrganization() {
      const organizationId =
        this.screen?.organizationId ||
        this.screen?.organization?.id;
      const loadedOrganization = this.organization;

      if (
        loadedOrganization?.id != null &&
        organizationId != null &&
        String(loadedOrganization.id) === String(organizationId)
      ) {
        return loadedOrganization;
      }

      const embeddedOrganization = this.screen?.organization;
      if (
        embeddedOrganization?.id != null &&
        (organizationId == null || String(embeddedOrganization.id) === String(organizationId))
      ) {
        return embeddedOrganization;
      }

      return null;
    },
    // Which way a yahrzeit row travels, when the organization has chosen. Null
    // until it does, and the board then follows its artboard exactly as before.
    yurtzeitenCarouselDirection() {
      return normalizeYurtzeitenCarouselDirection(
        this.yurtzeitenDisplayOrganization?.yurtzeitenCarouselDirection
      );
    },
    // The records split into the screenfuls the artboard rotates through. One
    // page is the design's rows × columns of cards, each card holding as many
    // people as the design has record blocks. Every yahrzeit therefore gets its
    // turn on screen instead of the first page crowding the rest out.
    // Midnight today, rebuilt only when the day key turns over.
    yurtzeitenDisplayToday() {
      const [year, month, day] = String(this.yurtzeitenDisplayDayKey)
        .split('-')
        .map(Number);
      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        const now = this.getScreenCivilDate() || new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }
      return new Date(year, month - 1, day);
    },
    // Only the yahrzeits inside the organization's display window — the Days
    // Before / Days After pair from Yurtzeiten Display Settings, counted against
    // each record's own anniversary on the calendar that record follows. The
    // endpoint deliberately sends every approved record and leaves the window to
    // the client, because that is where the Hebrew calendar library lives.
    yurtzeitenDisplayEligibleRecords() {
      return filterYurtzeitenByDisplayWindow(
        this.yurtzeitenDisplayRecords,
        this.yurtzeitenDisplayOrganization,
        this.yurtzeitenDisplayToday
      );
    },
    yurtzeitenDisplayPages() {
      const records = this.yurtzeitenDisplayEligibleRecords;
      if (!records.length) return [];

      const { settings } = resolveYurtzeitenDesign_N(this.yurtzeitenDisplayDesign);
      // The same resolvers the renderer lays the rows out with, so a page
      // always holds exactly as many records as its rows have cards for.
      return buildYurtzeitenDisplayPages_N(
        records,
        getYurtzeitenCardCapacity_N(settings.html || ''),
        resolveYurtzeitenDisplayColumns_N(this.yurtzeitenDisplayDesign),
        resolveYurtzeitenDisplayRows_N(this.yurtzeitenDisplayDesign)
      );
    },
    yurtzeitenDisplayPageCount() {
      return this.yurtzeitenDisplayPages.length;
    },
    // How long ONE page of yahrzeits holds the screen: the organization's "Time
    // on screen", set in the Yurtzeiten settings modal.
    yurtzeitenPageIntervalMs() {
      return resolveYurtzeitenDisplayDurationMs(this.yurtzeitenDisplayOrganization);
    },
    // How long one page takes to travel off as the next travels on.
    //
    // A fixed sweep for any ordinary dwell, but never more than a third of the
    // time a page is given: an organization that sets fifteen seconds gets the
    // full unhurried sweep, and one that sets two does not end up with a board
    // that is mid-swipe more often than it is still.
    yurtzeitenPageSwipeDuration() {
      const share = Math.round(this.yurtzeitenPageIntervalMs / 3);
      const milliseconds = Math.min(Math.max(share, YURTZEITEN_PAGE_SWIPE_MIN_MS), YURTZEITEN_PAGE_SWIPE_MS);
      return `${milliseconds}ms`;
    },
    // The artboard this screen shows yahrzeits on, or null when the board lives
    // on another screen entirely (or has never been placed).
    yurtzeitenDisplayArtboard() {
      const destination = this.yurtzeitenDisplayDestination;
      if (!destination) return null;
      if (String(this.screen?.id || '') !== destination.screenId) return null;
      return (this.screen?.artboards || []).find(
        (artboard) => String(artboard?.id || '') === destination.screenArtboardId
      ) || null;
    },
    // Whether the board has to take turns with other features on its artboard.
    // On the artboard an organization dedicates to yahrzeits this is false, and
    // the board then owns the surface outright: the artboard carousel has a
    // single element and never runs, so the page rotation below is the only
    // thing moving the rows on.
    yurtzeitenBoardSharesArtboard() {
      const artboard = this.yurtzeitenDisplayArtboard;
      if (!artboard) return false;
      return this.getDisplayElements(artboard).length > 1;
    },
    // The board is on screen when its artboard is currently showing it. Rotating
    // only then is what guarantees a page is never replaced while the viewer
    // cannot see it.
    yurtzeitenBoardIsOnScreen() {
      const artboard = this.yurtzeitenDisplayArtboard;
      if (!artboard) return false;
      if (!this.yurtzeitenDisplayPageCount) return false;
      return this.isCurrentYurtzeitenNDisplay(artboard);
    },
    // Each schedule on this screen with its own settings and design,
    // normalized once per payload, and its place in the payload's order
    // (oldest first) — the order an artboard shows its schedules in.
    weeklySchedulesById() {
      const map = {};
      (this.weeklySchedulePayload?.schedules || []).forEach((schedule, order) => {
        if (!schedule?.id) return;
        const settings = normalizeWeeklyScheduleSettings(schedule.settings);
        map[String(schedule.id)] = {
          schedule,
          settings,
          design: normalizeWeeklyScheduleDesign(settings.design),
          order,
        };
      });
      return map;
    },
    // Each artboard's boards: one per schedule on it, in the schedules' order.
    weeklyScheduleDisplaysByArtboard() {
      const map = {};
      for (const display of (this.weeklySchedulePayload?.displays || [])) {
        if (!display || display.isActive === false || !display.screenArtboardId) continue;
        if (!this.weeklySchedulesById[String(display.scheduleId)]) continue;
        const artboardId = String(display.screenArtboardId);
        if (!map[artboardId]) map[artboardId] = [];
        map[artboardId].push(display);
      }
      const orderOf = (display) => this.weeklySchedulesById[String(display.scheduleId)].order;
      Object.values(map).forEach((boards) => boards.sort((a, b) => orderOf(a) - orderOf(b)));
      return map;
    },
    // Which schedules are on which artboards, as one string: when it changes,
    // the artboards' carousels have elements to add or drop.
    weeklyScheduleBoardsKey() {
      return Object.keys(this.weeklyScheduleDisplaysByArtboard)
        .sort()
        .map((artboardId) => `${artboardId}:${this.weeklyScheduleDisplaysByArtboard[artboardId].map((d) => d.scheduleId).join(',')}`)
        .join('|');
    },
    // Minutes past midnight in the screen's own timezone, once a minute.
    weeklyScheduleNowMinutes() {
      return minutesOfDayInTimeZone(this.getOrganizationTimeZone(), this.currentTime || new Date());
    },
    yurtzeitenDisplayDestination() {
      const organization = this.yurtzeitenDisplayOrganization;
      const screenId = organization?.yurtzeitenScreenId;
      const screenArtboardId = organization?.yurtzeitenScreenArtboardId;

      // Both values are one atomic setting. Treat a legacy/partial value as
      // unconfigured so records can never leak onto an unintended screen.
      if (screenId == null || screenArtboardId == null) return null;
      return {
        screenId: String(screenId),
        screenArtboardId: String(screenArtboardId),
      };
    },
    // Maps room id -> room name for the current screen's rolls. A roll minyan's
    // `roomLocation` stores the room id, but room names are only carried inside
    // each roll's automatedRules[].rooms ({ id, name }) — so we harvest them
    // here to render a readable room name instead of a raw id.
    minyanRollRoomNames() {
      const map = {};
      const artboards = this.screen?.artboards || [];
      for (const artboard of artboards) {
        for (const roll of (artboard?.minyanRolls || [])) {
          for (const rule of (roll?.automatedRules || [])) {
            for (const room of (rule?.rooms || [])) {
              if (room && room.id != null && room.name) {
                map[String(room.id)] = room.name;
              }
            }
          }
        }
      }
      return map;
    },
    // Scroll tuning is driven by the organization when configured there
    // (screen.organization first, then the store-loaded organization); otherwise
    // it falls back to the data() defaults. Only a finite, positive value
    // overrides — null / 0 / undefined / NaN keep the default, so unconfigured
    // organizations behave exactly as before.
    effectiveDefaultScrollSpeed() {
      const org = this.screen?.organization || this.organization || {};
      const speed = Number(org.defaultScrollSpeed);
      return Number.isFinite(speed) && speed > 0 ? speed : this.defaultScrollSpeed;
    },
    effectiveMinScrollDuration() {
      const org = this.screen?.organization || this.organization || {};
      const duration = Number(org.minScrollDuration);
      return Number.isFinite(duration) && duration > 0 ? duration : this.minScrollDuration;
    },
    // Scale factor: how much the displayed image differs from its original size
    scaleFactor() {
      return this.imageWidth / this.imageNaturalWidth;
    },
    // Uniform "image-like" content scale for the vertical / noscroll modes: how
    // much bigger/smaller the current display is than the fixed design baseline
    // width. 1 at the baseline, >1 on larger screens, <1 on smaller — so every
    // absolute px unit inside the content (font size, padding, row height,
    // images) keeps the same proportion of the artboard on any screen size.
    designScale() {
      return this.imageWidth / DESIGN_BASE_WIDTH;
    },
    screenDisplayRootStyle() {
      if (!this.embedded || !this.embeddedFitWidth || !this.embeddedFitHeight) return {};

      return {
        '--embedded-image-width': `${this.embeddedFitWidth}px`,
        '--embedded-image-height': `${this.embeddedFitHeight}px`,
        '--embedded-image-offset-x': `${this.embeddedOffsetX}px`,
        '--embedded-image-offset-y': `${this.embeddedOffsetY}px`,
      };
    },
    zmanimDisplayOverrideMap() {
      return this.zmanimDisplayOverrides.reduce((map, item) => {
        if (item?.zmanimKey) map[item.zmanimKey] = item;
        return map;
      }, {});
    },
    // The time range previewed on the Dashboard, as instants on the screen's own
    // clock; null for the live display and for a date previewed at one moment.
    previewRange() {
      if (!this.previewDate) return null;
      return getPreviewRange(this.previewDate, this.previewStartTime, this.previewEndTime, this.getOrganizationTimeZone());
    },
  },
  methods: {
    // The Weekly Schedule boards for this screen. Everything time-shaped is
    // worked out here from the rules the API stores, with the same engine the
    // admin page previews with, so the screen never disagrees with it.
    async loadWeeklyScheduleDisplay() {
      const screenId = this.screen?.id;
      if (!screenId) return false;
      const requestId = ++this.weeklyScheduleRequestId;
      const boardsBefore = this.weeklyScheduleBoardsKey;

      // Only a screen with an artboard whose Content includes the schedule asks
      // for it; any other drops what it held.
      const wanted = (this.screen?.artboards || []).some((artboard) =>
        this.hasFeature(artboard, WEEKLY_SCHEDULE_FEATURE_N)
      );
      if (!wanted) {
        if (this.weeklySchedulePayload) {
          this._weeklyScheduleColumnsCache = {};
          this.weeklySchedulePayload = null;
          this.weeklyScheduleVersion += 1;
          await this.$nextTick();
          if (boardsBefore) this.refreshCurrentScreenArtboards();
        }
        return false;
      }

      let payload = null;
      try {
        const response = await WeeklySchedule_N.getWeeklySchedulePublic_N({
          screenId: String(screenId),
          // A previewed date's own one-off items, overrides and day notes.
          filterDate: this.previewDate || undefined,
        });
        payload = response?.data?.status ? response.data.data : null;
      } catch (error) {
        // A 404 is a screen with no schedule board; anything else keeps the
        // last payload so a dropped request never blanks a live board.
        if (error?.response?.status !== 404) return false;
        payload = null;
      }
      if (requestId !== this.weeklyScheduleRequestId) return false;
      if (payload && String(payload.screenId || '') !== String(screenId)) payload = null;

      const location = payload?.location || null;
      const locationKey = location ? `${location.latitude}|${location.longitude}|${location.timezone}` : '';
      if (locationKey !== this._weeklyScheduleLocationKey) {
        this._weeklyScheduleLocationKey = locationKey;
        this._weeklyScheduleResolver = location
          ? await createScheduleZmanResolver(location, this.zmanimDisplayOverrides || [])
          : null;
        if (requestId !== this.weeklyScheduleRequestId) return false;
      }

      this._weeklyScheduleColumnsCache = {};
      this.weeklySchedulePayload = payload;
      this.weeklyScheduleVersion += 1;
      await this.$nextTick();
      if (this.weeklyScheduleBoardsKey !== boardsBefore) this.refreshCurrentScreenArtboards();
      return true;
    },
    // One element per schedule on an artboard whose Content includes the
    // weekly schedule, each carrying its schedule's settings and design.
    getWeeklyScheduleElements(artboard) {
      if (!artboard?.id || !this.hasFeature(artboard, WEEKLY_SCHEDULE_FEATURE_N)) return [];
      return (this.weeklyScheduleDisplaysByArtboard[String(artboard.id)] || []).map((display) => {
        const board = this.weeklySchedulesById[String(display.scheduleId)];
        return {
          id: `weekly-schedule-${display.scheduleId}-${artboard.id}`,
          type: 'WeeklySchedule_N',
          _isWeeklySchedule: true,
          scheduleId: String(display.scheduleId),
          display,
          settings: board.settings,
          design: board.design,
        };
      });
    },
    getWeeklyScheduleRotationDurationMs(element) {
      return Math.max(1, Number(element?.settings?.displayDurationSeconds) || 60) * 1000;
    },
    // One board's columns, cached per minute: today (or the week) of its
    // schedule with each item's time resolved for its date, held exactly as
    // its settings say.
    getWeeklyScheduleColumns(element) {
      const payload = this.weeklySchedulePayload;
      const display = element?.display;
      const board = element ? this.weeklySchedulesById[element.scheduleId] : null;
      if (!payload || !display || !board) return [];
      const timeZone = this.getOrganizationTimeZone();
      const now = this.currentTime || new Date();
      const todayIso = todayIsoInTimeZone(timeZone, now);
      const nowMinutes = this.weeklyScheduleNowMinutes;
      const layout = board.design.layout;
      const boardKey = `${element.scheduleId}:${display.screenArtboardId || display.id}`;
      const key = `${boardKey}|${layout}|${todayIso}|${nowMinutes}|${this.weeklyScheduleVersion}`;
      const cache = this._weeklyScheduleColumnsCache || (this._weeklyScheduleColumnsCache = {});
      if (cache[boardKey]?.key === key) return cache[boardKey].columns;

      const settings = board.settings;
      const items = itemsInSeason(board.schedule.items || [], board.schedule.activeTemplateId);
      const roomNameById = (payload.rooms || []).reduce((map, room) => ({ ...map, [String(room.id)]: room.name }), {});
      const week = buildScheduleWeek(todayIso, todayIso);
      const days = layout === 'week' ? week : week.filter((day) => day.iso === todayIso);
      const columns = days.map((day) => {
        const occurrences = resolveDayOccurrences({
          items,
          dateIso: day.iso,
          resolver: this._weeklyScheduleResolver,
          roomNameById,
          activeOnly: true,
        });
        return {
          day,
          occurrences: filterOccurrencesForDisplay(occurrences, {
            settings,
            nowMinutes,
            isToday: day.isToday,
          }),
          notes: (board.schedule.dayNotes || []).filter((note) => note.date === day.iso).map((note) => note.note),
        };
      });
      cache[boardKey] = { key, columns };
      return columns;
    },
    getLegacyFontFamily(fontKey) {
      return getLegacyArtboardFontFamily(fontKey) || (isSafeFontFamily(fontKey) ? fontKey : '');
    },
    async loadYurtzeitenDisplay(options = {}) {
      const screenId = this.screen?.id;
      const organizationId =
        this.screen?.organizationId ||
        this.screen?.organization?.id ||
        this.organization?.id;
      if (!screenId || !organizationId) return false;

      const destination = this.yurtzeitenDisplayDestination;
      const destinationScreenId = destination?.screenId || '';
      const destinationArtboardId = destination?.screenArtboardId || '';
      const contextKey = [
        organizationId,
        screenId,
        destinationScreenId,
        destinationArtboardId,
      ].map(String).join('|');

      // Never let content from the previous Dashboard screen/organization sit
      // inside the newly selected artboards while their request is in flight.
      if (contextKey !== this.yurtzeitenDisplayContextKey) {
        this.yurtzeitenDisplayContextKey = contextKey;
        this.yurtzeitenDisplayRecords = [];
        this.yurtzeitenDisplayDesign = null;
        // A different organization, screen or destination is a different board.
        // Its rows start from the top; a page index carried over from the last
        // one would point into a list that no longer exists. Note this is the
        // ONLY place the page is reset — a plain refresh of the same board
        // deliberately keeps its place, which is what stops the later pages from
        // being starved by a screen that reloads faster than they rotate.
        // A different board's first page is not this board's next page, so it
        // takes the surface rather than travelling onto it.
        this.yurtzeitenPageSwipes = false;
        this.yurtzeitenPageIndex = 0;
      } else if (!options.force && this.yurtzeitenDisplayRecords.length) {
        return true;
      }

      const destinationArtboardExists = (this.screen?.artboards || []).some(
        (artboard) => String(artboard?.id) === destinationArtboardId
      );
      if (
        !destination ||
        String(screenId) !== destinationScreenId ||
        !destinationArtboardExists
      ) {
        // Invalidate any request belonging to the previous central location.
        ++this.yurtzeitenDisplayRequestId;
        this.yurtzeitenDisplayRecords = [];
        this.yurtzeitenDisplayDesign = null;
        await this.$nextTick();
        this.refreshCurrentScreenArtboards();
        return true;
      }

      const requestId = ++this.yurtzeitenDisplayRequestId;
      let response;
      try {
        response = await Yurtzeiten_N.getYurtzeitenDisplay_N({
          screenId: String(screenId),
        });
      } catch (error) {
        // A 404 means the screen is no longer the saved destination (or its
        // artboard was removed). Clear it immediately; transient network errors
        // retain the last successfully rendered payload.
        if (
          error?.response?.status === 404 &&
          requestId === this.yurtzeitenDisplayRequestId &&
          contextKey === this.yurtzeitenDisplayContextKey
        ) {
          this.yurtzeitenDisplayRecords = [];
          this.yurtzeitenDisplayDesign = null;
          await this.$nextTick();
          this.refreshCurrentScreenArtboards();
        }
        return false;
      }

      // A slow response for a screen the user already switched away from must
      // never overwrite the new screen's display state.
      if (requestId !== this.yurtzeitenDisplayRequestId || contextKey !== this.yurtzeitenDisplayContextKey) {
        return false;
      }

      const payload = response?.data?.status ? response.data.data : null;
      if (
        !payload ||
        String(payload.screenId || '') !== String(screenId) ||
        String(payload.screenArtboardId || '') !== destinationArtboardId
      ) {
        this.yurtzeitenDisplayRecords = [];
        this.yurtzeitenDisplayDesign = null;
        await this.$nextTick();
        this.refreshCurrentScreenArtboards();
        return false;
      }

      // Whether the board is on the artboard at all — the one thing about this
      // screen's element list a refetch can change. Read before the records are
      // replaced so the two can be compared.
      const hadBoard = this.yurtzeitenDisplayEligibleRecords.length > 0;

      // Deduped on arrival so every reader downstream — the pages, the element
      // count, the carousel — sees one entry per person rather than one per
      // submission.
      this.yurtzeitenDisplayRecords = dedupeYurtzeitenDisplayRecords_N(
        Array.isArray(payload.records) ? payload.records : []
      );
      // Null is valid and means the built-in template defaults.
      this.yurtzeitenDisplayDesign = payload.design || null;

      await this.$nextTick();
      if (requestId === this.yurtzeitenDisplayRequestId) {
        // A quiet refetch is the board topping up its own records mid-rotation.
        // Restarting every carousel on this screen for that would drop each
        // artboard back to its first element once a minute, so the carousels are
        // left alone unless the board itself appeared or disappeared — the only
        // way a refetch can change what elements an artboard holds.
        const boardPresenceChanged = hadBoard !== (this.yurtzeitenDisplayEligibleRecords.length > 0);
        if (options.quiet && !boardPresenceChanged) {
          this.refreshYurtzeitenBoardLayout();
        } else {
          this.refreshCurrentScreenArtboards();
        }
      }

      return true;
    },
    // The display window only moves at midnight, so the day is checked rather
    // than tracked continuously. A record entering or leaving the window changes
    // which elements the artboard holds, so the rotation is rebuilt with it.
    refreshYurtzeitenDisplayDay() {
      // The screen's own day on the display clock (a previewed date included).
      const now = this.getScreenCivilDate() || new Date();
      const key = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
      if (key === this.yurtzeitenDisplayDayKey) return;

      const isFirstRun = !this.yurtzeitenDisplayDayKey;
      this.yurtzeitenDisplayDayKey = key;
      // On the first run the artboards have not been built yet, and the caller
      // builds them; rebuilding here would only duplicate that work.
      if (!isFirstRun) {
        this.$nextTick(() => this.refreshCurrentScreenArtboards());
      }
    },
    onImageLoad() {
      this.imageEl = Array.isArray(this.$refs.imageEl) ? this.$refs.imageEl[0] : this.$refs.imageEl;
      if (!this.imageEl) return;
      this.imageNaturalWidth = this.imageEl.naturalWidth || 1920;
      this.imageNaturalHeight = this.imageEl.naturalHeight || 1080;
      this.updateImageMetrics();
      this.imageReady = true;
      this.isBackgroundLoading = false;
      this.setupEmbeddedResizeObserver();
      if (this.screen?.artboards) {
        this.screen.artboards.forEach((artboard) => {
          this.recalculateNoScrollFit(artboard);
          this.setupOverflowObserver(artboard);
        });
      }
    },
    refreshCurrentScreenArtboards() {
      const artboards = this.screen?.artboards || [];
      artboards.forEach((artboard) => this.startArtboardCarousel(artboard));
      this.updateNearestFutureZmanimIndexes();
      this.syncYurtzeitenPageRotation();
      this.$nextTick(() => {
        artboards.forEach((artboard) => {
          this.checkOverflow(artboard);
          this.recalculateNoScrollFit(artboard);
          this.setupOverflowObserver(artboard);
        });
      });
    },
    // How long the whole board holds a SHARED artboard before the carousel moves
    // on to the next feature: one "Time on screen" per page, so every page has
    // had its turn before the board hands over. That is the pacing the board had
    // when each page was its own carousel element, kept intact now that the
    // pages rotate inside one element instead.
    //
    // On the artboard an organization dedicates to yahrzeits this value is never
    // read — a lone element has no carousel to pace.
    getYurtzeitenRotationDurationMs() {
      return this.yurtzeitenPageIntervalMs * Math.max(this.yurtzeitenDisplayPageCount, 1);
    },
    /* --------------------- yahrzeit page rotation ------------------------- */
    //
    // More eligible yahrzeits than one screenful can hold means the board has
    // several pages (see `yurtzeitenDisplayPages`), and every one of them has to
    // reach the screen. A self-rescheduling timeout — rather than setInterval —
    // is what keeps that honest: each page is measured from the moment it went
    // up, so a settings change, a refetch or a spell off screen re-paces the
    // board instead of leaving a page half shown or shown twice as long.
    stopYurtzeitenPageRotation() {
      if (this.yurtzeitenPageTimer) {
        clearTimeout(this.yurtzeitenPageTimer);
        this.yurtzeitenPageTimer = null;
      }
    },
    // Bring the timer in line with what the screen is actually showing, without
    // disturbing a rotation that is already under way. Every path that re-anchors
    // the display ends here, so the board cannot be left with a dead timer by a
    // refresh that happened not to change `yurtzeitenBoardIsOnScreen` — and,
    // just as important, a screen that refreshes faster than the board rotates
    // cannot keep restarting the dwell and pin it to one page forever.
    syncYurtzeitenPageRotation() {
      if (!this.yurtzeitenBoardIsOnScreen) {
        this.stopYurtzeitenPageRotation();
        return;
      }
      if (this.yurtzeitenPageTimer) return;
      this.startYurtzeitenPageRotation();
    },
    startYurtzeitenPageRotation() {
      this.stopYurtzeitenPageRotation();
      // A single page still ticks: the tick is also what asks for the refetch
      // that brings newly approved (or newly eligible) records onto the board.
      if (!this.yurtzeitenDisplayPageCount) return;

      const scheduleNextPage = () => {
        const interval = this.yurtzeitenPageIntervalMs;
        this.yurtzeitenPageTimer = setTimeout(() => {
          this.yurtzeitenPageTimer = null;
          // The board may have left the screen between two ticks (the artboard
          // carousel moved on, the records emptied). Stop rather than rotate
          // rows nobody is looking at; the watcher restarts it on the way back.
          if (!this.yurtzeitenBoardIsOnScreen) return;
          this.advanceYurtzeitenPage();
          this.requestYurtzeitenPageRefresh();
          scheduleNextPage();
        }, interval);
      };

      scheduleNextPage();
    },
    advanceYurtzeitenPage() {
      const pageCount = this.yurtzeitenDisplayPageCount;
      if (!pageCount) {
        this.yurtzeitenPageIndex = 0;
        return;
      }

      const currentIndex = Math.min(Math.max(this.yurtzeitenPageIndex, 0), pageCount - 1);
      const isLastPage = currentIndex >= pageCount - 1;

      // On a shared artboard the last page is held rather than wrapped: the
      // artboard carousel is what moves on from here (its slot is exactly
      // pageCount intervals long), and wrapping would flash the first page again
      // in the moment before it does.
      if (isLastPage && this.yurtzeitenBoardSharesArtboard) return;

      const nextIndex = (currentIndex + 1) % pageCount;
      if (nextIndex === this.yurtzeitenPageIndex) return;
      // The row is turning over on its timer: this is the change the swipe
      // exists for, and the only one that travels.
      this.yurtzeitenPageSwipes = true;
      this.yurtzeitenPageIndex = nextIndex;

      // A page of two long names is not the height of a page of six short ones,
      // so what scrolls and what fits is re-measured for the row that just went
      // up — the same work the artboard carousel does on its own rotations.
      this.$nextTick(() => {
        const artboard = this.yurtzeitenDisplayArtboard;
        if (!artboard) return;
        this.checkOverflow(artboard);
        this.recalculateNoScrollFit(artboard);
      });
    },
    // Pull the record list again as the board turns over, so a yahrzeit approved
    // (or reaching its display window) while the screen has been up joins the
    // rotation on the next pass instead of waiting for the half-hourly screen
    // refresh. Throttled to a minute so a 15-second "time on screen" cannot turn
    // the board into a request loop, and never overlapping itself.
    requestYurtzeitenPageRefresh() {
      if (this.yurtzeitenPageRefreshInFlight) return;

      const now = Date.now();
      if (now - this.yurtzeitenPageRefreshAt < YURTZEITEN_PAGE_REFRESH_MIN_INTERVAL_MS) return;

      this.yurtzeitenPageRefreshAt = now;
      this.yurtzeitenPageRefreshInFlight = true;
      Promise.resolve(this.loadYurtzeitenDisplay({ force: true, quiet: true }))
        .catch(() => {})
        .finally(() => {
          this.yurtzeitenPageRefreshInFlight = false;
        });
    },
    // Everything `refreshCurrentScreenArtboards` does EXCEPT restarting the
    // carousels. A refetch that leaves the artboard holding the same elements
    // has nothing to re-anchor, and restarting anyway would drop every artboard
    // on the screen back to its first element.
    refreshYurtzeitenBoardLayout() {
      this.syncYurtzeitenPageRotation();
      const artboard = this.yurtzeitenDisplayArtboard;
      if (!artboard) return;
      this.$nextTick(() => {
        this.checkOverflow(artboard);
        this.recalculateNoScrollFit(artboard);
        this.setupOverflowObserver(artboard);
      });
    },
    getYurtzeitenDisplayItemStyle(artboard) {
      if (this.getArtboardScrollDirection(artboard) !== 'horizontal') return {};
      return {
        // The renderer owns a max-content one-row strip in horizontal mode.
        // Let that intrinsic width grow beyond one viewport so every card
        // participates in the shared marquee instead of wrapping out of view.
        width: 'max-content',
        maxWidth: 'none',
        whiteSpace: 'normal',
      };
    },
    // Everything the swipe needs to know about the page on its way out, taken
    // the moment before it leaves the flow — the one point where it is settled
    // and still measurable.
    //
    // Two things come out of it. The board is held at the outgoing page's
    // height, because the page leaving is positioned out of the flow and the
    // board would otherwise drop to the height of the page arriving in the
    // first frame — cropping a taller row the instant it began to travel. And
    // the page arriving is told how far out to start: `max()` against its own
    // 100% in the stylesheet, so whichever of the two is taller is the distance
    // covered, and a shorter row is never already part way on screen when the
    // swipe begins. Both are set on the board, so the page arriving inherits
    // them the moment it is inserted.
    //
    // Pixels only for the page leaving, never for the one arriving: a card
    // measures its note and takes its final height a frame or two after it
    // mounts, so a pixel distance snapped at the start would be taken from a
    // page that has not settled. The `100%` half of the `max()` is a percentage
    // of the arriving page's own box, which the browser re-resolves as that box
    // settles — it corrects itself, and a pixel value could not.
    holdYurtzeitenPageBox(el) {
      const item = el?.parentElement;
      const height = el?.offsetHeight || 0;
      const width = el?.offsetWidth || 0;
      if (!item || !height) return;

      item.style.minHeight = `${height}px`;
      item.style.setProperty('--yz-page-swipe-from-y', `${height}px`);
      if (width) item.style.setProperty('--yz-page-swipe-from-x', `${width}px`);
    },
    // Released from BOTH ends of the swipe. They finish in the same frame, and
    // taking either as the signal means a half that never reports — a board
    // torn down mid-swipe — cannot strand a height on the board.
    releaseYurtzeitenPageBox(el) {
      const item = el?.parentElement;
      if (!item) return;

      item.style.minHeight = '';
      item.style.removeProperty('--yz-page-swipe-from-y');
      item.style.removeProperty('--yz-page-swipe-from-x');
    },
    // Which way one page of yahrzeits gives way to the next.
    //
    // The Direction the Yurtzeiten settings modal saved, whatever the artboard
    // is set to — it is the board's own setting, and the modal names exactly
    // this: "Yahrzeits slide across, right to left" or "Yahrzeits move upward,
    // one row above the next". Taking it from `getArtboardScrollDirection`
    // instead would leave the board an organization dedicates to yahrzeits with
    // no answer at all, since a dedicated artboard is set to 'noscroll'.
    //
    // The fallbacks are the modal's own, in its order, so the direction the
    // board swipes is the one the modal shows as chosen even for an
    // organization that has never opened it.
    getYurtzeitenPageSwipeDirection(artboard) {
      return this.yurtzeitenCarouselDirection
        || normalizeYurtzeitenCarouselDirection(artboard?.scrollDirection)
        || 'horizontal';
    },
    // The transition a page change is dressed in. `yz-page-swap` has no CSS
    // behind it on purpose: Vue finds no duration to wait for and swaps the
    // pages in place, which is what every change that is not the row turning
    // over should look like.
    getYurtzeitenPageTransitionName(artboard) {
      if (!this.yurtzeitenPageSwipes) return 'yz-page-swap';
      return `yz-page-swipe-${this.getYurtzeitenPageSwipeDirection(artboard)}`;
    },
    getYurtzeitenDisplayViewportWidth(artboard) {
      if (this.getArtboardScrollDirection(artboard) !== 'horizontal') return 0;
      const displayedWidth = Number(artboard.widthPercent || 0) * this.imageWidth;
      const adjustedScale = this.scaleFactor * 1.5;
      if (!(displayedWidth > 0) || !(adjustedScale > 0)) return 0;
      return displayedWidth / adjustedScale;
    },
    // The height a row of yahrzeits has to fit into, in the units the row is
    // laid out in — what the board's cards measure themselves against to decide
    // whether a note has to be given a scrolling window.
    //
    // `getScaledContentStyle` is mirrored branch for branch on purpose: it is
    // what sizes the box the row is laid out inside, and a budget taken from the
    // other branch's scale would have a note scrolling on a board it fits, or
    // sitting still on one it overflows. Unlike the width above, every direction
    // has an answer — a row can be too tall for its artboard whichever way the
    // artboard travels.
    getYurtzeitenDisplayViewportHeight(artboard) {
      const displayedHeight = Number(artboard?.heightPercent || 0) * this.imageHeight;
      if (!(displayedHeight > 0)) return 0;

      const isVertical =
        this.getArtboardScrollDirection(artboard) === 'vertical' &&
        !this.isCurrentZmanimNHorizontalTicker(artboard);
      if (artboard.scrollDirection === 'noscroll' || isVertical) {
        const scale = this.designScale || 1;
        return scale > 0 ? displayedHeight / scale : 0;
      }

      const adjustedScale = this.scaleFactor * 1.5;
      return adjustedScale > 0 ? displayedHeight / adjustedScale : 0;
    },
    handleResize() {
      this.updateImageMetrics();
      if (this.screen?.artboards) {
        this.screen.artboards.forEach((artboard) => {
          this.recalculateNoScrollFit(artboard);
          this.checkOverflow(artboard);
        });
      }
    },
    updateImageMetrics() {
      this.imageEl = Array.isArray(this.$refs.imageEl) ? this.$refs.imageEl[0] : this.$refs.imageEl;
      if (!this.imageEl) return;

      if (this.embedded) {
        const metrics = this.getEmbeddedImageMetrics();
        if (metrics) {
          this.embeddedFitWidth = metrics.width;
          this.embeddedFitHeight = metrics.height;
          this.imageWidth = metrics.width;
          this.imageHeight = metrics.height;
          this.embeddedOffsetX = metrics.offsetX;
          this.embeddedOffsetY = metrics.offsetY;
          return;
        }
      }

      this.imageWidth = this.imageEl.clientWidth || this.imageWidth || 1;
      this.imageHeight = this.imageEl.clientHeight || this.imageHeight || 1;
    },
    // Embedded (dashboard): the root fills the card and the background image is
    // object-fit:contain inside it. Returns the CONTAINED image's rendered size
    // plus its letterbox offset within the card, so the artboard overlay can be
    // placed to match the centered image exactly. Contain = fit width-flush when
    // its height then fits the card, else height-flush — matching the requested
    // behavior — and, being native CSS on the <img>, the image itself is always
    // flush regardless of when/whether this measurement runs.
    getEmbeddedImageMetrics() {
      const naturalWidth = this.imageNaturalWidth || this.imageEl?.naturalWidth || 1920;
      const naturalHeight = this.imageNaturalHeight || this.imageEl?.naturalHeight || 1080;
      if (!naturalWidth || !naturalHeight) return null;

      const root = Array.isArray(this.$refs.displayRoot) ? this.$refs.displayRoot[0] : this.$refs.displayRoot;
      const cardWidth = root?.clientWidth || 0;
      const cardHeight = root?.clientHeight || 0;
      if (cardWidth <= 0 || cardHeight <= 0) return null;

      // Try width-fit first: both side edges are flush with the card.
      const widthScale = cardWidth / naturalWidth;
      let width = cardWidth;
      let height = naturalHeight * widthScale;

      // If width-fit overflows vertically, switch entirely to height-fit.
      if (height > cardHeight) {
        const heightScale = cardHeight / naturalHeight;
        width = naturalWidth * heightScale;
        height = cardHeight;
      }

      return {
        width,
        height,
        offsetX: Math.max(0, (cardWidth - width) / 2),
        offsetY: Math.max(0, (cardHeight - height) / 2),
      };
    },
    setupEmbeddedResizeObserver() {
      if (!this.embedded || typeof ResizeObserver === 'undefined') return;
      this.$nextTick(() => {
        const root = Array.isArray(this.$refs.displayRoot) ? this.$refs.displayRoot[0] : this.$refs.displayRoot;
        const target = root?.parentElement;
        if (!target || this.embeddedResizeObserverTarget === target) return;

        if (this.embeddedResizeObserver) {
          this.embeddedResizeObserver.disconnect();
        }

        this.embeddedResizeObserverTarget = target;
        this.embeddedResizeObserver = new ResizeObserver(() => {
          this.handleResize();
        });
        this.embeddedResizeObserver.observe(target);
      });
    },
    cleanupDisplayResources() {
      this._displayMounted = false;
      this.yurtzeitenDisplayRequestId += 1;
      this.weeklyScheduleRequestId += 1;
      this.stopYurtzeitenPageRotation();
      window.removeEventListener('resize', this.handleResize);
      Object.values(this.artboardTimers).forEach(timerId => {
        clearTimeout(timerId);
      });
      this.intervalIds.forEach((intervalId) => {
        clearInterval(intervalId);
      });
      this.intervalIds = [];
      if (this.screenSwitchRetryTimer) {
        clearTimeout(this.screenSwitchRetryTimer);
        this.screenSwitchRetryTimer = null;
      }
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
      Object.values(this.overflowObservers).forEach((observer) => {
        observer.disconnect();
      });
      this.overflowObservers = {};
      if (this.embeddedResizeObserver) {
        this.embeddedResizeObserver.disconnect();
        this.embeddedResizeObserver = null;
        this.embeddedResizeObserverTarget = null;
      }
    },
    // Scale artboard content proportionally using CSS transform
    getScaledContentStyle(artboard) {
      const displayedWidth = artboard.widthPercent * this.imageWidth;
      const displayedHeight = artboard.heightPercent * this.imageHeight;

      // Image-like proportional scaling for noscroll AND all vertical scrolling
      // (whether or not the content fits). Lay the content out at the artboard's
      // size *as it would be on the design-baseline screen* (displayed / scale)
      // and scale it back by `scale` (= currentDisplayWidth / DESIGN_BASE_WIDTH).
      // The net box always equals the artboard's displayed size, so it still
      // fills the artboard exactly — but every absolute unit inside the content
      // (font size, padding, row height, images, v-html) is multiplied by
      // `scale`, so the content keeps the SAME proportion of the artboard on any
      // screen resolution: identical to the authored look at the baseline width,
      // and proportionally larger/smaller on bigger/smaller screens. The scroll
      // animation lives on the inner scroller below (not this viewport), so tall
      // content still scrolls and is never cut off.
      const isVertical =
        this.getArtboardScrollDirection(artboard) === 'vertical' &&
        !this.isCurrentZmanimNHorizontalTicker(artboard);
      if (artboard.scrollDirection === 'noscroll' || isVertical) {
        const scale = this.designScale || 1;
        return {
          width: (displayedWidth / scale) + 'px',
          height: (displayedHeight / scale) + 'px',
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        };
      }

      const sizeBoost = 1.5;
      const adjustedScale = this.scaleFactor * sizeBoost;

      const originalWidth = displayedWidth / adjustedScale;
      const originalHeight = displayedHeight / adjustedScale;
      // Lay the content out at the pre-scale ("original") width so that, after
      // `scale(adjustedScale)`, it fills the artboard's full displayed width —
      // mirroring how `originalHeight` makes it fill the height. Using
      // `displayedWidth` here (the previous behaviour) left the scaled content
      // at only `displayedWidth * adjustedScale`, i.e. collapsed to a fraction
      // of the artboard and pinned to the top-left.
      const width = originalWidth;
      const currentElement = this.getCurrentDisplayElement(artboard);
      const animationDuration = currentElement?.type === 'Zmanim_N'
        ? this.getZmanimNRotationDuration(currentElement)
        : undefined;

      return {
        width: width + 'px',
        height: originalHeight + 'px',
        transform: `scale(${adjustedScale})`,
        transformOrigin: 'top left',
        ...(animationDuration ? { animationDuration } : {}),
      };
    },
    selectAddDonationModal(artboard) {
      this.selectedArtboard = artboard
      this.showAddDonationModal = true
    },
    showNavbar() {
        this.isNavbarVisible = true;
    },
    hideNavbar() {
        this.isNavbarVisible = false;
    },
    getPosterImage(image) {
      return `${STORAGE_URL}/${POSTER_IMAGES_DIR}/${image}`
    },
    getNearestFutureRoomIndex(minyanimRooms) {
      const nowMinutes = this.getOrgNowMinutes();
      const delay = Number(this.organization?.minyanimLabelDelay) || 0;

      // Map each room to its time in minutes (org timezone)
      const roomsWithMinutes = minyanimRooms
        .map((room, idx) => {
          const dateTime = this.getMinyanRoomDateTime(room);
          const minutes = dateTime ? this.zmanMinutesOfDay(dateTime) : null;
          return { idx, minutes: Number.isFinite(minutes) ? minutes : null };
        })
        .filter(room => room.minutes !== null);

      // Find rooms within the delay window
      const windowStart = nowMinutes - delay;
      const windowEnd = nowMinutes + delay;


      const roomsInWindow = roomsWithMinutes
        .filter(room => room.minutes >= windowStart && room.minutes <= windowEnd);

      if (roomsInWindow.length === 0) return [];

      // Find the nearest room in the window (closest to now)
      roomsInWindow.sort((a, b) => Math.abs(a.minutes - nowMinutes) - Math.abs(b.minutes - nowMinutes));
      return roomsInWindow.map((e) => e.idx);
    },
    getZmanimDateTime(key) {
      if (!this.zmanims) return '- 00:00 -';

      const value = this.zmanims[key] || '';

      return value;
    },
    getNearestFutureZmanimIndex(zmanimList) {
      const nowMinutes = this.getOrgNowMinutes();
      const delay = Number(this.organization?.zmanimLabelDelay) || 0;

      // Map each room to its time in minutes (org timezone)
      const zmanimsWithMinutes = zmanimList
        .map((content, idx) => {
          const dateTime = this.getZmanimDateTime(content.name);
          const minutes = dateTime ? this.zmanMinutesOfDay(dateTime) : null;
          return { idx, minutes: Number.isFinite(minutes) ? minutes : null };
        })
        .filter(zmanim => zmanim.minutes !== null);

      // Find rooms within the delay window
      const windowStart = nowMinutes - delay;
      const windowEnd = nowMinutes + delay;

      const zmanimsInWindow = zmanimsWithMinutes
        .filter(zmanim => zmanim.minutes >= windowStart && zmanim.minutes <= windowEnd);

      if (zmanimsInWindow.length === 0) return [];

      // Find the nearest zmanim in the window (closest to now)
      zmanimsInWindow.sort((a, b) => Math.abs(a.minutes - nowMinutes) - Math.abs(b.minutes - nowMinutes));
      return zmanimsInWindow.map((e) => e.idx);
    },
    getMinyanRoomDateTime(minyanimRoom) {
      if (!minyanimRoom) return '';
      if (minyanimRoom.useZmanim && minyanimRoom.zmanimName) {
        // Prefer the real kosher-zmanim value (the same source the cell displays)
        // so sorting / highlighting matches the shown time; getComputedZmanDateTime
        // is only a last-resort estimate for legacy sunrise-offset keys.
        return this.getResolvedZmanDateTime(minyanimRoom.zmanimName);
      }
      return minyanimRoom.time || '';
    },
    getSortedMinyanimRooms(minyanimRooms) {
      if (!Array.isArray(minyanimRooms)) return [];
      return [...minyanimRooms].sort((a, b) => {
        const aValue = this.getMinyanRoomDateTime(a);
        const bValue = this.getMinyanRoomDateTime(b);
        const aTime = aValue ? new Date(aValue).getTime() : Number.POSITIVE_INFINITY;
        const bTime = bValue ? new Date(bValue).getTime() : Number.POSITIVE_INFINITY;
        return aTime - bTime;
      });
    },
    getRollItemMinutes(item) {
      if (!item) return Number.POSITIVE_INFINITY;

      if (item.timingMode === 'fixed' && item.fixedTime) {
        const match = String(item.fixedTime).match(/^(\d{2}):(\d{2})(?::\d{2})?$/);
        if (!match) return Number.POSITIVE_INFINITY;
        return Number(match[1]) * 60 + Number(match[2]);
      }

      if (item.timingMode === 'zmanim' && item.zmanimKey) {
        const offset = item.offsetMinutes ?? item.zmanimOffsetMinutes;
        const value = item._shabbosAnchor
          ? (this.resolveShabbosAnchorZmanDateTime(item.zmanimKey, item._shabbosAnchor, offset)
             || this.resolveRollZmanDateTime(item.zmanimKey, offset)
             || this.getResolvedZmanDateTime(item.zmanimKey, offset))
          : (this.resolveRollZmanDateTime(item.zmanimKey, offset)
             || this.getResolvedZmanDateTime(item.zmanimKey, offset));
        if (!value) return Number.POSITIVE_INFINITY;
        // Minutes-of-day in the org timezone so sort order / highlight / countdown
        // match the clock time shown for this minyan. Shabbos dynamic minyanim
        // snap to their "Round Start Time To" grid so every consumer (sort,
        // secondary times, countdown) uses the same rounded value as the clock.
        const minutes = this.zmanMinutesOfDay(value);
        const grid = Number(item._roundToMinutes) || 0;
        return grid > 0 ? roundMinutesToGridDirectional(minutes, grid, item._roundDirection) : minutes;
      }

      // Weekly Static Zman: the zman's Min/Max clock time across Sunday–Friday
      // of the current week, shifted by the minyan's ± Offset and then snapped to
      // its "Round Time To" grid in its "Round To" direction (closer / high /
      // lower). One static value for the whole week — sort, highlight, secondary
      // times and the countdown all use this same value as the shown clock.
      if (isWeeklyZmanTimingMode(item.timingMode) && item.zmanimKey) {
        const iso = this.resolveWeeklyStaticZmanDateTime(item.zmanimKey, getMinyanWeeklyZmanMode(item));
        if (!iso) return Number.POSITIVE_INFINITY;
        const minutes = this.zmanMinutesOfDay(iso);
        if (!Number.isFinite(minutes)) return Number.POSITIVE_INFINITY;
        return resolveWeeklyZmanMinutes(item, minutes);
      }

      if (item.timing?.mode === 'fixed' && item.timing.fixed?.time) {
        const match = String(item.timing.fixed.time).match(/^(\d{2}):(\d{2})(?::\d{2})?$/);
        if (!match) return Number.POSITIVE_INFINITY;
        return Number(match[1]) * 60 + Number(match[2]);
      }

      if (item.timing?.zmanim?.zman) {
        const value = this.getResolvedZmanDateTime(item.timing.zmanim.zman, item.timing.zmanim.offsetMinutes);
        if (!value) return Number.POSITIVE_INFINITY;
        // Minutes-of-day in the org timezone (matches the displayed clock time).
        return this.zmanMinutesOfDay(value);
      }

      return Number.POSITIVE_INFINITY;
    },
    // Time order on the roll's 2:00 AM day (so a 1:59 AM minyan lands last),
    // matching the engine's getVisibleMinyanim — the ordering the display,
    // the roll editor's live preview and the dashboard preview all share.
    getSortedRollMinyanim(minyanim) {
      if (!Array.isArray(minyanim)) return [];
      return [...minyanim].sort(
        (a, b) => compareRollDayMinutes(this.getRollItemMinutes(a), this.getRollItemMinutes(b))
      );
    },
    // Build the RollType scheduling context for the current clock tick. The
    // weekday and time-of-day come from the organization's timezone — like
    // computeIsShabbos and every other roll clock here — so a screen running in
    // a different timezone still switches rolls on the shul's wall clock.
    getMinyanRollContext() {
      const now = this.currentTime || new Date();
      const calendar = this.createJewishCalendar(this.getScreenCivilDate(now));
      const orgParts = this.getDatePartsInTimeZone(now, this.getOrganizationTimeZone());
      return buildRollContext({
        now,
        day: orgParts.dayIndex,
        minutesOfDay: orgParts.hours * 60 + orgParts.minutes,
        isShabbos: this.computeIsShabbos(now),
        isRoshChodesh: this.isJewishCalendarRoshChodesh(calendar),
        isYomTov: this.isJewishCalendarYomTov(calendar),
      });
    },
    isJewishCalendarRoshChodesh(calendar) {
      if (!calendar) return false;
      try {
        return Boolean(calendar.isRoshChodesh?.());
      } catch (error) {
        return false;
      }
    },
    computeIsShabbos(date = this.currentTime || new Date()) {
      const now = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(now.getTime())) return false;
      // Day-of-week and time-of-day in the org timezone, so the Shabbos window
      // tracks the org's location (not the display device's timezone).
      const orgParts = this.getDatePartsInTimeZone(now, this.getOrganizationTimeZone());
      const day = orgParts.dayIndex;

      if (day === 6) {
        // Saturday — Shabbos until nightfall (tzeis). Unknown tzeis: whole day.
        const tzeisIso =
          this.kosherZmanimLookup?.tzeis ||
          this.kosherZmanimLookup?.tzais ||
          this.zmanims?.tzeis ||
          '';
        const tzeis = tzeisIso ? new Date(tzeisIso) : null;
        if (tzeis && !Number.isNaN(tzeis.getTime())) return now.getTime() < tzeis.getTime();
        return true;
      }

      if (day === 5) {
        // Friday — Shabbos from candle-lighting (sunset − 18m) onward.
        const sunsetIso =
          this.kosherZmanimLookup?.sunset ||
          this.kosherZmanimLookup?.seaLevelSunset ||
          this.zmanims?.sunset ||
          '';
        const sunset = sunsetIso ? new Date(sunsetIso) : null;
        if (sunset && !Number.isNaN(sunset.getTime())) {
          return now.getTime() >= sunset.getTime() - 18 * 60000;
        }
        // Fallback: Friday 12:30 PM changeover (matches the Strict windows).
        return orgParts.hours * 60 + orgParts.minutes >= 12 * 60 + 30;
      }

      return false;
    },
    // Location + timezone that drive this screen's zmanim and wall clock. Each
    // Screen now carries its own latitude / longitude / timezone (and address /
    // postCode); we read those first and fall back to the owning organization
    // only when a screen has not been configured yet, so existing screens keep
    // working. This is the single source of truth for the display's geography.
    getScreenLocationConfig() {
      const screen = this.screen || {};
      const organization = screen.organization || this.organization || {};
      const firstNumber = (...vals) => {
        for (const val of vals) {
          const num = Number(val);
          if (Number.isFinite(num)) return num;
        }
        return Number.NaN;
      };
      const firstString = (...vals) => {
        for (const val of vals) {
          if (typeof val === 'string' && val.trim()) return val.trim();
        }
        return '';
      };
      return {
        latitude: firstNumber(screen.latitude, organization.latitude),
        longitude: firstNumber(screen.longitude, organization.longitude),
        timezone: firstString(screen.timezone, organization.timezone),
        address: firstString(screen.address, organization.address),
        postCode: firstString(
          screen.postCode, screen.postcode, screen.zip,
          organization.postCode, organization.postcode, organization.zip
        ),
      };
    },
    getOrganizationTimeZone() {
      const { timezone } = this.getScreenLocationConfig();
      return timezone || this.geoLocationTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    },
    getDatePartsInTimeZone(date, timezone) {
      const value = date instanceof Date ? date : new Date(date);
      const fallbackDate = Number.isNaN(value.getTime()) ? new Date() : value;
      const fallback = {
        dayIndex: fallbackDate.getDay(),
        hours: fallbackDate.getHours(),
        minutes: fallbackDate.getMinutes(),
      };

      if (Number.isNaN(value.getTime())) return fallback;

      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: timezone || 'UTC',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(value);
        const partMap = parts.reduce((acc, part) => {
          acc[part.type] = part.value;
          return acc;
        }, {});
        const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        const dayIndex = dayMap[partMap.weekday];
        const hours = Number(partMap.hour);
        const minutes = Number(partMap.minute);

        return {
          dayIndex: Number.isFinite(dayIndex) ? dayIndex : fallback.dayIndex,
          hours: Number.isFinite(hours) ? hours : fallback.hours,
          minutes: Number.isFinite(minutes) ? minutes : fallback.minutes,
        };
      } catch (error) {
        return fallback;
      }
    },
    // ---- Screen-timezone time helpers -------------------------------------
    // Zmanim getters return an absolute instant; the clock time you read off it
    // depends on the timezone you format it in. The whole display must use the
    // SCREEN's timezone (its physical location — see getScreenLocationConfig,
    // which falls back to the organization), NOT the display device's own
    // timezone — otherwise a screen/browser running in a different timezone
    // shows a shifted ("completely different") time than the editor preview.
    // These helpers are the single source of truth for that conversion.

    // Format a zman value as a 12-hour "h:mm" clock string in the org timezone.
    // Accepts an absolute instant (ISO string / Date — converted to org tz) or a
    // plain wall-clock "HH:mm[:ss]" string (already org-local, shown as-is).
    formatZmanClock(value, options = {}) {
      if (value === null || value === undefined || value === '') return '';
      const { withPeriod = false, withSeconds = false } = options;

      // Plain wall-clock string ("HH:mm" / "HH:mm:ss"): already org-local — no
      // timezone conversion (e.g. a manually-typed fixed minyan time).
      if (typeof value === 'string') {
        const plain = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
        if (plain) {
          const h = Number(plain[1]);
          const m = Number(plain[2]);
          const s = Number(plain[3] || 0);
          if (!Number.isFinite(h) || !Number.isFinite(m)) return '';
          const hour12 = h % 12 || 12;
          let out = `${hour12}:${String(m).padStart(2, '0')}`;
          if (withSeconds) out += `:${String(s).padStart(2, '0')}`;
          return withPeriod ? `${out} ${h >= 12 ? 'PM' : 'AM'}` : out;
        }
      }

      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return '';

      const intlOptions = {
        timeZone: this.getOrganizationTimeZone(),
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };
      if (withSeconds) intlOptions.second = '2-digit';

      try {
        const formatted = date.toLocaleTimeString('en-US', intlOptions);
        return withPeriod ? formatted : formatted.replace(/\s*(AM|PM)$/i, '').trim();
      } catch (error) {
        // Invalid timezone string — fall back to the device's local time rather
        // than dropping the value entirely.
        const formatted = date.toLocaleTimeString('en-US', { ...intlOptions, timeZone: undefined });
        return withPeriod ? formatted : formatted.replace(/\s*(AM|PM)$/i, '').trim();
      }
    },
    // Minutes-of-day (0–1439) for an absolute instant in the org timezone. Used
    // for sorting / highlight / countdown so the ordering and timers match the
    // clock times shown on screen. Returns +Infinity for blank/invalid input.
    zmanMinutesOfDay(value) {
      if (value === null || value === undefined || value === '') return Number.POSITIVE_INFINITY;
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return Number.POSITIVE_INFINITY;
      const parts = this.getDatePartsInTimeZone(date, this.getOrganizationTimeZone());
      return parts.hours * 60 + parts.minutes;
    },
    // "Now" as minutes-of-day in the org timezone.
    getOrgNowMinutes(now = this.currentTime || new Date()) {
      const date = now instanceof Date ? now : new Date(now);
      const base = Number.isNaN(date.getTime()) ? new Date() : date;
      const parts = this.getDatePartsInTimeZone(base, this.getOrganizationTimeZone());
      return parts.hours * 60 + parts.minutes;
    },
    // "Now" for the whole display (what currentTime is set to): the real clock,
    // or — previewing a date on the Dashboard — that date at the current time
    // of day on the screen's own clock; or, when the time range previewed on it
    // does not hold that time, the range's start, ticking on from there.
    getDisplayNow() {
      if (!this.previewDate) return new Date();
      const range = this.previewRange;
      if (range && this._previewRunsFromRangeStart) {
        return new Date(range.from.getTime() + (Date.now() - this._previewClockOrigin));
      }
      return getPreviewInstant(this.previewDate, this.getOrganizationTimeZone()) || new Date();
    },
    // The screen's own calendar day at `now` — read in its timezone, not the
    // viewing device's — as device-local noon of that date, which is how
    // kosher-zmanim calendars, JewishCalendar and getDay() can be pointed at it.
    // On the screen itself the two days are the same; a Dashboard in another
    // timezone would otherwise read tomorrow or yesterday for part of each day.
    getScreenCivilDate(now = this.currentTime || new Date()) {
      const date = now instanceof Date ? now : new Date(now);
      if (Number.isNaN(date.getTime())) return null;
      const parts = getZonedDateTimeParts(date, this.getOrganizationTimeZone());
      if (parts) return toLocalNoon(parts);
      const fallback = new Date(date.getTime());
      fallback.setHours(12, 0, 0, 0);
      return fallback;
    },
    // Milliseconds until the org-local clock next reaches `targetMinutes`
    // (minutes-of-day in the org timezone). Org-timezone-aware replacement for
    // the engine's getRollCountdownDiffMs so countdowns match the on-screen
    // times even when the device runs in a different timezone. Second-accurate:
    // seconds/millis are timezone-independent (IANA offsets are whole minutes).
    getOrgRollCountdownDiffMs(targetMinutes, now = this.currentTime || new Date()) {
      if (!Number.isFinite(targetMinutes)) return Number.NaN;
      const date = now instanceof Date ? now : new Date(now);
      if (Number.isNaN(date.getTime())) return Number.NaN;
      const nowMinutes = this.getOrgNowMinutes(date);
      if (!Number.isFinite(nowMinutes)) return Number.NaN;
      const nowMsOfDay = nowMinutes * 60000 + date.getSeconds() * 1000 + date.getMilliseconds();
      const targetMsOfDay = Math.round(targetMinutes) * 60000;
      const DAY_MS = 24 * 60 * 60 * 1000;
      let diff = targetMsOfDay - nowMsOfDay;
      if (diff <= 0) diff += DAY_MS; // already passed today → next occurrence
      return diff;
    },
    isDonationShabbosNow(date = this.currentTime || new Date()) {
      const now = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(now.getTime())) return false;

      const orgParts = this.getDatePartsInTimeZone(now, this.getOrganizationTimeZone());

      if (orgParts.dayIndex === 6) {
        const tzeisIso =
          this.kosherZmanimLookup?.tzeis ||
          this.kosherZmanimLookup?.tzais ||
          this.zmanims?.tzeis ||
          '';
        const tzeis = tzeisIso ? new Date(tzeisIso) : null;
        if (tzeis && !Number.isNaN(tzeis.getTime())) return now.getTime() < tzeis.getTime();
        return true;
      }

      if (orgParts.dayIndex === 5) {
        const sunsetIso =
          this.kosherZmanimLookup?.sunset ||
          this.kosherZmanimLookup?.seaLevelSunset ||
          this.zmanims?.sunset ||
          '';
        const sunset = sunsetIso ? new Date(sunsetIso) : null;
        if (sunset && !Number.isNaN(sunset.getTime())) {
          return now.getTime() >= sunset.getTime() - SHABBOS_CANDLE_OFFSET_MINUTES * 60000;
        }
        return orgParts.hours * 60 + orgParts.minutes >= 12 * 60 + 30;
      }

      return false;
    },
    normalizeDonationActivity(value) {
      const normalized = String(value || '').trim().toLowerCase();
      if (normalized === 'shabbos' || normalized === 'shabbat') return 'shabbos';
      if (normalized === 'weekday' || normalized === 'weekdays') return 'weekdays';
      if (normalized === 'fallback') return 'fallback';
      return 'always';
    },
    // Activity "When Artboard Is Empty": the donation or announcement goes up
    // only while nothing else is showing on its artboard (see
    // getDisplayElements).
    isFallbackItem(item) {
      return this.normalizeDonationActivity(item?.activity) === 'fallback';
    },
    isShowingFallbackItems(artboard) {
      const items = [...(artboard?.donations || []), ...(artboard?.announcements || [])];
      if (!items.some((item) => this.isFallbackItem(item))) return false;
      const [first] = this.getDisplayElements(artboard);
      return Boolean(first)
        && (first.type === 'Donation' || first.type === 'Announcement')
        && this.isFallbackItem(first);
    },
    isDonationVisibleForActivity(donation) {
      if (donation?.isActive === false) return false;

      const activity = this.normalizeDonationActivity(donation?.activity);
      if (activity === 'shabbos') return this.isDonationShabbosNow();
      if (activity === 'weekdays') return !this.isDonationShabbosNow();
      return true;
    },
    // Posters use the same Always / Shabbos / Weekdays gating as donations,
    // driven by the same org-timezone Shabbos-window check (isDonationShabbosNow).
    // A photo shows when it is active, has an image, and today falls inside its
    // display window. The window bounds are optional and independent, matching
    // how the rest of the display treats start/end dates.
    isRecentPhotoVisible(photo) {
      if (!photo || !photo.photo) return false;
      if (photo.isActive === false || photo.isDeleted) return false;

      // A time range previewed on the Dashboard shows every photo up at any
      // moment of it; otherwise the photo has to be up now.
      const now = (this.currentTime || new Date()).getTime();
      const range = this.previewRange;
      const latest = range ? range.to.getTime() : now;
      const earliest = range ? range.from.getTime() : now;
      const start = photo.displayStartDate ? new Date(photo.displayStartDate).getTime() : null;
      const end = photo.displayEndDate ? new Date(photo.displayEndDate).getTime() : null;
      if (start != null && Number.isFinite(start) && latest < start) return false;
      if (end != null && Number.isFinite(end) && earliest > end) return false;
      return true;
    },
    // Whether an event should be on screen right now.
    //
    // The template is part of the test rather than a rendering detail: an event
    // is a calendar entry first, and only the layout it is linked to gives it a
    // form to be drawn in. Without one there is nothing to show, so it must not
    // take a turn in the artboard's rotation and leave the board blank.
    //
    // The display window is compared as whole calendar days, both ends
    // inclusive: the dates are picked from date-only inputs, and an event that
    // vanished at midnight at the start of its own last day would be wrong.
    isEventVisible(event) {
      if (!event || !event.eventTemplate) return false;
      if (event.isActive === false || event.isDeleted) return false;

      const startOfDay = (value) => {
        const date = toWallClockDate(value);
        return date
          ? new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
          : null;
      };

      // The screen's own day on the display clock (a previewed date included).
      const now = this.getScreenCivilDate() || new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();

      const start = startOfDay(event.displayStartDate);
      if (start != null && today < start) return false;

      const end = startOfDay(event.displayEndDate);
      if (end != null && today > end) return false;

      return true;
    },
    getEventImageUrl(image) {
      return `${STORAGE_URL}/${EVENT_IMAGES_DIR}/${image}`;
    },
    /**
     * Fill an Event Template with one event's values.
     *
     * Driven by an explicit map rather than by walking the event's own keys the
     * way renderDonationContent does: an event carries relations (`eventTemplate`,
     * `screen`, `user`) that a key walk would happily stringify into the page,
     * and a placeholder for a column the event happens to leave null has to
     * disappear rather than print "null". Every token here is one the Insert
     * Variable menu offers — see utils/event_template_variables.ts.
     */
    renderEventContent(template, event) {
      let content = String(template == null ? '' : template);
      if (!content) return '';

      // The blank lines the template's author left with Enter, marked while the
      // layout is still exactly what they saved. Ahead of the substitution
      // below on purpose: a paragraph holding nothing but a {token} this event
      // has no value for ends up just as empty, and that one has to go on
      // collapsing — see utils/authored_blank_lines.ts.
      content = markAuthoredBlankLinesHtml(content);

      const photo = String(event?.image || '').trim();
      const dateOrEmpty = (value) => {
        const formatted = this.formatScheduleDateOnly(value);
        // The shared formatter returns '-' for an unset date, which reads as a
        // stray dash on a memorial-style card. Nothing is the honest output.
        return formatted === '-' ? '' : formatted;
      };

      // Each text value is wrapped in its own <span>. Inert in an ordinary
      // paragraph, and load-bearing in a "split row": that row is a flex
      // container, where a bare run of text collapses into ONE anonymous item
      // and space-between would have nothing to push apart. The span makes every
      // value its own flex child, so the row splits on the variables the way the
      // editor previewed it. The photo is already its own element.
      const asValue = (html) => (html ? `<span class="event-template-value">${html}</span>` : '');

      const values = {
        title: asValue(this.multilineToHtml(event?.title)),
        description: asValue(this.multilineToHtml(event?.description)),
        details: asValue(this.multilineToHtml(event?.details)),
        location: asValue(this.multilineToHtml(event?.location)),
        eventDate: asValue(dateOrEmpty(event?.eventDate)),
        displayStartDate: asValue(dateOrEmpty(event?.displayStartDate)),
        displayEndDate: asValue(dateOrEmpty(event?.displayEndDate)),
        // An event without a photo leaves nothing behind, rather than a broken
        // image icon in the middle of the layout.
        image: photo
          ? `<img class="event-template-photo" src="${this.getEventImageUrl(encodeURIComponent(photo))}" alt="" />`
          : '',
      };

      Object.keys(values).forEach((key) => {
        // split/join rather than a regex replace: the token is a literal, and a
        // value containing "$&" or "$1" is inserted verbatim instead of being
        // read as a replacement pattern the way String.replace would read it.
        content = content.split(`{${key}}`).join(values[key]);
      });

      return content;
    },
    isPosterVisibleForActivity(poster) {
      if (poster?.isActive === false) return false;

      const activity = this.normalizeDonationActivity(poster?.activity);
      if (activity === 'shabbos') return this.isDonationShabbosNow();
      if (activity === 'weekdays') return !this.isDonationShabbosNow();
      return true;
    },
    // Announcements use the same Activity gating as donations.
    isAnnouncementVisibleForActivity(announcement) {
      if (announcement?.isActive === false) return false;

      const activity = this.normalizeDonationActivity(announcement?.activity);
      if (activity === 'shabbos') return this.isDonationShabbosNow();
      if (activity === 'weekdays') return !this.isDonationShabbosNow();
      return true;
    },
    handleDonationActivityClockTick() {
      const isShabbos = this.isDonationShabbosNow();
      if (this.lastDonationActivityShabbosState === null) {
        this.lastDonationActivityShabbosState = isShabbos;
        return;
      }
      if (isShabbos === this.lastDonationActivityShabbosState) return;

      this.lastDonationActivityShabbosState = isShabbos;
      (this.screen?.artboards || []).forEach((artboard) => this.startArtboardCarousel(artboard));
      this.syncYurtzeitenPageRotation();
      this.$nextTick(() => {
        (this.screen?.artboards || []).forEach((artboard) => {
          this.checkOverflow(artboard);
          this.recalculateNoScrollFit(artboard);
        });
      });
    },
    // An artboard emptying out onto its fallback items (a roll going off air,
    // say) or filling back up swaps its whole element list, so the carousels
    // start over on the new one instead of sitting on an index that no longer
    // exists.
    handleFallbackItemClockTick() {
      const key = (this.screen?.artboards || [])
        .filter((artboard) => this.isShowingFallbackItems(artboard))
        .map((artboard) => artboard.id)
        .join('|');
      if (this.lastFallbackItemKey === null) {
        this.lastFallbackItemKey = key;
        return;
      }
      if (key === this.lastFallbackItemKey) return;

      this.lastFallbackItemKey = key;
      (this.screen?.artboards || []).forEach((artboard) => this.startArtboardCarousel(artboard));
      this.syncYurtzeitenPageRotation();
      this.$nextTick(() => {
        (this.screen?.artboards || []).forEach((artboard) => {
          this.checkOverflow(artboard);
          this.recalculateNoScrollFit(artboard);
        });
      });
    },
    // Parse an "HH:mm" string to minutes-of-day, or null when invalid.
    parseClockToMinutes(value) {
      if (typeof value !== 'string') return null;
      const match = value.match(/^(\d{1,2}):(\d{2})/);
      if (!match) return null;
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
      return hours * 60 + minutes;
    },
    // Resolve an automated-rule zman value to an ISO datetime string. The rule's
    // zman selector offers the same options as a minyan's Dynamic Zman, so it
    // resolves through the SAME chain a minyan does — Settings → Special Zmanim
    // overrides, the prebuilt kosher-zmanim lookup, then a direct calendar getter
    // — and rules built before that share a curated dropdown are normalized to
    // their canonical key first. Returns '' (never a synthetic sunrise) when the
    // zman can't be resolved, so the rule simply generates nothing.
    resolveAutomatedZmanDateTime(zmanValue, offsetMinutes = 0) {
      const key = normalizeAutomatedZmanKey(zmanValue);
      if (!key) return '';
      const offset = Number(offsetMinutes) || 0;
      return this.resolveRollZmanDateTime(key, offset) || this.getResolvedZmanDateTime(key, offset);
    },
    // Resolve a saved AutomatedTimeBoundary to minutes-of-day, or null.
    resolveAutomatedBoundaryMinutes(boundary) {
      if (!boundary || typeof boundary !== 'object') return null;
      if (boundary.mode === 'fixed') {
        return this.parseClockToMinutes(boundary.fixed?.time);
      }
      if (boundary.mode === 'zman' || boundary.mode === 'zmanim') {
        const zman = boundary.zman || {};
        // ± minutes: a negative offset anchors the boundary BEFORE the zman.
        const offset = normalizeAutomatedOffsetMinutes(zman.offsetMinutes ?? zman.offset);
        const iso = this.resolveAutomatedZmanDateTime(zman.zman, offset);
        if (!iso) return null;
        // Minutes-of-day in the org timezone (matches the displayed clock time).
        const minutes = this.zmanMinutesOfDay(iso);
        return Number.isFinite(minutes) ? minutes : null;
      }
      return null;
    },
    // Generated minyanim for one roll's automated rules (concrete times + rooms).
    getRollAutomatedMinyanim(roll) {
      return generateRollAutomatedMinyanim(roll, {
        resolveBoundaryMinutes: (boundary) => this.resolveAutomatedBoundaryMinutes(boundary),
      });
    },
    // A roll's full minyan list: manually-defined minyanim + automated ones.
    // On Shabbos-type rolls, dynamic-zman minyanim are tagged with the weekend
    // anchor day (`_shabbosAnchor`) so the display resolves them against the
    // locked weekend dates instead of today.
    getRollCombinedMinyanim(roll) {
      // A minyan switched off by the roll editor's per-row Active toggle is
      // dropped here, before anything else looks at the roll. That keeps it out
      // of the rendered rows, the card grid, the highlight/countdown candidates
      // and the upcoming-minyan window in one place — and, because this feeds
      // the roll expansion that `buildSlotWinners` reads, it also stops a
      // hidden minyan from claiming its time slot and suppressing a
      // lower-priority roll's minyan at the same time.
      const manual = (Array.isArray(roll?.minyanim) ? roll.minyanim : []).filter(isMinyanActive);
      const generated = this.getRollAutomatedMinyanim(roll);
      const isShabbos = this.isShabbosRollType(roll?.type);
      const tagged = isShabbos
        ? manual.map((minyan) => {
            const anchor = this.normalizeShabbosAnchor(minyan?.shabbosAnchor);
            // Every minyan on a Shabbos roll carries the weekend anchor, so a
            // נץ החמה toggle resolves sunrise for that locked weekend day rather
            // than for today (only the dynamic-zman branches below read it for
            // the minyan's OWN time, so a fixed-time minyan is unaffected).
            const anchored = { ...minyan, _shabbosAnchor: anchor };
            // Shabbos dynamic-zman minyanim also carry their "Round Start Time
            // To" grid + direction so the resolved time snaps consistently
            // (display, sort, secondary times and countdown).
            return minyan?.timingMode === 'zmanim' && minyan?.zmanimKey
              ? {
                  ...anchored,
                  _roundToMinutes: getMinyanRoundToMinutes(minyan),
                  _roundDirection: getMinyanRoundDirection(minyan),
                }
              : anchored;
          })
        : manual;
      return [...tagged, ...generated];
    },
    // Rolls for an artboard with their minyanim expanded to include automated
    // ones. Tagged so the template can identify a roll display element even
    // though it is a (cloned) expanded copy.
    getExpandedMinyanRolls(artboard) {
      return (artboard?.minyanRolls || []).map((roll) => ({
        ...roll,
        _isMinyanRoll: true,
        minyanim: this.getRollCombinedMinyanim(roll),
        // The authored list, including rows switched off by the per-minyan
        // Active toggle, so `rollUsesManualOrder` still recognises a manually
        // arranged roll after those rows have been filtered out.
        _orderSourceMinyanim: Array.isArray(roll?.minyanim) ? roll.minyanim : [],
      }));
    },
    // RollType filter + "Greatest Wins": active rolls (with visible minyanim).
    getActiveMinyanRolls(artboard) {
      const ctx = this.getMinyanRollContext();
      return resolveRollDisplay(
        this.getExpandedMinyanRolls(artboard),
        ctx,
        (minyan) => this.getRollItemMinutes(minyan)
      ).map((entry) => entry.roll);
    },
    // Upcoming-minyan content assigned to this artboard. The screen payload
    // attaches each artboard's `upcomingMinyanims` (already filtered for
    // !isDeleted by the API); here we keep only the enabled/active ones that
    // actually have display content, and tag each so the carousel can render it.
    getActiveUpcomingMinyanims(artboard) {
      const list = Array.isArray(artboard?.upcomingMinyanims) ? artboard.upcomingMinyanims : [];
      // An upcoming display belongs to a roll, so it must obey that roll's
      // RollType schedule too: a Weekday (Strict) roll that is currently off-air
      // should not surface its "next minyan" upcoming card. Gate every element by
      // its source roll being active right now (same context as the roll display).
      const ctx = this.getMinyanRollContext();
      const now = this.currentTime || new Date();
      const active = list
        .filter((u) =>
          u
          && u.enabled === true
          && u.isActive !== false
          && !u.isDeleted
          && this.upcomingMinyanHasContent(u.displayContent)
          && this.isUpcomingRollActive(u, ctx)
          // Only surface an element while its Display From / Display Until window
          // currently selects a minyan — outside the window it shows nothing and
          // must not claim a carousel slot. When the roll can't be resolved on
          // this screen (or has no timed minyanim), there is no window to apply,
          // so fall back to the prior behaviour of showing the template as-is.
          && this.isUpcomingElementInWindow(u, now)
        )
        .map((u) => ({ ...u, _isUpcomingMinyan: true }));

      // A single upcoming display is shown as-is. But when 2+ rolls each place an
      // upcoming display on the SAME artboard, they would otherwise each take a
      // carousel slot and compete. Instead collapse them into ONE slot whose
      // content tracks the soonest upcoming minyan across all those rolls,
      // rendered with the template + design of the roll that minyan belongs to —
      // so it automatically switches as the global "next" minyan rolls forward
      // (see getUpcomingMinyanContent / getCombinedUpcomingSelection).
      if (active.length <= 1) return active;
      return [{
        _isUpcomingMinyan: true,
        _combinedUpcoming: active,
        id: `combined-upcoming-${artboard?.id ?? ''}`,
        // A representative template/roll id so any generic consumer still sees a
        // non-empty upcoming element; the real choice happens at render time.
        displayContent: active[0].displayContent,
        minyanRollId: active[0].minyanRollId,
      }];
    },
    // True when an upcoming minyan's rich-text body has something worth showing
    // (visible text or an image) — guards against blank carousel slots.
    upcomingMinyanHasContent(html) {
      if (!html) return false;
      const raw = String(html);
      if (/<img\b/i.test(raw)) return true;
      const text = raw.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
      return text.length > 0;
    },
    // Locate a roll anywhere on the current screen by its id. An upcoming-minyan
    // element references its source roll via `minyanRollId`; the roll itself may
    // live under any artboard (it is linked to an artboard through its own
    // Display tab, independent of where the upcoming display is shown).
    findRollByMinyanRollId(rollId) {
      if (rollId == null) return null;
      const target = String(rollId);
      const artboards = this.screen?.artboards || [];
      for (const artboard of artboards) {
        for (const roll of (artboard?.minyanRolls || [])) {
          if (roll && String(roll.id) === target) return roll;
        }
      }
      return null;
    },
    // Whether an upcoming-minyan element's source roll is active right now per
    // its RollType schedule (Weekday/Shabbos Strict windows, Rosh Chodesh,
    // Weekday Custom recurrence, ...). This intentionally ignores the roll's
    // isActive display toggle so hiding the Minyanim Roll itself does not hide
    // the separate Upcoming Minyanim element.
    isUpcomingRollActive(upcoming, ctx) {
      const roll = this.findRollByMinyanRollId(upcoming && upcoming.minyanRollId);
      if (!roll) return true;
      return isRollActiveNow(roll, ctx || this.getMinyanRollContext());
    },
    // Signed milliseconds from `now` to the org-local time-of-day `targetMinutes`:
    // positive while the minyan is still upcoming, negative once it has already
    // started (within roughly the last 12 hours). Built on getOrgRollCountdownDiffMs
    // so it shares the exact org-timezone clock the rest of the roll display uses.
    getOrgSignedDiffMs(targetMinutes, now = this.currentTime || new Date()) {
      const diff = this.getOrgRollCountdownDiffMs(targetMinutes, now);
      if (!Number.isFinite(diff)) return Number.NaN;
      const DAY_MS = 24 * 60 * 60 * 1000;
      // getOrgRollCountdownDiffMs always rolls forward into (0, 24h]; anything
      // past the 12h mark is really a minyan that started a moment ago.
      return diff > DAY_MS / 2 ? diff - DAY_MS : diff;
    },
    // The minyan an Upcoming-Minyanim element should show at `now`, honoring the
    // roll's Upcoming tab settings:
    //   • Display From  — how early before its time a minyan may appear
    //       fixed         → displayFromMinutesBefore minutes before
    //       startOfDay    → any time earlier the same day (no lower bound)
    //       afterPrevious → only once the previous minyan has started
    //   • Display Until — how long after its time a minyan lingers
    //       start         → disappears exactly at minyan time
    //       minutesAfter  → lingers displayUntilMinutesAfter minutes past its time
    //       endTime       → lingers until the next minyan begins
    //   • Prioritize Not Started — when a just-passed minyan and the next one are
    //       both within their windows, prefer the not-yet-started one; otherwise
    //       the in-progress minyan holds the slot until its window expires.
    // Returns the chosen minyan object, or null when nothing is within its window
    // right now (the element then shows nothing and claims no carousel slot).
    getUpcomingWindowMinyan(element, roll, now = this.currentTime || new Date()) {
      if (!roll || !element) return null;
      const timed = [];
      for (const minyan of this.getRollCombinedMinyanim(roll)) {
        if (this.isRollTextItem(minyan)) continue;
        const minutes = this.getRollItemMinutes(minyan);
        if (!Number.isFinite(minutes)) continue;
        timed.push({ minyan, minutes });
      }
      if (!timed.length) return null;
      timed.sort((a, b) => a.minutes - b.minutes);
      const count = timed.length;

      const MINUTE_MS = 60000;
      const fromMode = element.displayFromMode || 'fixed';
      const untilMode = element.displayUntilMode || 'start';
      const fixedLeadMs = Math.max(0, Number(element.displayFromMinutesBefore) || 0) * MINUTE_MS;
      const trailAfterMs = Math.max(0, Number(element.displayUntilMinutesAfter) || 0) * MINUTE_MS;

      // Gap from the previous / to the next minyan, computed cyclically so the
      // first and last minyan of the day wrap correctly; a lone minyan spans the
      // whole day. Used by afterPrevious (lower bound) and endTime (upper bound).
      const gapBeforeMs = (idx) => {
        if (count === 1) return Number.POSITIVE_INFINITY;
        const prev = timed[(idx - 1 + count) % count].minutes;
        const gap = (((timed[idx].minutes - prev) % 1440) + 1440) % 1440;
        return (gap || 1440) * MINUTE_MS;
      };
      const gapAfterMs = (idx) => {
        if (count === 1) return Number.POSITIVE_INFINITY;
        const next = timed[(idx + 1) % count].minutes;
        const gap = (((next - timed[idx].minutes) % 1440) + 1440) % 1440;
        return (gap || 1440) * MINUTE_MS;
      };
      const leadMsFor = (idx) => {
        if (fromMode === 'fixed') return fixedLeadMs;
        if (fromMode === 'afterPrevious') return gapBeforeMs(idx);
        // startOfDay / zmanim / unknown → no lower bound (visible all day before).
        return Number.POSITIVE_INFINITY;
      };
      const trailMsFor = (idx) => {
        if (untilMode === 'minutesAfter') return trailAfterMs;
        if (untilMode === 'endTime') return gapAfterMs(idx);
        // start (default) → gone the moment the minyan begins.
        return 0;
      };

      const candidates = [];
      timed.forEach((entry, idx) => {
        const signedMs = this.getOrgSignedDiffMs(entry.minutes, now);
        if (!Number.isFinite(signedMs)) return;
        if (signedMs > leadMsFor(idx)) return;     // still too early to appear
        if (signedMs <= -trailMsFor(idx)) return;  // window has already expired
        candidates.push({ minyan: entry.minyan, signedMs });
      });
      if (!candidates.length) return null;

      const notStarted = candidates.filter((c) => c.signedMs > 0);
      const started = candidates.filter((c) => c.signedMs <= 0);
      const soonest = (list) => list.reduce((a, b) => (b.signedMs < a.signedMs ? b : a));
      const mostRecent = (list) => list.reduce((a, b) => (b.signedMs > a.signedMs ? b : a));

      let chosen;
      if (element.prioritizeNotStarted) {
        chosen = notStarted.length ? soonest(notStarted) : mostRecent(started);
      } else {
        chosen = started.length ? mostRecent(started) : soonest(notStarted);
      }
      return chosen ? chosen.minyan : null;
    },
    // Whether an upcoming element should currently occupy a carousel slot. If its
    // roll resolves to at least one timed minyan we honor the Display From /
    // Display Until window (hidden when nothing is in-window); otherwise there is
    // nothing to time, so we leave it visible to render whatever static template
    // it carries (matching the pre-window behavior).
    isUpcomingElementInWindow(element, now = this.currentTime || new Date()) {
      const roll = this.findRollByMinyanRollId(element && element.minyanRollId);
      const hasTimedMinyan = !!roll && this.getRollCombinedMinyanim(roll).some(
        (minyan) => !this.isRollTextItem(minyan) && Number.isFinite(this.getRollItemMinutes(minyan))
      );
      if (!hasTimedMinyan) return true;
      return !!this.getUpcomingWindowMinyan(element, roll, now);
    },
    // Across several rolls' upcoming displays that share one artboard, pick the
    // single soonest upcoming minyan (the global "next"). Ties resolve by roll
    // priority (Greatest Wins — matching the roll display), then by the upcoming
    // element's order, so the choice is fully deterministic. Returns the winning
    // { minyan, roll, element } or null when nothing is upcoming on any of them.
    getCombinedUpcomingSelection(elements) {
      const now = this.currentTime || new Date();
      // Each element first resolves its OWN minyan through its Display From /
      // Display Until window (getUpcomingWindowMinyan); we then pick between those
      // per-element choices globally.
      const candidates = [];
      (Array.isArray(elements) ? elements : []).forEach((element, order) => {
        const roll = this.findRollByMinyanRollId(element && element.minyanRollId);
        if (!roll) return;
        const minyan = this.getUpcomingWindowMinyan(element, roll, now);
        if (!minyan) return;
        const signedMs = this.getOrgSignedDiffMs(this.getRollItemMinutes(minyan), now);
        if (!Number.isFinite(signedMs)) return;
        candidates.push({ minyan, roll, element, signedMs, priority: Number(roll.priority) || 0, order });
      });
      if (!candidates.length) return null;
      // Prefer a not-yet-started minyan (soonest first); if every candidate is
      // already in progress, keep the most-recently-started one. Ties resolve by
      // roll priority (Greatest Wins — matching the roll display), then order.
      candidates.sort((a, b) => {
        const aFuture = a.signedMs > 0;
        const bFuture = b.signedMs > 0;
        if (aFuture !== bFuture) return aFuture ? -1 : 1;
        if (a.signedMs !== b.signedMs) return aFuture ? a.signedMs - b.signedMs : b.signedMs - a.signedMs;
        if (a.priority !== b.priority) return b.priority - a.priority;
        return a.order - b.order;
      });
      return candidates[0];
    },
    // Resolve an upcoming-minyan element to its final HTML: find its roll, pick
    // that roll's next minyan, and interpolate the body's {name}/{room}/{time}/
    // {countdown} + display-toggle placeholders against it (reusing the
    // exact roll renderer so values match the roll display). Reads `currentTime`
    // (which ticks every second), so the chosen minyan re-evaluates continuously
    // — comfortably refreshing the "next minyan" at least once a minute. When no
    // roll/minyan resolves, the placeholders collapse to empty rather than
    // leaking literal `{tokens}` onto the screen.
    getUpcomingCountdownDesign(upcomingElement, rollDesign) {
      const design = rollDesign || {};
      return {
        ...design,
        countdown: {
          ...(design.countdown || {}),
          target: normalizeRollCountdownTarget(upcomingElement?.countdownTarget),
        },
      };
    },
    getUpcomingMinyanContent(upcomingElement) {
      // Combined slot (2+ rolls share this artboard's upcoming display): show the
      // upcoming template + design of whichever roll owns the soonest upcoming
      // minyan, switching automatically as that "next" minyan rolls forward.
      const combined = upcomingElement && upcomingElement._combinedUpcoming;
      if (Array.isArray(combined) && combined.length) {
        const selection = this.getCombinedUpcomingSelection(combined);
        if (selection) {
          const minyan = { ...selection.minyan, _isRollActiveMinyan: true };
          return this.renderRollCellHtml(
            (selection.element && selection.element.displayContent) || '',
            minyan,
            this.getUpcomingCountdownDesign(
              selection.element,
              (selection.roll && selection.roll.design) || {}
            )
          );
        }
        // Nothing upcoming on any of the rolls — render the first roll's template
        // with no minyan so its placeholders collapse rather than leaking tokens.
        const first = combined[0];
        const firstRoll = this.findRollByMinyanRollId(first && first.minyanRollId);
        return this.renderRollCellHtml(
          (first && first.displayContent) || '',
          null,
          this.getUpcomingCountdownDesign(first, (firstRoll && firstRoll.design) || {})
        );
      }

      const template = (upcomingElement && upcomingElement.displayContent) || '';
      if (!template) return '';
      const roll = this.findRollByMinyanRollId(upcomingElement && upcomingElement.minyanRollId);
      // The minyan chosen by this element's Display From / Display Until window.
      const next = roll ? this.getUpcomingWindowMinyan(upcomingElement, roll) : null;
      // This IS the shown minyan, so mark it active to let its {countdown} resolve
      // using this Upcoming display's independent Countdown To selection.
      const minyan = next ? { ...next, _isRollActiveMinyan: true } : null;
      return this.renderRollCellHtml(
        template,
        minyan,
        this.getUpcomingCountdownDesign(upcomingElement, (roll && roll.design) || {})
      );
    },
    // Minyanim for one roll after hiding slots claimed by a higher-priority roll.
    getVisibleRollMinyanim(roll, artboard) {
      const ctx = this.getMinyanRollContext();
      const getMinutes = (minyan) => this.getRollItemMinutes(minyan);
      const expandedRolls = this.getExpandedMinyanRolls(artboard);
      const activeRolls = getActiveRolls(expandedRolls, ctx);
      const slotWinners = buildSlotWinners(activeRolls, getMinutes);
      // `roll` is already an expanded clone (it came from getActiveMinyanRolls);
      // match it back within this freshly-expanded set by id so it shares the
      // same slot-winner context.
      const target = expandedRolls.find((r) => r.id != null && r.id === roll?.id)
        || (roll?._isMinyanRoll ? roll : {
          ...roll,
          minyanim: this.getRollCombinedMinyanim(roll),
          _orderSourceMinyanim: Array.isArray(roll?.minyanim) ? roll.minyanim : [],
        });
      return getVisibleMinyanim(target, slotWinners, getMinutes);
    },
    // Minutes-of-day (org timezone) of the Netz (sunrise) a minyan's נץ החמה
    // toggle anchors to. A Shabbos-roll minyan resolves against its locked
    // weekend anchor date — the same date its own time resolves against — so the
    // netz shown next to it belongs to that day, not to today. Cached per
    // resolved ISO so the per-second re-render doesn't redo the timezone
    // conversion for every minyan on screen.
    getRollSunriseMinutes(item) {
      const anchor = item && item._shabbosAnchor;
      const iso =
        (anchor ? this.resolveShabbosAnchorZmanDateTime(NETZ_ZMAN_KEY, anchor) : '') ||
        this.resolveRollZmanDateTime(NETZ_ZMAN_KEY) ||
        this.getResolvedZmanDateTime(NETZ_ZMAN_KEY);
      if (!iso) return null;
      // Keyed by timezone too, so switching to a screen in another zone can't
      // hand back the previous screen's minutes-of-day.
      const timeZone = this.getOrganizationTimeZone();
      const cache = this._rollSunriseCache;
      if (cache && cache.iso === iso && cache.timeZone === timeZone) return cache.minutes;
      const minutes = this.zmanMinutesOfDay(iso);
      const resolved = Number.isFinite(minutes) ? minutes : null;
      this._rollSunriseCache = { iso, timeZone, minutes: resolved };
      return resolved;
    },
    // A minyan's secondary timestamps: the davening milestones measured from its
    // own start time (Bruches +5, Hoidy +15, Ashrei, Borchy) and נץ החמה measured
    // from the day's real sunrise. Entries whose anchor can't be resolved are
    // dropped, so nothing renders as a placeholder time.
    getRollSecondaryTimes(item) {
      return resolveMinyanSecondaryTimes(item, {
        minyanMinutes: this.getRollItemMinutes(item),
        sunriseMinutes: this.getRollSunriseMinutes(item),
      });
    },
    toggleFullScreen() {
        if (document.fullscreenElement) {
            // Exit fullscreen mode
            document.exitFullscreen()
                .then(() => {
                    this.isFullScreen = false;
                })
                .catch((err) => {
                    console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            // Enter fullscreen mode
            document.documentElement.requestFullscreen()
                .then(() => {
                    this.isFullScreen = true;
                })
                .catch((err) => {
                    console.error(`Error attempting to enter full-screen mode: ${err.message} (${err.name})`);
                });
        }
    },
    formatScheduleDateOnly(value) {
      const date = toWallClockDate(value);
      return date ? this.$filters.getDateOnly(date) : '-';
    },
    formatScheduleHebrewMonth(value) {
      const date = toWallClockDate(value);
      return date ? this.$filters.convertToHebrewMonthOnly(date) : '-';
    },
    // Donor-entered fields (title / name / inHonorOf …) may span multiple lines.
    // Convert their newlines to <br> so each line renders on the Display exactly
    // as it was typed in the donation modal (raw "\n" would otherwise collapse
    // to a single space inside the v-html template).
    multilineToHtml(value) {
      if (value == null) return '';
      return String(value).replace(/\r\n|\r|\n/g, '<br>');
    },
    // Every placeholder filled in one pass (utils/donation_template), so an
    // answer that happens to read "{name}" is never filled in again: each of
    // the template's fields takes the donation's answer (blank when it gave
    // none), or — for one that fills itself in — its date, written out as the
    // screen shows dates.
    renderDonationContent(template, donation) {
        return renderDonationTemplate(template, donation, {
            toHtml: this.multilineToHtml,
            dates: {
                displayStartDate: (record) => this.multilineToHtml(this.formatScheduleDateOnly(record.displayStartDate)),
                displayEndDate: (record) => this.multilineToHtml(this.formatScheduleDateOnly(record.displayEndDate)),
                donationDate: (record) => this.multilineToHtml(this.$filters.getDateOnly(record.createdAt)),
                month: (record) => this.formatScheduleHebrewMonth(record.displayStartDate),
            },
        });
    },
    renderMinyanimCountdownContent(minyanimCountdown) {
        let minyanimRooms = this.screen.artboards
        .flatMap(artboard => artboard.minyanims || [])
        .flatMap(type =>
          (type.minyanimRooms || []).map(room => ({
            ...room,
            minyanimTypeName: type.name, // <- comes from MinyanimType.name ("×©×—×¨×™×ª")
          }))
        );

        // let minyanimCountdown =  {
        //     id: "fd85a7ee-f2d0-40a6-8258-ca7871966f17",
        //     content: "<h3 class=\"ql-align-center\"><strong>{room} - {type} - {time} - {countdown}</strong></h3><p><br></p>",
        //     roomId: "e416f55c-c681-4c7c-a9cc-d1f76f3cd870",
        //     type: "MinyanimCountdown",
        //     screenId: "ba6688e2-3f25-4ce8-9867-d8668ff83a2c",
        //     screenArtboardId: "bc56d2c0-0083-4616-b912-93983b85ecad",
        //     organizationId: "02da9c28-bc31-4438-9fe1-afe3ea3b094a",
        //     isActive: true,
        //     isDeleted: false,
        //     createdBy: "c6b03a18-7f07-4399-97cf-406cb4d92533",
        //     createdAt: "2025-11-21T10:01:37.860Z"
        // }

        // BEFORE the reduce: "now" and each room time as minutes-of-day in the
        // org timezone, so the picked "next" room matches the displayed times.
        const nowMinutes = this.getOrgNowMinutes();

        let nextMinyanimRoom = minyanimRooms.reduce((closest, item) => {
          const itemMinutes = this.zmanMinutesOfDay(item.time);
          if (!Number.isFinite(itemMinutes)) return closest;

          // skip past times (earlier today)
          if (itemMinutes < nowMinutes) return closest;

          // if we don't have a candidate yet, take this one
          if (!closest) return item;

          const closestMinutes = this.zmanMinutesOfDay(closest.time);

          // pick the one whose TIME (HH:MM) is closer to now
          return itemMinutes < closestMinutes ? item : closest;
        }, null);


        if (!nextMinyanimRoom) {
          return '';
        }

        let content = minyanimCountdown?.content?.replace('{room}', nextMinyanimRoom.room.name)
        content = content?.replace('{type}', nextMinyanimRoom.minyanimTypeName)
        content = content?.replace('{time}', this.formatZmanClock(nextMinyanimRoom.time) || '-')
        
        const countdownStr = this.formatMinyanimCountdownTo(nextMinyanimRoom.time);
        content = content?.replace('{countdown}', countdownStr);

        return content;
    },
    formatMinyanimCountdownTo(time) {
      if (!time || !this.currentTime) return '';

      const now = this.currentTime;
      const src = new Date(time);
      if (Number.isNaN(src.getTime())) return '';

      // Build "now" and the target time as ms-of-day in the org timezone so the
      // countdown matches the org's location, not the display device. Seconds /
      // millis are timezone-independent (IANA offsets are whole minutes).
      const targetMinutes = this.zmanMinutesOfDay(time);
      if (!Number.isFinite(targetMinutes)) return '';
      const targetMsOfDay = targetMinutes * 60000 + src.getSeconds() * 1000 + src.getMilliseconds();
      const nowMsOfDay =
        this.getOrgNowMinutes(now) * 60000 + now.getSeconds() * 1000 + now.getMilliseconds();
      let diff = targetMsOfDay - nowMsOfDay;

      // If that time today already passed, clamp to zero
      if (diff <= 0) {
        return '00:00:00';
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    },

    // =====================================================================
    // Minyanim Roll — design rendering
    // ---------------------------------------------------------------------
    // Every helper below maps a control from the roll's Design tab onto the
    // live display, so editing the design is reflected one-to-one here.
    // The persisted shape is design.{displayView, grid, listText,
    // underlineText, highlight, countdown, header*, ...}.
    // =====================================================================

    // 'card' | 'list'. When the roll carries a displayView (i.e. it has been
    // saved by the design tab) we mirror the editor exactly — anything that
    // isn't 'list' is card view. Legacy rolls saved before displayView existed
    // keep their original list rendering.
    getRollViewMode(design) {
      if (!design?.displayView) return 'list';
      return design.displayView.viewMode === 'list' ? 'list' : 'card';
    },
    // Column count for both card and list layouts (1 | 2 | 3).
    getRollColumns(design) {
      const cols = Number(design?.displayView?.columns);
      return [1, 2, 3].includes(cols) ? cols : 1;
    },
    // List fill direction: 'vertical' (column-major) | 'horizontal' (row-major).
    // Right-hand list field. When neither side is configured we fall back to
    // the classic "name … time" row (name on the right in RTL).
    getRollRightField(design) {
      const dv = design?.displayView || {};
      if (dv.leftField || dv.rightField) return dv.rightField || '';
      return 'minyan';
    },
    getRollLeftField(design) {
      const dv = design?.displayView || {};
      if (dv.leftField || dv.rightField) return dv.leftField || '';
      return 'time';
    },
    // Time/Name divider: honour the explicit control; for legacy rolls saved
    // before displayView existed, keep the historical dotted leader.
    getRollDivider(design) {
      const value = design?.displayView?.timeNameDivider;
      if (value === 'none' || value === 'line' || value === 'dots') return value;
      return design?.showLeaderDots === false ? 'none' : 'dots';
    },
    getRollDividerClass(design) {
      const divider = this.getRollDivider(design);
      if (divider === 'dots') return 'minyanim-dots';
      if (divider === 'line') return 'roll-divider--line';
      return 'roll-divider--spacer';
    },
    // Row divider between list rows: 'line' | 'none'.
    getRollRowDivider(design) {
      const value = design?.displayView?.rowDivider;
      if (value === 'line' || value === 'none') return value;
      return design?.showRowDividers ? 'line' : 'none';
    },
    // Resolve a roll minyan's room id to a readable name. Falls back to the
    // raw value only when it isn't a room id (e.g. a legacy plain-text room);
    // an unresolved id is hidden rather than shown as a GUID.
    resolveRollRoomName(roomLocation) {
      if (!roomLocation) return '';
      const id = String(roomLocation);
      const name = this.minyanRollRoomNames[id];
      if (name) return name;
      const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
      return isUuid ? '' : id;
    },
    // The resolved time for one of a minyan's secondary timestamps
    // (bruches / hoidy / ashrei / borchy / netz). Empty when that toggle isn't
    // enabled or its anchor couldn't be resolved.
    getRollSecondaryTime(item, key) {
      const sec = this.getRollSecondaryTimes(item).find((s) => s.key === key);
      // Show the Hebrew name alongside the time (e.g. "ברכות 7:05") rather than
      // the bare time, so a selected display-toggle field is self-labelling.
      return sec ? `${sec.label} ${sec.time}` : '';
    },
    // Resolve a roll field/variable value for one minyan. Supports
    // {name} {room} {time} {countdown} plus one token per display toggle
    // ({bruches} {hoidy} {ashrei} {borchy} {netz}), and the roll-wide {parsha}.
    // ({minyan} is kept as a backward-compatible alias for {name}.)
    getRollFieldValue(item, field, design) {
      // Not per-minyan: the very parsha the Date/Time banner shows.
      if (field === 'parsha') return this.getSafeParshaName();
      if (!item || !field) return '';
      if (ROLL_SECONDARY_TIME_FIELDS.has(field)) return this.getRollSecondaryTime(item, field);
      switch (field) {
        case 'name':
        case 'minyan':
          return item.minyanName || item.name || '';
        case 'room':
          return item.roomName || this.resolveRollRoomName(item.roomLocation);
        case 'time':
          return this.formatRollTime(item);
        case 'countdown':
          return this.getRollCountdown(item, design);
        default:
          return '';
      }
    },
    // Resolve the selected countdown point for one minyan. Countdown targeting
    // is independent of whether its display-time toggle is on: the setting must
    // still work on legacy rows with no toggle flags. Missing offsets use the
    // same defaults as the display toggles; an unavailable sunrise makes Netz
    // fall back to this minyan's primary time rather than blanking the timer.
    getRollCountdownTargetMinutes(item, design) {
      return resolveRollCountdownTargetMinutes(
        item,
        design?.countdown?.target,
        {
          minyanMinutes: this.getRollItemMinutes(item),
          sunriseMinutes: this.getRollSunriseMinutes(item),
        }
      );
    },
    // The countdown target is independent of the highlighted next minyan. Pick
    // the soonest next occurrence of the selected point across all visible real
    // minyanim, so (for example) a Bruches countdown can keep running after that
    // minyan's base start time has arrived.
    getNextRollCountdownTarget(items, design) {
      const result = { index: -1, targetMinutes: Number.NaN };
      if (!Array.isArray(items) || !items.length || !this.currentTime) return result;
      let nearestDiffMs = Number.POSITIVE_INFINITY;
      const target = normalizeRollCountdownTarget(design?.countdown?.target);
      const candidates = items
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => !this.isRollTextItem(item));
      // Prefer rows explicitly designated for the selected milestone. If none
      // are designated (common on legacy data), every real minyan remains a
      // candidate and its saved/default offset still drives the countdown.
      const explicitlyEnabled = target === 'minyan'
        ? []
        : candidates.filter(({ item }) => (
          item?.[target] === true || item?.[target] === 1 || item?.[target] === 'true'
        ));
      const eligible = explicitlyEnabled.length ? explicitlyEnabled : candidates;
      eligible.forEach(({ item, index }) => {
        const targetMinutes = this.getRollCountdownTargetMinutes(item, design);
        if (!Number.isFinite(targetMinutes)) return;
        const diffMs = this.getOrgRollCountdownDiffMs(targetMinutes);
        if (Number.isFinite(diffMs) && diffMs < nearestDiffMs) {
          nearestDiffMs = diffMs;
          result.index = index;
          result.targetMinutes = targetMinutes;
        }
      });
      return result;
    },
    // Live countdown to the configured point on the next qualifying minyan. The
    // target rolls to tomorrow once today's occurrence has passed, and the
    // display is always HH:MM:SS.
    getRollCountdown(item, design) {
      if (!item || !this.currentTime) return '';
      const cd = design?.countdown;
      if (cd && cd.enabled === false) return '';
      let targetMinutes = Number.NaN;
      if (this.isRollTextItem(item)) {
        // Text headers have no milestone of their own; getRollGroups stamps the
        // selected next real minyan's already-resolved target onto them.
        targetMinutes = Number(item._rollCountdownTargetMinutes);
      } else if (item._isRollCountdownMinyan === true) {
        // Normal roll rows carry an explicit countdown tag, separate from the
        // next-minyan tag that drives Highlight styling.
        targetMinutes = Number(item._rollCountdownTargetMinutes);
        if (!Number.isFinite(targetMinutes)) {
          targetMinutes = this.getRollCountdownTargetMinutes(item, design);
        }
      } else if (item._isRollCountdownMinyan == null && item._isRollActiveMinyan) {
        // Upcoming Minyan templates are rendered outside getRollGroups and only
        // mark their selected row as active. Resolve the configured target here
        // so their {countdown} matches the roll and dashboard display.
        targetMinutes = this.getRollCountdownTargetMinutes(item, design);
      }
      if (!Number.isFinite(targetMinutes)) return '';
      const diffMs = this.getOrgRollCountdownDiffMs(targetMinutes);
      if (!Number.isFinite(diffMs) || diffMs <= 0) return '';
      // Countdown Time window: when enabled, the {countdown} only appears once
      // the next minyan is within `minutesBefore` minutes — outside that window
      // it stays empty. (minutesBefore <= 0 / unset means no window: always on.)
      const minutesBefore = Number(cd && cd.minutesBefore);
      if (Number.isFinite(minutesBefore) && minutesBefore > 0 && diffMs > minutesBefore * 60000) {
        return '';
      }
      return formatRollCountdown(diffMs / 1000);
    },
    // Inline style for the {countdown} variable: Countdown Color as the badge
    // background, Countdown Text Color as its text. These countdown colours apply
    // in List view only (matching the design tab, which only offers them there);
    // in Card view the countdown still shows but unstyled, so return no style.
    getRollCountdownStyle(design) {
      if (this.getRollViewMode(design) !== 'list') return {};
      const cd = design?.countdown || {};
      const style = {};
      const textColor = cd.textColorCountdown || cd.color;
      if (textColor) style.color = textColor;
      if (cd.backgroundColor) {
        style.backgroundColor = cd.backgroundColor;
        style.padding = '1px 8px';
        style.borderRadius = '6px';
        style.display = 'inline-block';
      }
      return style;
    },
    // Same styling as a CSS string, for injecting the {countdown} badge into the
    // grid cell HTML (renderRollCellHtml). List view only, mirroring
    // getRollCountdownStyle.
    getRollCountdownCss(design) {
      if (this.getRollViewMode(design) !== 'list') return '';
      const cd = design?.countdown || {};
      let css = '';
      const textColor = cd.textColorCountdown || cd.color;
      if (textColor) css += `color:${textColor};`;
      if (cd.backgroundColor) {
        css += `background-color:${cd.backgroundColor};padding:1px 8px;border-radius:6px;display:inline-block;`;
      }
      return css;
    },
    // Highlight styling applied to the NEXT (upcoming) minyan. The Highlight Time
    // (highlight.minutesBefore) is how many minutes BEFORE that minyan arrives the
    // highlight turns on; "Always" (0/unset) keeps it highlighted the whole time
    // it is the next minyan. The toggle (enabled) turns the highlight off entirely.
    rollHighlightStyle(design, item) {
      const hl = design?.highlight;
      if (!hl || hl.enabled === false || !item) return {};
      if (!item._isRollActiveMinyan) return {};
      const windowBefore = Number(hl.minutesBefore);
      if (Number.isFinite(windowBefore) && windowBefore > 0 && this.currentTime) {
        const minutes = this.getRollItemMinutes(item);
        if (Number.isFinite(minutes)) {
          // Time remaining until the next minyan, measured in the org timezone so
          // the window matches the on-screen clock. Only highlight once we are
          // within `windowBefore` minutes of it arriving.
          const diffMs = this.getOrgRollCountdownDiffMs(minutes);
          if (!Number.isFinite(diffMs) || diffMs > windowBefore * 60000) return {};
        }
      }
      const style = {};
      if (hl.colorBackground) style.backgroundColor = hl.backgroundColor || hl.activeColor;
      const highlightText = hl.textColorHighlight || hl.textColor;
      if (highlightText) style.color = highlightText;
      return style;
    },
    // "Started" styling applied to the CURRENT minyan (the one whose time has just
    // arrived). Started Color shows from the minyan's start and lasts for the
    // Started Time window (started.minutesAfter minutes), measured in the org
    // timezone so it matches the on-screen clock; "Always" (0/unset) keeps it on
    // for as long as it is the current minyan. The toggle (enabled) turns it off
    // entirely. Distinct from the highlight, which marks the NEXT (upcoming) minyan.
    rollStartedStyle(design, item) {
      const st = design?.started;
      if (!st || st.enabled === false || !item) return {};
      if (!item._isRollCurrentMinyan) return {};
      const minutes = this.getRollItemMinutes(item);
      if (!Number.isFinite(minutes)) return {};
      const windowAfter = Number(st.minutesAfter);
      if (Number.isFinite(windowAfter) && windowAfter > 0 && this.currentTime) {
        // Minutes since the minyan started, in the org timezone (same space that
        // picks the current minyan). Outside [0, windowAfter) the colour is off.
        const elapsed = this.getOrgNowMinutes() - minutes;
        if (!(elapsed >= 0 && elapsed < windowAfter)) return {};
      }
      const style = {};
      if (st.backgroundColor) style.backgroundColor = st.backgroundColor;
      if (st.textColorStarted) style.color = st.textColorStarted;
      return style;
    },
    // A text-type roll item always shows its own rich-text body. A selected zman
    // only feeds the timing (display time / upcoming highlight) through
    // getRollItemMinutes — it never replaces what is shown, which is the rich text.
    // The body is placed inside the normal card (card view) or row (list view),
    // so it inherits the same chrome and highlight as the other minyanim.
    getRollTextHtml(item, design) {
      const html = item && item.content;
      if (html && String(html).trim()) {
        return this.renderRollCellHtml(html, item, design);
      }
      return this.escapeRollHtml((item && (item.minyanName || item.name)) || '');
    },
    // Group minyanim under section headers (by minyan name) when enabled,
    // otherwise return a single unlabelled group. Items stay time-sorted.
    // A free-text minyan item (added via the "Text" button). These never get a
    // grouping header of their own.
    isRollTextItem(item) {
      return item?.itemType === 'text' || item?.kind === 'text' || item?.type === 'text';
    },
    // Split a group's items into ordered render segments so a Text-type minyan
    // acts as a full-width header that splits the surrounding minyanim. Each text
    // item is its own { type: 'text', item } segment; consecutive non-text
    // minyanim are batched into a { type: 'minyanim', items } segment (rendered as
    // a card grid or list). Same result in card and list view.
    getRollItemSegments(items) {
      const list = Array.isArray(items) ? items : [];
      const segments = [];
      let run = null;
      list.forEach((item, idx) => {
        if (this.isRollTextItem(item)) {
          run = null;
          segments.push({ type: 'text', key: `t-${item.id ?? idx}`, item });
        } else {
          if (!run) {
            run = { type: 'minyanim', key: `m-${item.id ?? idx}`, items: [] };
            segments.push(run);
          }
          run.items.push(item);
        }
      });
      return segments;
    },
    // The "current" minyan (the latest whose time has arrived) and the "next"
    // minyan (the earliest still upcoming) among a roll's visible items, wrapping
    // the next to the day's earliest once every minyan has passed. These tags
    // drive Highlight/Started; the independently configurable countdown target
    // is selected by getNextRollCountdownTarget.
    getRollActiveMinyanIndices(items) {
      const result = { currentIdx: -1, nextIdx: -1 };
      if (!Array.isArray(items) || !items.length || !this.currentTime) return result;
      const nowMinutes = this.getOrgNowMinutes();
      let nextDiffMs = Number.POSITIVE_INFINITY;
      let currentMinutes = Number.NEGATIVE_INFINITY;
      items.forEach((item, idx) => {
        const minutes = this.getRollItemMinutes(item);
        if (!Number.isFinite(minutes)) return;
        if (minutes <= nowMinutes && minutes > currentMinutes) {
          currentMinutes = minutes;
          result.currentIdx = idx;
        }
        if (!this.isRollTextItem(item)) {
          const diffMs = this.getOrgRollCountdownDiffMs(minutes);
          if (Number.isFinite(diffMs) && diffMs < nextDiffMs) {
            nextDiffMs = diffMs;
            result.nextIdx = idx;
          }
        }
      });
      return result;
    },
    getRollGroups(roll, artboard) {
      const design = roll?.design || {};
      const rawItems = this.getVisibleRollMinyanim(roll, artboard);
      // Highlight still follows the next base minyan. Countdown separately picks
      // the next occurrence of its configured Minyan/Bruches/Hoidy/Netz point.
      // Shallow copies keep the screen payload's shared item objects untouched.
      const { currentIdx, nextIdx } = this.getRollActiveMinyanIndices(rawItems);
      const countdown = this.getNextRollCountdownTarget(rawItems, design);
      const items = rawItems.map((item, i) => {
        const tagged = {
          ...item,
          // Text blocks read the shared numeric target; real rows additionally
          // use this explicit boolean to distinguish Countdown from Highlight.
          _rollCountdownTargetMinutes: countdown.targetMinutes,
          _isRollCountdownMinyan: i === countdown.index,
        };
        if (i === currentIdx) tagged._isRollCurrentMinyan = true;
        if (i === nextIdx) tagged._isRollActiveMinyan = true;
        return tagged;
      });
      if (!design.showGroupHeaders) {
        return [{ key: '__all', label: '', items }];
      }
      // Group minyanim under a header keyed by their name, with one exception:
      // text-type minyanim are never grouped — each becomes its own header-less
      // group so no section header renders above it.
      const groups = [];
      const labelGroups = new Map();
      let textCount = 0;
      for (const item of items) {
        if (this.isRollTextItem(item)) {
          groups.push({ key: `__text-${textCount += 1}`, label: '', items: [item] });
          continue;
        }
        const label = this.getRollFieldValue(item, 'minyan', design) || 'מנינים';
        let group = labelGroups.get(label);
        if (!group) {
          group = { key: label, label, items: [] };
          labelGroups.set(label, group);
          groups.push(group);
        }
        group.items.push(item);
      }
      return groups;
    },
    // Outer wrapper: base typography (fonts have no per-field UI, so they come
    // from the saved design defaults).
    getRollContainerStyle(design) {
      if (!design) return {};
      return {
        fontFamily: design.fontFamily ? design.fontFamily + ', sans-serif' : undefined,
        fontSize: design.fontSize ? design.fontSize + 'px' : undefined,
        fontWeight: design.fontWeight || undefined,
      };
    },
    getRollTitleStyle(design) {
      if (!design) return {};
      return {
        fontSize: (Number(design.titleFontSize) || 18) + 'px',
        color: design.titleColor || '#1a1a1a',
      };
    },
    getRollHeaderStyle(design) {
      if (!design) return {};
      return {
        fontFamily: design.headerFontFamily ? design.headerFontFamily + ', sans-serif' : undefined,
        fontSize: (Number(design.headerFontSize) || 16) + 'px',
        color: design.headerColor || '#1a1a1a',
        textAlign: design.headerAlignment || 'center',
      };
    },
    // List container — the bordered box plus the column grid (and fill order).
    getRollListStyle(design) {
      if (!design) return {};
      // List view is a flat list: no card box (background/border/radius/padding)
      // around the rows — only the optional multi-column layout below.
      const style = {};
      const cols = this.getRollColumns(design);
      if (cols > 1) {
        style.display = 'grid';
        style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
        style.columnGap = '18px';
        // The list container is dir="rtl", so row flow fills each line right
        // to left (1st item top-right, 2nd to its left, 3rd starts the next
        // line) — never top-to-bottom columns.
        style.gridAutoFlow = 'row';
      }
      return style;
    },
    // Per-row styling: row divider + highlight.
    getRollRowStyle(design, item, idx, total) {
      const style = {};
      if (this.getRollRowDivider(design) === 'line' && idx < total - 1) {
        style.borderBottom = '1px solid ' + (design?.borderColor || 'currentColor');
      }
      Object.assign(style, this.rollHighlightStyle(design, item));
      Object.assign(style, this.rollStartedStyle(design, item));
      return style;
    },
    // Font/size/color for a list field. Row sides always use the list
    // typography; the underline field renders as its own centered line below.
    getRollSideStyle(design, field) {
      if (!design || !field) return {};
      const src = design.listText;
      const style = {};
      if (src) {
        if (src.fontFamily) style.fontFamily = src.fontFamily;
        if (src.fontSize) style.fontSize = src.fontSize + 'px';
        if (src.textColor) style.color = src.textColor;
      }
      return style;
    },
    // The list field whose value is shown, underlined and centered, beneath each
    // row (e.g. {name}/{room}/{time}/...). Empty when none is selected.
    // The selected Underline fields (up to 3), tolerating the legacy single
    // `underlineField` string from rolls saved before multi-select.
    getRollUnderlineFields(design) {
      const dv = design?.displayView || {};
      const fields = Array.isArray(dv.underlineFields)
        ? dv.underlineFields
        : (dv.underlineField ? [dv.underlineField] : []);
      return fields.filter(Boolean).slice(0, 3);
    },
    // Their resolved, non-empty values for one minyan — what renders side by side.
    getRollUnderlineValues(item, design) {
      return this.getRollUnderlineFields(design)
        .map((field) => this.getRollFieldValue(item, field, design))
        .filter((value) => value !== '' && value != null);
    },
    getRollUnderlineStyle(design) {
      const src = design?.underlineText || {};
      // Inline the font/color so they survive the display context (the roll
      // renders inside Quill's .ql-editor, which forces text-align:left). Layout
      // (centering, side-by-side, underline) is handled by the scoped classes.
      const style = {};
      if (src.fontFamily) style.fontFamily = src.fontFamily;
      if (src.fontSize) style.fontSize = src.fontSize + 'px';
      if (src.textColor) style.color = src.textColor;
      return style;
    },
    // Card grid container — one row of `columns` cards.
    getRollCardsContainerStyle(design) {
      const cols = this.getRollColumns(design);
      // 3 columns render on a 6-sub-column grid so a trailing partial row (1 or 2
      // cards) can be centered; every card spans 2 sub-columns, which makes full
      // rows pixel-identical to a plain 3-column grid. Other counts use one grid
      // column per card. (See getRollCardGridStyle for per-card placement.)
      const templateCols = cols === 3 ? 6 : cols;
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${templateCols}, minmax(0, 1fr))`,
        gap: '12px',
        alignItems: 'stretch',
        width: '100%',
      };
    },
    getRollCardBackgroundColor(design) {
      const color = String(design?.backgroundColor || '').trim();
      if (color.toLowerCase() === 'transparent') return 'transparent';
      return color || '#ffffff';
    },
    // Individual card — border/background/radius from the Typography & Colors
    // card, plus highlight when active.
    getRollCardStyle(design, item, idx, total) {
      const style = {
        borderColor: design?.borderColor || '#e5e7eb',
        borderRadius: (design?.borderRadius != null ? Number(design.borderRadius) : 8) + 'px',
        backgroundColor: this.getRollCardBackgroundColor(design),
        padding: this.getRollCardPadding(design?.cardPadding),
      };
      Object.assign(style, this.rollHighlightStyle(design, item));
      Object.assign(style, this.rollStartedStyle(design, item));
      Object.assign(style, this.getRollCardGridStyle(design, idx, total));
      return style;
    },
    // Per-card grid placement so a trailing partial row is centered instead of
    // hanging to one side (card view only). RTL-safe — the placements are
    // symmetric, so centering reads the same in either direction.
    //
    //  • 2 columns: an odd count leaves the last card alone → span both columns
    //    but keep it one column wide and centered.
    //  • 3 columns: laid out on a 6-sub-column grid (each card spans 2), so full
    //    rows match a plain 3-column grid. A final row of 1 card centers in the
    //    middle; a final row of 2 cards centers as a pair (sub-columns 2–3 & 4–5).
    //
    // The 12px matches the grid gap in getRollCardsContainerStyle.
    getRollCardGridStyle(design, idx, total) {
      if (this.getRollViewMode(design) !== 'card') return {};
      if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(idx)) return {};
      const cols = this.getRollColumns(design);

      if (cols === 2) {
        if (total % 2 === 1 && idx === total - 1) {
          return { gridColumn: '1 / -1', justifySelf: 'center', width: 'calc((100% - 12px) / 2)' };
        }
        return {};
      }

      if (cols === 3) {
        const remainder = total % 3;
        const fullCount = total - remainder; // cards filling complete rows
        if (idx < fullCount) {
          // Full-row card → its natural slot: sub-columns 1 / 3 / 5.
          return { gridColumn: `${(idx % 3) * 2 + 1} / span 2`, gridRow: String(Math.floor(idx / 3) + 1) };
        }
        // Leftover card(s) in the final, incomplete row — centered.
        const lastRow = String(fullCount / 3 + 1);
        if (remainder === 1) {
          return { gridColumn: '3 / span 2', gridRow: lastRow }; // dead center
        }
        // remainder === 2 → centered pair: sub-columns 2–3 and 4–5.
        const posInLast = idx - fullCount; // 0 (right, RTL) or 1 (left)
        return { gridColumn: posInLast === 0 ? '2 / span 2' : '4 / span 2', gridRow: lastRow };
      }

      return {};
    },
    // Normalize a roll card's padding ("Vpx Hpx") with the same rules as the
    // Zmanim card padding so a roll renders identically to its design tab.
    getRollCardPadding(value) {
      const raw = String(value ?? '').trim().replace(/\s+/g, ' ');
      if (!raw) return '12px 14px';
      const tokens = raw.split(' ');
      if (tokens.length > 4) return '12px 14px';
      const normalizedTokens = tokens.map((token) => {
        const match = token.match(/^(\d+(?:\.\d+)?)(px)?$/i);
        if (!match) return null;
        const numericValue = Math.min(Math.max(Number(match[1]), 0), 200);
        const normalizedValue = Number.isInteger(numericValue)
          ? String(numericValue)
          : String(Number(numericValue.toFixed(2)));
        return `${normalizedValue}px`;
      });
      return normalizedTokens.every(Boolean) ? normalizedTokens.join(' ') : '12px 14px';
    },
    // Whether the card should use the grid-designer template. Any layout
    // (including "No Grid", a single free-form area) qualifies as long as at
    // least one cell actually has content; otherwise we fall back to the
    // simple name/time card.
    rollHasGrid(design) {
      const grid = design?.grid;
      if (!grid || !grid.layout) return false;
      if (!Array.isArray(grid.cells) || !grid.cells.length) return false;
      return grid.cells.some((cell) => this.rollCellHasContent(cell));
    },
    rollCellHasContent(html) {
      if (!html) return false;
      const raw = String(html);
      if (ROLL_FIELD_TOKEN_REGEX.test(raw)) return true;
      if (/<img\b/i.test(raw)) return true;
      const text = raw.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
      return text.length > 0;
    },
    getRollGridCells(design) {
      const grid = design?.grid || {};
      const layout = ROLL_GRID_LAYOUTS[grid.layout];
      const cells = Array.isArray(grid.cells) ? grid.cells : [];
      const count = layout ? layout.cells : cells.length;
      const out = [];
      for (let i = 0; i < count; i += 1) out.push(cells[i] || '');
      return out;
    },
    getRollGridContainerStyle(design) {
      const layout = ROLL_GRID_LAYOUTS[design?.grid?.layout];
      return {
        display: 'grid',
        gap: '8px',
        width: '100%',
        ...(layout ? layout.container : { gridTemplateColumns: '1fr' }),
      };
    },
    getRollGridCellStyle(design, idx) {
      const layout = ROLL_GRID_LAYOUTS[design?.grid?.layout];
      const style = { ...((layout && layout.cellStyles && layout.cellStyles[idx]) || {}) };
      // Per-cell { v, h } padding (px) set via the grid designer's V/H steppers.
      const pad = Array.isArray(design?.grid?.cellPaddings) ? design.grid.cellPaddings[idx] : null;
      if (pad) {
        const clampPad = (n) => Math.min(99, Math.max(0, Math.round(Number(n)) || 0));
        style.padding = `${clampPad(pad.v)}px ${clampPad(pad.h)}px`;
      }
      return style;
    },
    // Substitute the per-minyan variables into a grid cell's rich-text HTML.
    renderRollCellHtml(cellHtml, item, design) {
      const html = String(cellHtml || '');
      return html.replace(ROLL_FIELD_TOKEN_REGEX_GLOBAL, (_, key) => {
        const value = this.escapeRollHtml(this.getRollFieldValue(item, key, design) || '');
        // The {countdown} variable carries its own colours (Countdown Color /
        // Countdown Text Color); every other variable inherits the cell's style.
        if (key === 'countdown' && value) {
          const css = this.getRollCountdownCss(design);
          return css ? `<span style="${css}">${value}</span>` : value;
        }
        return value;
      });
    },
    escapeRollHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    // Format a resolved zman ISO as the roll clock, snapping Shabbos dynamic
    // minyanim to their "Round Start Time To" grid so the shown time matches the
    // rounded sort / secondary / countdown values computed in getRollItemMinutes.
    formatRollZmanClock(iso, item) {
      const grid = Number(item?._roundToMinutes) || 0;
      if (grid > 0) {
        const minutes = this.zmanMinutesOfDay(iso);
        if (Number.isFinite(minutes)) {
          return formatClockFromMinutes(roundMinutesToGridDirectional(minutes, grid, item?._roundDirection)) || '--:--';
        }
      }
      return this.formatZmanClock(iso) || '--:--';
    },
    formatRollTime(item) {
      if (!item) return '';
      if (item.timingMode === 'fixed') {
        return this.formatPlainTime(item.fixedTime);
      }
      if (item.timingMode === 'zmanim' && item.zmanimKey) {
        const offset = item.offsetMinutes ?? item.zmanimOffsetMinutes;
        let iso = '';
        if (item._shabbosAnchor) {
          iso = this.resolveShabbosAnchorZmanDateTime(item.zmanimKey, item._shabbosAnchor, offset);
          // Anchors not ready yet — fall through to the standard resolver.
        }
        // Use the real kosher-zmanim value for this zman, computed from the
        // organization's lat/lng. Prefer the exact resolver (prebuilt lookup or a
        // direct calendar getter); fall back to the legacy resolver only if that
        // misses, so the {time} variable shows the true minyan time. Format in the
        // org timezone so the clock matches the org's location, not the device.
        if (!iso) {
          iso =
            this.resolveRollZmanDateTime(item.zmanimKey, offset) ||
            this.getResolvedZmanDateTime(item.zmanimKey, offset);
        }
        return iso ? this.formatRollZmanClock(iso, item) : '--:--';
      }
      // Weekly Static Zman: show the week's (Sun–Fri) Min/Max clock time after
      // the minyan's ± Offset and its grid + direction rounding — the same
      // pipeline getRollItemMinutes uses, so the shown clock, sort, secondary
      // times and countdown always agree.
      if (isWeeklyZmanTimingMode(item.timingMode) && item.zmanimKey) {
        const iso = this.resolveWeeklyStaticZmanDateTime(item.zmanimKey, getMinyanWeeklyZmanMode(item));
        if (!iso) return '--:--';
        const minutes = this.zmanMinutesOfDay(iso);
        if (Number.isFinite(minutes)) {
          return formatClockFromMinutes(resolveWeeklyZmanMinutes(item, minutes)) || '--:--';
        }
        return this.formatZmanClock(iso) || '--:--';
      }
      if (item.timing?.mode === 'fixed') {
        const time = item.timing.fixed?.time || '';
        if (!time) return '';
        const [h, m] = time.split(':').map(Number);
        const period = h >= 12 ? 'PM' : 'AM';
        const hour12 = h % 12 || 12;
        return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
      }
      const z = item.timing?.zmanim;
      if (!z) return '';
      const iso = this.getResolvedZmanDateTime(z.zman, z.offsetMinutes);
      return iso ? (this.formatZmanClock(iso) || '--:--') : '--:--';
    },
    formatPlainTime(time) {
      if (!time) return '';
      const match = String(time).match(/^(\d{2}):(\d{2})(?::\d{2})?$/);
      if (!match) return '';

      const h = Number(match[1]);
      const m = Number(match[2]);
      if (!Number.isFinite(h) || !Number.isFinite(m)) return '';

      const hour12 = h % 12 || 12;
      return `${hour12}:${String(m).padStart(2, '0')}`;
    },
    normalizeKosherZmanimKey(methodName) {
      if (!methodName?.startsWith('get')) return '';
      const key = methodName.slice(3);
      return key ? key.charAt(0).toLowerCase() + key.slice(1) : '';
    },
    buildKosherZmanimMap(zmanimCalendar) {
      if (!zmanimCalendar) return {};

      const toIso = (v) => {
        if (!v) return '';
        if (v instanceof Date) return Number.isNaN(v.getTime()) ? '' : v.toISOString();
        if (typeof v.toISO === 'function' && v.isValid !== false) return v.toISO() || '';
        if (typeof v.toJSDate === 'function') {
          const d = v.toJSDate();
          return d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString() : '';
        }
        return '';
      };

      const kosherZmanimMap = {};
      const visitedMethods = new Set();
      let proto = Object.getPrototypeOf(zmanimCalendar);

      while (proto && proto !== Object.prototype) {
        Object.getOwnPropertyNames(proto).forEach((methodName) => {
          if (visitedMethods.has(methodName) || !methodName.startsWith('get')) return;
          visitedMethods.add(methodName);

          const method = zmanimCalendar[methodName];
          if (typeof method !== 'function' || method.length > 0) return;

          try {
            const iso = toIso(method.call(zmanimCalendar));
            if (iso) {
              const normalizedKey = this.normalizeKosherZmanimKey(methodName);
              if (normalizedKey) {
                kosherZmanimMap[normalizedKey] = iso;
              }
            }
          } catch (error) {
            // Some getters are not valid for every location/date; skip them quietly.
          }
        });

        proto = Object.getPrototypeOf(proto);
      }

      const sunrise = kosherZmanimMap.sunrise || kosherZmanimMap.seaLevelSunrise || '';
      const sunset = kosherZmanimMap.sunset || kosherZmanimMap.seaLevelSunset || '';
      const aliasMap = {
        alosHashachar: ['alosHashachar', 'alos72'],
        alotHaShachar: ['alosHashachar', 'alos72'],
        dawn: ['alosHashachar', 'alos72'],
        misheyakir: ['misheyakir11Point5Degrees', 'misheyakir11Degrees'],
        misheyakirMachmir: ['misheyakir11Degrees', 'misheyakir10Point2Degrees'],
        sunrise: ['sunrise', 'seaLevelSunrise'],
        sofZmanShmaMGA19Point8: ['sofZmanShmaMGA19Point8Degrees'],
        sofZmanShmaMGA16Point1: ['sofZmanShmaMGA16Point1Degrees'],
        sofZmanShmaMGA: ['sofZmanShmaMGA'],
        sofZmanShma: ['sofZmanShmaGRA', 'sofZmanShma'],
        sofZmanShmaGra: ['sofZmanShmaGRA', 'sofZmanShma'],
        sofZmanTfillaMGA19Point8: ['sofZmanTfilaMGA19Point8Degrees'],
        sofZmanTfillaMGA16Point1: ['sofZmanTfilaMGA16Point1Degrees'],
        sofZmanTfillaMGA: ['sofZmanTfilaMGA'],
        sofZmanTfilla: ['sofZmanTfilaGRA', 'sofZmanTfila'],
        chatzot: ['chatzos'],
        chatzotNight: ['solarMidnight', 'midnightTonight'],
        minchaGedola: ['minchaGedola'],
        minchaKetana: ['minchaKetana'],
        plagHaMincha: ['plagHamincha'],
        sunset: ['sunset', 'seaLevelSunset'],
        tzeis: ['tzais'],
        tzeit7083deg: ['tzaisGeonim7Point083Degrees'],
        tzeit85deg: ['tzaisGeonim8Point5Degrees'],
        tzeit50min: ['tzais50'],
        tzeit72min: ['tzais72'],
        afterSunset60: ['tzais60'],
      };

      Object.entries(aliasMap).forEach(([key, candidateKeys]) => {
        const value = candidateKeys.map((candidateKey) => kosherZmanimMap[candidateKey]).find(Boolean);
        if (value) {
          kosherZmanimMap[key] = value;
        }
      });

      if (!kosherZmanimMap.hanachatTefillin) {
        kosherZmanimMap.hanachatTefillin =
          kosherZmanimMap.misheyakir ||
          (sunrise ? this.addMinutesWithOffset(sunrise, -50) : '');
      }

      if (!kosherZmanimMap.plagMinchaMGA90 && kosherZmanimMap.plagHamincha90Minutes) {
        kosherZmanimMap.plagMinchaMGA90 = kosherZmanimMap.plagHamincha90Minutes;
      }

      if (!kosherZmanimMap.afterSunset60) {
        kosherZmanimMap.afterSunset60 =
          kosherZmanimMap.tzais60 ||
          (sunset ? this.addMinutesWithOffset(sunset, 60) : '');
      }

      if (!kosherZmanimMap.chatzotNight && kosherZmanimMap.chatzos) {
        kosherZmanimMap.chatzotNight = this.addMinutesISO(kosherZmanimMap.chatzos, 12 * 60);
      }

      if (!kosherZmanimMap.misheyakir22Min && kosherZmanimMap.alos72) {
        kosherZmanimMap.misheyakir22Min = this.addMinutesISO(kosherZmanimMap.alos72, 22);
      }

      // "משיכיר -60 דקות" = Sunrise (Visible/Elevated) − 60 min. Uses the same
      // base (sunrise) the Zmanim_N editor resolves so preview and display agree.
      if (!kosherZmanimMap.misheyakirMinus60 && sunrise) {
        kosherZmanimMap.misheyakirMinus60 = this.addMinutesISO(sunrise, -60);
      }

      // "מוצאי שבת לאנדאן" — Tzeis 8.5° vs Tzeis 72 (R"T), picked by the shared
      // three-case rule in utils/motzei_shabbos_london.ts. Both bases are read
      // straight off the calendar when the 0-arg scan above didn't capture them,
      // so display, dashboard and the Zmanim_N editor preview always agree.
      if (!kosherZmanimMap[MOTZEI_SHABBOS_LONDON_KEY]) {
        const londonIso = resolveMotzeiShabbosLondonFrom((baseKey) => {
          if (kosherZmanimMap[baseKey]) return kosherZmanimMap[baseKey];
          const getter = zmanimCalendar[`get${baseKey.charAt(0).toUpperCase()}${baseKey.slice(1)}`];
          if (typeof getter !== 'function') return '';
          try {
            return toIso(getter.call(zmanimCalendar));
          } catch (error) {
            return '';
          }
        });
        if (londonIso) kosherZmanimMap[MOTZEI_SHABBOS_LONDON_KEY] = londonIso;
      }

      return Object.fromEntries(Object.entries(kosherZmanimMap).filter(([, value]) => Boolean(value)));
    },
    // --- Shabbos Schedule Engine (Weekly Static Lock) ---
    isShabbosRollType(type) {
      return type === 'shabbos' || type === 'shabbos_strict';
    },
    normalizeShabbosAnchor(value) {
      return ['friday', 'shabbos', 'motzei'].includes(value) ? value : 'shabbos';
    },
    // The upcoming weekend's anchor dates, locked per week: every day from this
    // week's Sunday through Saturday resolves to the same Friday / Saturday, so
    // the schedule "regenerates" each Sunday and never shifts mid-week.
    getShabbosWeekAnchors(now = this.currentTime || new Date()) {
      // The screen's own day at local noon: noon avoids DST / midnight
      // date-boundary ambiguity when the kosher-zmanim calendar reads the
      // date's Y/M/D.
      const base = this.getScreenCivilDate(now);
      if (!base) return null;
      const sunday = new Date(base);
      sunday.setDate(base.getDate() - base.getDay()); // most recent Sunday (today if Sunday)
      const friday = new Date(sunday);
      friday.setDate(sunday.getDate() + 5);
      const shabbos = new Date(sunday);
      shabbos.setDate(sunday.getDate() + 6);
      const pad = (n) => String(n).padStart(2, '0');
      const weekKey = `${sunday.getFullYear()}-${pad(sunday.getMonth() + 1)}-${pad(sunday.getDate())}`;
      return { sunday, friday, shabbos, weekKey };
    },
    // Build a zmanim map for one anchor date, reusing the same builder as the
    // live (today) map so the value format is identical, then add the synthetic
    // Shabbos keys (candle lighting / motzei) for that specific date.
    buildAnchorZmanimMapForDate(date) {
      const cal = this._kosherZmanimCalendar;
      if (!cal || !date) return null;
      try {
        cal.setDate(date);
        const map = this.buildKosherZmanimMap(cal);
        const sunset = map.sunset || map.seaLevelSunset || '';
        // The org-wide Settings → Special Zmanim configuration wins for this
        // anchor day's candle / motzei (resolved against THIS date's sunset, and
        // the calendar which is already set to it). When it isn't configured the
        // built-in defaults below are kept exactly as before.
        if (!map.shabbatHadlukasHaneiros) {
          const candleIso = this.resolveSpecialZmanSettingsIso(SPECIAL_ZMAN_CANDLE_KEY, sunset, cal);
          if (candleIso) {
            map.shabbatHadlukasHaneiros = candleIso;
          } else if (sunset) {
            map.shabbatHadlukasHaneiros = this.addMinutesISO(sunset, -SHABBOS_CANDLE_OFFSET_MINUTES);
          }
        }
        if (!map.shabbatMotzei) {
          map.shabbatMotzei =
            this.resolveSpecialZmanSettingsIso(SPECIAL_ZMAN_MOTZEI_KEY, sunset, cal) ||
            map.tzeis || map.tzais || map.tzeit72min || map.tzeit50min ||
            (sunset ? this.addMinutesISO(sunset, SHABBOS_MOTZEI_OFFSET_MINUTES) : '');
        }
        return map;
      } catch (error) {
        return null;
      }
    },
    // Ensure the Friday / Shabbos anchor maps exist for the current week. Cheap
    // no-op when already built for this week. Must be called outside render
    // (it mutates reactive state) — done on zmanim load and the 5-minute refresh.
    ensureShabbosAnchorZmanim() {
      const cal = this._kosherZmanimCalendar;
      if (!cal) return false;
      const anchors = this.getShabbosWeekAnchors();
      if (!anchors) return false;
      if (
        this._shabbosAnchorWeekKey === anchors.weekKey &&
        this.fridayAnchorZmanim &&
        this.shabbosAnchorZmanim
      ) {
        return true;
      }
      const original = cal.getDate();
      const friday = this.buildAnchorZmanimMapForDate(anchors.friday);
      const shabbos = this.buildAnchorZmanimMapForDate(anchors.shabbos);
      // Restore the live date so later calculations off the shared calendar
      // (e.g. degree-based motzei) keep operating on today.
      try { cal.setDate(original); } catch (error) { /* noop */ }
      if (!friday || !shabbos) return false;
      this.fridayAnchorZmanim = friday;
      this.shabbosAnchorZmanim = shabbos;
      this._shabbosAnchorWeekKey = anchors.weekKey;
      return true;
    },
    getShabbosAnchorMap(anchor) {
      // 'friday' uses the Friday date; 'shabbos' (day) and 'motzei' (Saturday
      // night) both resolve on the Saturday anchor date.
      return anchor === 'friday' ? this.fridayAnchorZmanim : this.shabbosAnchorZmanim;
    },
    // Resolve a dynamic zman against a locked weekend anchor date. Returns an
    // ISO instant (UTC) just like the live zmanim map, or '' when anchors aren't
    // ready yet (caller falls back to the standard resolver).
    resolveShabbosAnchorZmanDateTime(zmanimKey, anchor, customOffsetMinutes = 0) {
      if (!zmanimKey) return '';
      const map = this.getShabbosAnchorMap(this.normalizeShabbosAnchor(anchor));
      if (!map) return '';
      const extraOffset = Number(customOffsetMinutes) || 0;
      const direct = map[zmanimKey];
      if (direct) {
        return extraOffset ? this.addMinutesISO(direct, extraOffset) : direct;
      }
      // Fallback for keys not present in the map: offset from the anchor day's
      // sunrise, mirroring getComputedZmanDateTime but anchored to that date.
      const sunrise = map.sunrise || '';
      if (!sunrise) return '';
      const baseOffset = Number(ZMANIM_ENGLISH_OFFSETS[zmanimKey]);
      const totalOffset = (Number.isFinite(baseOffset) ? baseOffset : 0) + extraOffset;
      return this.addMinutesISO(sunrise, totalOffset);
    },
    // --- Weekly Static Zman (Max/Min across Sunday–Friday) ---
    // The week a Weekly Static Zman minyan scans: Sunday through Friday of the
    // week today is in, in the org's calendar — from Sunday midnight to Friday
    // midnight (getWeeklyZmanWeekDates, shared with the editor preview). On
    // Shabbos it is still the week that began the Sunday before. weekKey (that
    // Sunday) identifies the week, so cached values regenerate at Sunday
    // midnight.
    getWeeklyStaticWeekAnchor(now = this.currentTime || new Date()) {
      const base = this.getScreenCivilDate(now);
      if (!base) return null;
      const dates = getWeeklyZmanWeekDates(base);
      const sunday = dates[0];
      const pad = (n) => String(n).padStart(2, '0');
      const weekKey = `${sunday.getFullYear()}-${pad(sunday.getMonth() + 1)}-${pad(sunday.getDate())}`;
      return { dates, weekKey };
    },
    // Resolve a zman for the date the shared kosher-zmanim calendar is currently
    // set to (the caller sets/restores the date). Mirrors the editor preview's
    // resolveZmanBaseIso so both layers pick the exact same per-day times:
    // Special Zmanim settings win for candle/motzei, then the direct calendar
    // getter (no arity restriction), then the computed keys, then the legacy
    // sunrise + fixed-offset estimate.
    resolveWeeklyStaticZmanForCalendarDate(zmanimKey) {
      const cal = this._kosherZmanimCalendar;
      if (!cal || !zmanimKey) return '';
      const getterIso = (key) => {
        const getter = `get${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        const fn = cal[getter];
        if (typeof fn !== 'function') return '';
        try {
          return this.kosherZmanimValueToIso(fn.call(cal));
        } catch (e) {
          return '';
        }
      };
      if (isSpecialZmanKey(zmanimKey)) {
        const sunsetIso = getterIso('sunset') || getterIso('seaLevelSunset');
        const specialIso = this.resolveSpecialZmanSettingsIso(zmanimKey, sunsetIso, cal);
        if (specialIso) return specialIso;
      }
      const direct = getterIso(zmanimKey);
      if (direct) return direct;
      // Editor-offered keys with no direct kosher-zmanim getter.
      if (zmanimKey === 'chatzotNight') {
        const chatzos = getterIso('chatzos');
        return chatzos ? this.addMinutesISO(chatzos, 12 * 60) : '';
      }
      if (zmanimKey === 'misheyakir22Min') {
        const alos72 = getterIso('alos72');
        return alos72 ? this.addMinutesISO(alos72, 22) : '';
      }
      if (zmanimKey === MOTZEI_SHABBOS_LONDON_KEY) {
        // Both bases resolve for the date the calendar is currently set to, so
        // the three-case rule is re-evaluated per day of the weekly scan.
        return resolveMotzeiShabbosLondonFrom(getterIso);
      }
      // Legacy keys: sunrise + fixed offset, anchored to this calendar date.
      const baseOffset = Number(ZMANIM_ENGLISH_OFFSETS[zmanimKey]);
      if (!Number.isFinite(baseOffset)) return '';
      const sunrise = getterIso('sunrise');
      return sunrise ? this.addMinutesISO(sunrise, baseOffset) : '';
    },
    // Resolve a Weekly Static Zman minyan's time: the zman is computed for EVERY
    // day of the current week (Sunday through Friday) and the ISO of the maximum
    // ('max') or minimum ('min') clock time — compared in the org timezone — is
    // returned. Values are cached per week (and per zman+mode) so the scan runs
    // once; the cache regenerates each Sunday, on a location/calendar rebuild,
    // and when the Special Zmanim settings load. Returns '' while the calendar
    // isn't ready (callers show '--:--' / sort last until it is).
    resolveWeeklyStaticZmanDateTime(zmanimKey, weeklyMode = 'max') {
      if (!zmanimKey) return '';
      const cal = this._kosherZmanimCalendar;
      if (!cal) return '';
      const anchor = this.getWeeklyStaticWeekAnchor();
      if (!anchor) return '';
      const mode = weeklyMode === 'min' ? 'min' : 'max';
      const cacheKey = `${zmanimKey}|${mode}`;
      if (!this._weeklyStaticZmanCache || this._weeklyStaticZmanCache.weekKey !== anchor.weekKey) {
        this._weeklyStaticZmanCache = { weekKey: anchor.weekKey, values: {} };
      }
      if (cacheKey in this._weeklyStaticZmanCache.values) {
        return this._weeklyStaticZmanCache.values[cacheKey];
      }

      let original = null;
      try { original = cal.getDate(); } catch (error) { original = null; }

      let bestIso = '';
      let bestMinutes = Number.NaN;
      try {
        for (const date of anchor.dates) {
          let iso = '';
          try {
            cal.setDate(date);
            iso = this.resolveWeeklyStaticZmanForCalendarDate(zmanimKey);
          } catch (error) {
            iso = '';
          }
          if (!iso) continue;
          // "Latest/earliest of the week" is a wall-clock comparison across the
          // six days, so compare minutes-of-day in the org timezone (the value
          // actually shown), not absolute instants.
          const minutes = this.zmanMinutesOfDay(iso);
          if (!Number.isFinite(minutes)) continue;
          if (!bestIso || (mode === 'min' ? minutes < bestMinutes : minutes > bestMinutes)) {
            bestIso = iso;
            bestMinutes = minutes;
          }
        }
      } finally {
        // Restore the live date so later calculations off the shared calendar
        // keep operating on today.
        if (original != null) {
          try { cal.setDate(original); } catch (error) { /* noop */ }
        }
      }

      // Cache even an empty result only when the calendar produced nothing for
      // any day — a later successful build replaces it via the invalidations.
      this._weeklyStaticZmanCache.values[cacheKey] = bestIso;
      return bestIso;
    },
    // Normalize a kosher-zmanim getter result (Date | Luxon DateTime | Temporal)
    // to an ISO string, mirroring buildKosherZmanimMap's converter.
    kosherZmanimValueToIso(v) {
      if (!v) return '';
      if (v instanceof Date) return Number.isNaN(v.getTime()) ? '' : v.toISOString();
      if (typeof v.toISO === 'function' && v.isValid !== false) return v.toISO() || '';
      if (typeof v.toJSDate === 'function') {
        const d = v.toJSDate();
        return d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString() : '';
      }
      return '';
    },
    // Resolve a roll minyan's dynamic-zman clock time from the kosher-zmanim
    // calendar built for screen.organization's lat/lng (the same source the
    // Zmanim display uses). Tries the prebuilt lookup first, then calls the
    // matching ComplexZmanimCalendar getter directly so any valid zman key
    // resolves exactly — no synthetic sunrise estimate. Returns '' if it can't.
    // Today's sunset (org location), used as the base for the Special Zmanim
    // candle / motzei formulas.
    getSpecialZmanSunsetIso() {
      return (
        this.kosherZmanimLookup?.sunset ||
        this.kosherZmanimLookup?.seaLevelSunset ||
        this.zmanims?.sunset ||
        ''
      );
    },
    // Settings → Zmanim Settings → Special Zmanim. Returns the organization's
    // configured candle-lighting / motzei time for `zmanimKey`, or '' when that
    // special zman has not been configured (so callers keep their own default).
    // `sunsetIso` / `calendar` let callers resolve for a specific day (the Shabbos
    // anchor dates) instead of today.
    resolveSpecialZmanSettingsIso(zmanimKey, sunsetIso = null, calendar = null) {
      return resolveSpecialZmanIsoFromOverrides(this.zmanimDisplayOverrides, zmanimKey, {
        sunsetIso: sunsetIso != null ? sunsetIso : this.getSpecialZmanSunsetIso(),
        calendar: calendar || this._kosherZmanimCalendar,
      });
    },
    resolveRollZmanDateTime(zmanimKey, offsetMinutes = 0) {
      if (!zmanimKey) return '';
      const offset = Number(offsetMinutes) || 0;
      // A roll minyan on Dynamic Zman that selects Hadlukas Haneiros / Motzei uses
      // the org-wide Special Zmanim settings when they are configured — they win
      // over the built-in defaults below. Roll-only: this resolver is not used by
      // the Zmanim_N boards, which keep their own per-board Special Zmanim config.
      if (isSpecialZmanKey(zmanimKey)) {
        const specialIso = this.resolveSpecialZmanSettingsIso(zmanimKey);
        if (specialIso) {
          return offset ? this.addMinutesWithOffset(specialIso, offset) : specialIso;
        }
      }
      let iso = this.kosherZmanimLookup?.[zmanimKey] || this.zmanims?.[zmanimKey] || '';
      if (!iso && this._kosherZmanimCalendar) {
        const getter = `get${zmanimKey.charAt(0).toUpperCase()}${zmanimKey.slice(1)}`;
        const fn = this._kosherZmanimCalendar[getter];
        if (typeof fn === 'function' && fn.length === 0) {
          try {
            iso = this.kosherZmanimValueToIso(fn.call(this._kosherZmanimCalendar));
          } catch (e) {
            iso = '';
          }
        }
      }
      if (!iso) return '';
      return offset ? this.addMinutesWithOffset(iso, offset) : iso;
    },
    getResolvedZmanDateTime(zmanimKey, customOffsetMinutes = 0) {
      if (!zmanimKey) return '';

      const extraOffset = Number(customOffsetMinutes);
      const withOffset = (value) => (
        value && Number.isFinite(extraOffset) && extraOffset !== 0
          ? this.addMinutesWithOffset(value, extraOffset)
          : value
      );

      const directValue = this.kosherZmanimLookup?.[zmanimKey] || this.zmanims?.[zmanimKey] || '';
      if (directValue) return withOffset(directValue);

      // Some kosher-zmanim getters (e.g. getPlagHamincha — the Advanced-tab
      // "פלג המנחה (גר״א)") take optional args, so buildKosherZmanimMap — which
      // keeps only 0-arg getters — skips them, even though they compute a valid
      // time when called with no args. Resolve those straight from the calendar,
      // exactly as the editor's live preview does, so every selectable zman
      // (including Advanced ones) appears on the display and not only the preview.
      const calendarValue = this.resolveZmanFromCalendar(zmanimKey);
      if (calendarValue) return withOffset(calendarValue);

      return this.getComputedZmanDateTime(zmanimKey, customOffsetMinutes);
    },
    // Call a ComplexZmanimCalendar getter directly by key (get<Key>()), with no
    // arity restriction, so arg-taking getters that self-default when called
    // with no args (getPlagHamincha, etc.) still resolve. Mirrors the editor
    // preview's getCalendarZmanimISO. Returns '' if the getter is missing/errors.
    resolveZmanFromCalendar(zmanimKey) {
      if (!zmanimKey || !this._kosherZmanimCalendar) return '';
      const getter = `get${zmanimKey.charAt(0).toUpperCase()}${zmanimKey.slice(1)}`;
      const fn = this._kosherZmanimCalendar[getter];
      if (typeof fn !== 'function') return '';
      try {
        return this.kosherZmanimValueToIso(fn.call(this._kosherZmanimCalendar));
      } catch (e) {
        return '';
      }
    },
    getComputedZmanDateTime(zmanimKey, customOffsetMinutes = 0) {
      if (!zmanimKey) return '';

      const baseOffset = Number(ZMANIM_ENGLISH_OFFSETS[zmanimKey]);
      // Unknown keys have no sunrise-relative offset. Returning sunrise here would
      // surface a bogus early-morning time (e.g. a modern `plagHamincha` key that
      // is only resolvable via the kosher-zmanim calendar, which the callers try
      // first). Bail so callers show '--:--' instead of a wrong time.
      if (!Number.isFinite(baseOffset)) return '';

      const sunrise = this.deviceSunrise || this.zmanims?.sunrise || '';
      if (!sunrise) return '';

      const extraOffset = Number(customOffsetMinutes);
      const totalOffset = baseOffset + (Number.isFinite(extraOffset) ? extraOffset : 0);

      return this.addMinutesWithOffset(sunrise, totalOffset);
    },
    getRollZmanTime(zmanimKey, customOffsetMinutes = 0) {
      const rollTime = this.getComputedZmanDateTime(zmanimKey, customOffsetMinutes);
      return rollTime ? this.formatZmanClock(rollTime) : '';
    },
    renderZmanimContent(template, zmanims) {
      if (!zmanims) return template;

      // This regex matches {key} ... {time}
      return template.replace(/{(\w+)}([^{}]*?){time}/g, (match, key, between) => {
        const value = zmanims[key] || '';
        // Yiddish mapping or fallback to key
        const keyLabel = ZMANIM_YIDDISH_MAPPING[key] || key;

        const dateMatch = value.match(/T(\d{2}):(\d{2}):(\d{2})/);
        let hour = dateMatch ? parseInt(dateMatch[1], 10) : 0;
        let minute = dateMatch ? dateMatch[2] : '00';
        let second = dateMatch ? dateMatch[3] : '00';
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12; // 12-hour format
        const timeStr = `${hour}:${minute}`;

        // Replace {key} with label, keep the text in between, replace {time} with timeStr
        return `${keyLabel}${between}${timeStr}`;
      });
    },
    getZmanimTime(key) {
      if (!this.zmanims) return '- 00:00 -';

      const value = this.zmanims[key] || '';

      // Yiddish mapping or fallback to key
      const keyLabel = ZMANIM_YIDDISH_MAPPING[key] || key;

      const dateMatch = value.match(/T(\d{2}):(\d{2}):(\d{2})/);
      let hour = dateMatch ? parseInt(dateMatch[1], 10) : 0;
      let minute = dateMatch ? dateMatch[2] : '00';
      let second = dateMatch ? dateMatch[3] : '00';
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12; // 12-hour format

      return `${hour}:${minute}`;
    },
    getZmanimNTime(key) {
      const time = this.getResolvedZmanDateTime(key);
      return time ? this.formatZmanimNDisplayTime(key, time) : '--:--';
    },
    getDateTimeSortValue(dateTime) {
      if (!dateTime) return Number.POSITIVE_INFINITY;
      const value = new Date(dateTime).getTime();
      return Number.isFinite(value) ? value : Number.POSITIVE_INFINITY;
    },
    getZmanimNShabbatDesign(displayElement) {
      const shabbat = displayElement?.design?.shabbat || {};
      return {
        candleOffsetMinutes: Number(shabbat.candleOffsetMinutes) || 18,
        exitMode: shabbat.exitMode || 'fixedMinutes',
        exitMinutes: Number(shabbat.exitMinutes) || 72,
        exitDegrees: Number(shabbat.exitDegrees) || 8.5,
      };
    },
    createJewishCalendar(date) {
      const Calendar = this.jewishCalendarConstructor;
      if (!Calendar) return null;
      try {
        const calendar = new Calendar(date);
        if (typeof calendar.setUseModernHolidays === 'function') {
          calendar.setUseModernHolidays(true);
        }
        return calendar;
      } catch (error) {
        return null;
      }
    },
    isJewishCalendarYomTov(calendar) {
      if (!calendar) return false;
      try {
        return Boolean(calendar.isYomTov?.());
      } catch (error) {
        return false;
      }
    },
    isJewishCalendarAssurBemelacha(calendar) {
      if (!calendar) return false;
      try {
        return Boolean(calendar.isAssurBemelacha?.() || calendar.isYomTov?.());
      } catch (error) {
        return false;
      }
    },
    isJewishCalendarErevYomTov(calendar) {
      if (!calendar) return false;
      try {
        return Boolean(calendar.isErevYomTov?.());
      } catch (error) {
        return false;
      }
    },
    getJewishDayContext(date = this.currentTime || new Date()) {
      // The screen's own day, whatever timezone the device viewing it is in.
      const today = this.getScreenCivilDate(date) || new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const todayCalendar = this.createJewishCalendar(today);
      const tomorrowCalendar = this.createJewishCalendar(tomorrow);
      const isFriday = today.getDay() === 5;
      const isSaturday = today.getDay() === 6;
      const tomorrowIsSaturday = tomorrow.getDay() === 6;
      const isYomTov = this.isJewishCalendarYomTov(todayCalendar);
      const tomorrowIsYomTov = this.isJewishCalendarYomTov(tomorrowCalendar);
      const isAssurBemelachaToday = this.isJewishCalendarAssurBemelacha(todayCalendar);
      const tomorrowIsAssurBemelacha = this.isJewishCalendarAssurBemelacha(tomorrowCalendar);
      const isErevYomTov = this.isJewishCalendarErevYomTov(todayCalendar);
      const isHolyToday = isSaturday || isAssurBemelachaToday;
      const tomorrowIsHoly = tomorrowIsSaturday || tomorrowIsAssurBemelacha;
      const showSaturdayTzeis = isSaturday && tomorrowIsHoly;
      const showMotzei = isHolyToday && !tomorrowIsHoly;
      const showCandles =
        !showSaturdayTzeis &&
        !showMotzei &&
        (isFriday || (isErevYomTov && !isYomTov));

      return {
        today,
        tomorrow,
        isFriday,
        isSaturday,
        isYomTov,
        tomorrowIsYomTov,
        isErevYomTov,
        isHolyToday,
        tomorrowIsHoly,
        showCandles,
        showMotzei,
        showSaturdayTzeis,
      };
    },
    roundIsoDownToMinute(iso) {
      if (!iso) return '';
      const date = new Date(iso);
      if (Number.isNaN(date.getTime())) return '';
      date.setSeconds(0, 0);
      return date.toISOString();
    },
    roundIsoUpToMinute(iso) {
      if (!iso) return '';
      const date = new Date(iso);
      if (Number.isNaN(date.getTime())) return '';
      if (date.getSeconds() > 0 || date.getMilliseconds() > 0) {
        date.setMinutes(date.getMinutes() + 1);
      }
      date.setSeconds(0, 0);
      return date.toISOString();
    },
    normalizeZmanimRoundTo(value) {
      return Object.values(ZmanimDisplayOverrideRoundTo).includes(value)
        ? value
        : ZmanimDisplayOverrideRoundTo.closer;
    },
    getZmanimDisplayOverrideSettings(key) {
      const override = this.zmanimDisplayOverrideMap[key] || {};
      return {
        showSeconds: typeof override.showSeconds === 'boolean' ? override.showSeconds : false,
        roundTo: this.normalizeZmanimRoundTo(override.roundTo),
      };
    },
    getRoundedZmanimDateForSettings(dateTime, settings) {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      if (Number.isNaN(date.getTime())) return null;
      if (settings.showSeconds) return date;

      const millisecondsToMinute = (date.getSeconds() * 1000) + date.getMilliseconds();
      if (settings.roundTo === ZmanimDisplayOverrideRoundTo.high) {
        if (millisecondsToMinute > 0) date.setTime(date.getTime() + (60000 - millisecondsToMinute));
      } else if (settings.roundTo === ZmanimDisplayOverrideRoundTo.lower) {
        date.setTime(date.getTime() - millisecondsToMinute);
      } else {
        date.setTime(
          date.getSeconds() >= 30
            ? date.getTime() + (60000 - millisecondsToMinute)
            : date.getTime() - millisecondsToMinute
        );
      }
      date.setSeconds(0, 0);
      return date;
    },
    getZmanimDateTimeForOverrideDisplay(key, dateTime) {
      const date = this.getRoundedZmanimDateForSettings(
        dateTime,
        this.getZmanimDisplayOverrideSettings(key)
      );
      return date ? date.toISOString() : '';
    },
    formatZmanimNDisplayTime(key, dateTime) {
      const settings = this.getZmanimDisplayOverrideSettings(key);
      const date = this.getRoundedZmanimDateForSettings(dateTime, settings);
      if (!date) return '--:--';

      // Format in the org timezone so the time reflects the org's location, not
      // the display device's timezone.
      return this.formatZmanClock(date, { withSeconds: settings.showSeconds });
    },
    isTzeisZmanKey(key) {
      return /^(tzais|tzeis|tzeit)/i.test(String(key || ''))
        || key === 'afterSunset60'
        || key === 'shabbatMotzei'
        || key === MOTZEI_SHABBOS_LONDON_KEY;
    },
    getMotzeiLabel(context) {
      if (context.isSaturday && context.isYomTov) return 'מוצאי שבת ויו״ט';
      if (context.isSaturday) return 'מוצאי שבת';
      return 'מוצאי יום טוב';
    },
    getShabbatTzeisDateTime(config) {
      const map = this.kosherZmanimLookup || {};
      const sunset = map.sunset || map.seaLevelSunset || this.zmanims?.sunset || '';
      if (config.exitMode === 'degrees') {
        const cal = this._kosherZmanimCalendar;
        if (cal && typeof cal.getSunsetOffsetByDegrees === 'function') {
          try {
            const v = cal.getSunsetOffsetByDegrees(90 + Number(config.exitDegrees || 8.5));
            const iso = v
              ? (v instanceof Date
                  ? (Number.isNaN(v.getTime()) ? '' : v.toISOString())
                  : (typeof v.toISO === 'function' && v.isValid !== false
                      ? v.toISO() || ''
                      : (typeof v.toJSDate === 'function'
                          ? (() => { const d = v.toJSDate(); return d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString() : ''; })()
                          : '')))
              : '';
            if (iso) return iso;
          } catch (e) { /* fall through to map/sunset fallbacks */ }
        }
        return (
          map.tzaisGeonim8Point5Degrees ||
          map.tzeit85deg ||
          map.tzais ||
          (sunset ? this.addMinutesISO(sunset, config.exitMinutes) : '')
        );
      }
      return sunset ? this.addMinutesISO(sunset, config.exitMinutes) : '';
    },
    getShabbatSyntheticZmanInfo(displayElement, key) {
      if (!['shabbatHadlukasHaneiros', 'shabbatMotzei'].includes(key)) return null;
      const config = this.getZmanimNShabbatDesign(displayElement);
      const context = this.getJewishDayContext();

      if (key === 'shabbatHadlukasHaneiros' && context.showCandles) {
        const sunset = this.kosherZmanimLookup?.sunset || this.kosherZmanimLookup?.seaLevelSunset || this.zmanims?.sunset || '';
        const dateTime = sunset ? this.roundIsoDownToMinute(this.addMinutesISO(sunset, -config.candleOffsetMinutes)) : '';
        return dateTime ? { dateTime, label: 'הדלקת נרות' } : null;
      }

      if (key === 'shabbatMotzei' && context.showMotzei) {
        const rawTzeis = this.getShabbatTzeisDateTime(config);
        const dateTime = context.isSaturday ? this.roundIsoUpToMinute(rawTzeis) : this.roundIsoDownToMinute(rawTzeis);
        return dateTime ? { dateTime, label: this.getMotzeiLabel(context) } : null;
      }

      if (key === 'shabbatMotzei' && context.showSaturdayTzeis) {
        const dateTime = this.roundIsoUpToMinute(this.getShabbatTzeisDateTime(config));
        return dateTime ? { dateTime, label: 'צאת הכוכבים' } : null;
      }

      return null;
    },
    getRoundedZmanDateTimeForDisplay(key, dateTime) {
      const context = this.getJewishDayContext();
      if (context.isSaturday && this.isTzeisZmanKey(key)) {
        return this.roundIsoUpToMinute(dateTime);
      }
      return dateTime;
    },
    getZmanimNItems(displayElement) {
      if (!Array.isArray(displayElement?.selectedZmanim)) return [];
      const SHABBAT_SYNTHETIC_KEYS = ['shabbatHadlukasHaneiros', 'shabbatMotzei'];
      return displayElement.selectedZmanim
        .map((key) => {
          const synthetic = this.getShabbatSyntheticZmanInfo(displayElement, key);
          // Shabbat-only zmanim (candle lighting / motzei) must only appear on
          // the day their religious condition is met. If the synthetic
          // resolver returned null, the day's filter logic says "don't show
          // this today" — drop the row instead of falling back to sunrise.
          if (SHABBAT_SYNTHETIC_KEYS.includes(key) && !synthetic) {
            return null;
          }
          const rawDateTime = synthetic?.dateTime || this.getResolvedZmanDateTime(key);
          const dateTime = synthetic ? rawDateTime : this.getRoundedZmanDateTimeForDisplay(key, rawDateTime);
          if (!dateTime || Number.isNaN(new Date(dateTime).getTime())) return null;
          const displayDateTime = this.getZmanimDateTimeForOverrideDisplay(key, dateTime);
          return {
            key,
            label: synthetic?.label || this.getZmanimDisplayName(key),
            time: this.formatZmanimNDisplayTime(key, dateTime),
            dateTime: displayDateTime || dateTime,
          };
        })
        .filter((item) => Boolean(item && item.dateTime))
        .sort((a, b) => this.getDateTimeSortValue(a.dateTime) - this.getDateTimeSortValue(b.dateTime));
    },
    getZmanimDisplayName(key) {
      return this.zmanimDisplayOverrideMap[key]?.name || ALL_ZMANIM_YIDDISH_MAPPING[key] || key;
    },
    getNearestFutureSelectedZmanIndex(zmanimItems) {
      if (!Array.isArray(zmanimItems) || !this.currentTime) return -1;
      const nowMinutes = this.getOrgNowMinutes();
      let nearestIdx = -1;
      let nearestDiff = Infinity;

      zmanimItems.forEach((item, idx) => {
        const value = item?.dateTime;
        if (!value) return;

        // Minutes-of-day in the org timezone (matches the displayed clock time).
        const zmanMinutes = this.zmanMinutesOfDay(value);
        if (!Number.isFinite(zmanMinutes) || zmanMinutes <= nowMinutes) return;

        const diff = zmanMinutes - nowMinutes;
        if (diff < nearestDiff) {
          nearestDiff = diff;
          nearestIdx = idx;
        }
      });

      return nearestIdx;
    },
    // ----- Zmanim_N Grid Designer card rendering (mirrors the roll grid) -----
    // Card view + the design's grid has content → render each zman as a grid card.
    isZmanimNGridActive(displayElement) {
      const design = displayElement?.design || {};
      const viewMode = design.viewMode || (design.cardView ? 'card' : 'grid');
      return viewMode !== 'list' && zmanimGridHasContent(design.grid);
    },
    getZmanimGridCells(grid) {
      return getZmanimGridCells(grid);
    },
    getZmanimGridContainerStyle(grid) {
      return getZmanimGridContainerStyle(grid);
    },
    getZmanimGridCellStyle(grid, idx) {
      return getZmanimGridCellStyle(grid, idx);
    },
    // Index of the soonest upcoming zman — the only card that shows a countdown.
    getZmanimNextIndex(displayElement) {
      return getNearestFutureZmanIndex(this.getZmanimNItems(displayElement), this.currentTime || new Date());
    },
    // Substitute a zman's {name}/{time}/{countdown} into a grid cell for Display.
    renderZmanimGridCell(cell, item, index, displayElement) {
      const design = this.getZmanimNDesign(displayElement);
      const countdown = index === this.getZmanimNextIndex(displayElement)
        ? getZmanimCountdownString(item.dateTime, this.currentTime || new Date(), design.countdown)
        : '';
      return renderZmanimGridCellHtml(
        cell,
        { name: item.label, time: item.time, countdown },
        { countdownCss: getZmanimCountdownCss({ ...design.countdown, viewMode: design.viewMode }) },
      );
    },
    getZmanimNCardBackgroundColor(value) {
      const color = String(value || '').trim();
      return color || '#ffffff';
    },
    getZmanimNCardPadding(value) {
      const raw = String(value ?? '').trim().replace(/\s+/g, ' ');
      if (!raw) return '12px 14px';
      const tokens = raw.split(' ');
      if (tokens.length > 4) return '12px 14px';
      const normalizedTokens = tokens.map((token) => {
        const match = token.match(/^(\d+(?:\.\d+)?)(px)?$/i);
        if (!match) return null;
        const numericValue = Math.min(Math.max(Number(match[1]), 0), 200);
        const normalizedValue = Number.isInteger(numericValue)
          ? String(numericValue)
          : String(Number(numericValue.toFixed(2)));
        return `${normalizedValue}px`;
      });
      return normalizedTokens.every(Boolean) ? normalizedTokens.join(' ') : '12px 14px';
    },
    getZmanimNDesign(displayElement) {
      const design = displayElement?.design || {};
      const columns = Number(design.columns ?? design.listColumns ?? displayElement?.columns ?? 1) || 1;
      const listViewVerticalColumns = Math.min(
        Math.max(
          Number(design.listViewVerticalColumns ?? design.listColumns ?? displayElement?.columns ?? columns) || 1,
          1
        ),
        3
      );
      const viewMode = design.viewMode || (design.cardView ? 'card' : 'grid');
      const listOrientation = design.listOrientation || 'vertical';
      const cardLayoutRows = Number(design.cardLayoutRows) === 1 ? 1 : 2;
      const rowSpacing = Number(design.rowSpacing);
      const rotationSpeed = Number(design.rotationSpeed ?? displayElement?.rotationSpeed ?? 10);
      const displayFontSize = Number(displayElement?.fontSize);
      const designFontSize = Number(design.fontSize);
      const fontSize = Number.isFinite(displayFontSize) && displayFontSize > 0
        ? displayFontSize
        : Number.isFinite(designFontSize) && designFontSize > 0
          ? designFontSize
          : null;
      const textColor = displayElement?.textColor || design.textColor || displayElement?.headerColor || design.headerColor || '#000000';
      const cardBackgroundColor = this.getZmanimNCardBackgroundColor(design.cardBackgroundColor);
      const cardPadding = this.getZmanimNCardPadding(design.cardPadding);
      const highlight = normalizeZmanimHighlightDesign(design);
      const countdown = normalizeZmanimCountdownDesign(design);
      return {
        viewMode,
        listOrientation,
        columns: Math.max(columns, 1),
        listColumns: Math.max(Number(design.listColumns ?? columns) || columns, 1),
        listViewVerticalColumns,
        cardView: viewMode === 'card',
        cardLayoutRows,
        horizontalDividerStyle: design.horizontalDividerStyle || 'line',
        horizontalDividerLine: design.horizontalDividerLine || design.horizontalDividerStyle || 'none',
        rowDividerColor: design.rowDividerColor || '#000000',
        cardBorderColor: design.cardBorderColor || '#6366f1',
        cardBackgroundColor,
        cardPadding,
        rowSpacing: Number.isFinite(rowSpacing) ? Math.min(Math.max(rowSpacing, -80), 80) : 10,
        dividerSymbol: design.dividerSymbol || 'diamond',
        rotationSpeed: Number.isFinite(rotationSpeed) ? Math.min(Math.max(rotationSpeed, 0.5), 20) : 10,
        fontFamily: design.fontFamily || '',
        fontSize,
        headerColor: textColor,
        textColor,
        highlight,
        countdown,
        upcomingHighlightEnabled: highlight.enabled,
        upcomingHighlightColor: getZmanimHighlightAccentColor(highlight),
      };
    },
    getZmanimNRotationDuration(displayElement) {
      const { rotationSpeed } = this.getZmanimNDesign(displayElement);
      return `${rotationSpeed * 8}s`;
    },
    getZmanimNRotationDurationMs(displayElement) {
      const { rotationSpeed } = this.getZmanimNDesign(displayElement);
      return rotationSpeed * 8000;
    },
    // Carousel dwell time for a Minyanim Roll element, driven by the roll's
    // design rotationSpeed using the same formula and [0.5, 20] range as
    // Zmanim_N so "Rotation Speed" behaves identically across both features.
    getRollRotationDurationMs(displayElement) {
      const raw = Number(displayElement?.design?.rotationSpeed);
      const rotationSpeed = Number.isFinite(raw) ? Math.min(Math.max(raw, 0.5), 20) : 10;
      return rotationSpeed * 8000;
    },
    // Carousel dwell times for Announcement / Donation / Event elements. Unlike
    // rolls and Zmanim_N these are NOT relative "rotation speeds" — each is an
    // explicit duration in seconds set once per organization from that
    // feature's own list page (Settings -> Display Duration) and stored on the
    // organization record, so every screen in the org holds each item for the
    // same time. All three fall back to 30 seconds for organizations that have
    // never set them.
    //
    // The screen's own embedded organization is read first: a live display has
    // no session and never loads the organization into the store. The
    // Dashboard's embedded preview has one either way, so it follows a save in
    // the settings modal as soon as the store updates.
    getDisplayDurationOrganization() {
      return this.screen?.organization || this.organization || null;
    },
    getAnnouncementDisplayDurationMs() {
      return resolveAnnouncementDisplayDurationMs(this.getDisplayDurationOrganization());
    },
    getDonationDisplayDurationMs() {
      return resolveDonationDisplayDurationMs(this.getDisplayDurationOrganization());
    },
    // One value for both event kinds: a Quick Event is an Event with a
    // different `subType`, and both reach the rotation through an Event
    // Template, so the artboard holds either for the same time.
    getEventDisplayDurationMs() {
      return resolveEventDisplayDurationMs(this.getDisplayDurationOrganization());
    },
    // Carousel dwell time for a Poster element. Posters share ONE "Rotation
    // Speed" set on the Posters page and persisted to this device'''s
    // localStorage, so every poster uses the same duration — same [0.5, 20] ×
    // 8000ms mapping as rolls / Zmanim_N. Unlike the two dwell times above it
    // is not org-wide: a screen that has never opened the Posters page falls
    // back to the default.
    getPosterRotationDurationMs() {
      let raw = Number.NaN;
      try {
        if (typeof localStorage !== 'undefined') {
          raw = Number(localStorage.getItem('posters_N_rotationSpeed'));
        }
      } catch (e) { /* storage unavailable */ }
      const rotationSpeed = Number.isFinite(raw) && raw > 0 ? Math.min(Math.max(raw, 0.5), 20) : 10;
      return rotationSpeed * 8000;
    },
    getZmanimNDisplayClasses(displayElement, artboard = null) {
      const design = this.getZmanimNDesign(displayElement);
      return {
        [`zmanim-n-display--${design.viewMode}`]: true,
        [`zmanim-n-display--list-${design.listOrientation}`]: design.viewMode === 'list',
        [`zmanim-n-display--divider-${design.horizontalDividerStyle}`]: true,
        [`zmanim-n-display--rows-${design.cardLayoutRows}`]: design.viewMode !== 'list',
        'zmanim-n-display--list-horizontal-static': this.isZmanimNHorizontalTickerStatic(displayElement, artboard),
      };
    },
    // A horizontal list normally marquee-scrolls (its own ticker, independent of
    // the artboard). When the artboard is set to "no scroll" it must hold still:
    // render a single, centered, non-animated row instead of the looping ticker.
    isZmanimNHorizontalTickerStatic(displayElement, artboard) {
      return this.isZmanimNHorizontalList(displayElement) && artboard?.scrollDirection === 'noscroll';
    },
    getZmanimNStaticHorizontalFitScale(displayElement, artboard) {
      if (!this.isZmanimNHorizontalTickerStatic(displayElement, artboard)) return 1;
      const scale = Number(this.zmanimNHorizontalFitScales?.[artboard.id]);
      return Number.isFinite(scale) && scale > 0 ? Math.min(scale, 1) : 1;
    },
    // The marquee renders two item copies for a seamless loop; a static (no-scroll)
    // ticker needs only one so the row isn't visibly duplicated.
    getZmanimNTickerCopies(displayElement, artboard) {
      return this.isZmanimNHorizontalTickerStatic(displayElement, artboard) ? [0] : [0, 1];
    },
    getZmanimNDisplayStyle(displayElement, artboard = null) {
      const design = this.getZmanimNDesign(displayElement);
      const isVerticalList = design.viewMode === 'list' && design.listOrientation === 'vertical';
      const columns = isVerticalList ? design.listViewVerticalColumns : design.viewMode === 'list' ? 1 : design.listColumns;
      const rowSpacing = Number(design.rowSpacing) || 0;
      const staticHorizontalScale = this.getZmanimNStaticHorizontalFitScale(displayElement, artboard);
      // A 3-column CARD layout renders on a 6-sub-column grid so a trailing partial
      // row (1 or 2 cards) can be centered; every card spans 2 sub-columns, which
      // makes full rows pixel-identical to a plain 3-column grid. List views (which
      // reuse `columns` for their own layout) are deliberately untouched.
      // See getZmanimNCardGridStyle for the per-card placement.
      const templateColumns = design.viewMode !== 'list' && Number(columns) === 3 ? 6 : columns;
      return {
        gridTemplateColumns: `repeat(${templateColumns}, minmax(0, 1fr))`,
        '--zmanim-n-card-border-color': design.cardBorderColor || '#6366f1',
        '--zmanim-n-card-background-color': this.getZmanimNCardBackgroundColor(design.cardBackgroundColor),
        '--zmanim-n-card-padding': this.getZmanimNCardPadding(design.cardPadding),
        '--zmanim-n-static-horizontal-scale': staticHorizontalScale,
        ...(isVerticalList ? {
          columnGap: columns > 1 ? '16px' : '0px',
          '--zmanim-n-row-gap': `${Math.max(rowSpacing, 0)}px`,
          '--zmanim-n-row-overlap': `${Math.min(rowSpacing, 0)}px`,
          '--zmanim-n-row-divider-color': design.rowDividerColor || '#000000',
        } : {}),
        fontFamily: design.fontFamily ? `${design.fontFamily}, sans-serif` : undefined,
        animationDuration: this.getZmanimNRotationDuration(displayElement),
      };
    },
    isZmanimNHorizontalList(displayElement) {
      const design = this.getZmanimNDesign(displayElement);
      return design.viewMode === 'list' && design.listOrientation === 'horizontal';
    },
    isZmanimNVerticalList(displayElement) {
      const design = this.getZmanimNDesign(displayElement);
      return design.viewMode === 'list' && design.listOrientation !== 'horizontal';
    },
    getZmanimNVerticalListColumns(displayElement, zmanimItems = null) {
      const items = Array.isArray(zmanimItems) ? zmanimItems : this.getZmanimNItems(displayElement);
      const { listViewVerticalColumns } = this.getZmanimNDesign(displayElement);
      const columnCount = Math.min(
        Math.max(Number(listViewVerticalColumns) || 1, 1),
        Math.max(items.length, 1)
      );
      const baseSize = Math.floor(items.length / columnCount);
      const remainder = items.length % columnCount;
      let offset = 0;

      return Array.from({ length: columnCount }, (_, columnIndex) => {
        const size = baseSize + (columnIndex < remainder ? 1 : 0);
        const columnItems = items.slice(offset, offset + size).map((item, itemIndex) => ({
          ...item,
          sourceIndex: offset + itemIndex,
        }));
        offset += size;
        return {
          key: `zmanim-column-${columnIndex}`,
          items: columnItems,
          sourceItems: items,
        };
      });
    },
    isCurrentZmanimNHorizontalTicker(artboard) {
      if (!artboard?.id) return false;
      const current = this.getCurrentDisplayElement(artboard);
      if (!current || current.type !== 'Zmanim_N') return false;
      if (!artboard.features?.includes?.('Zmanim_N')) return false;
      return this.isZmanimNHorizontalList(current);
    },
    isCurrentRecentPhotoDisplay(artboard) {
      if (!artboard?.id) return false;
      const current = this.getCurrentDisplayElement(artboard);
      return Boolean(current?._isRecentPhotoCarousel);
    },
    isCurrentYurtzeitenNDisplay(artboard) {
      if (!artboard?.id) return false;
      const current = this.getCurrentDisplayElement(artboard);
      return Boolean(current?._isYurtzeitenN);
    },
    // The direction an artboard's content actually travels.
    //
    // Normally the artboard's own setting. A yahrzeit row is the exception: the
    // Yurtzeiten board is organization-owned — one screen, one artboard, chosen
    // once — so its direction is chosen in the Yurtzeiten settings modal rather
    // than per artboard, and that choice wins while a yahrzeit row is the
    // element on screen.
    //
    // A no-scroll artboard is left alone. That setting says the content does not
    // travel at all, and the organization's choice is only between travelling
    // across and travelling up.
    getArtboardScrollDirection(artboard) {
      const artboardDirection = artboard?.scrollDirection;
      if (artboardDirection === 'noscroll') return artboardDirection;
      if (!this.isCurrentYurtzeitenNDisplay(artboard)) return artboardDirection;
      return this.yurtzeitenCarouselDirection || artboardDirection;
    },
    getCurrentDisplayElement(artboard) {
      const elements = this.getDisplayElements(artboard);
      if (!Array.isArray(elements) || !elements.length) return null;
      const currentIndex = this.displayItemIndexes?.[artboard.id] ?? 0;
      return elements[currentIndex] || null;
    },
    getZmanimNDividerSymbol(displayElement) {
      const { dividerSymbol } = this.getZmanimNDesign(displayElement);
      const symbols = {
        diamond: 'â™¦',
        pipe: '|',
        bullet: 'â€¢',
      };
      return symbols[dividerSymbol] || symbols.diamond;
    },
    getZmanimNHorizontalDividerLine(displayElement) {
      const { horizontalDividerLine } = this.getZmanimNDesign(displayElement);
      return ['none', 'line', 'dots'].includes(horizontalDividerLine) ? horizontalDividerLine : 'none';
    },
    isZmanimNUpcomingItem(displayElement, index, zmanimItems) {
      const design = this.getZmanimNDesign(displayElement);
      if (!design.upcomingHighlightEnabled || getNearestFutureZmanIndex(zmanimItems, this.currentTime || new Date()) !== index) return false;
      return isZmanimHighlightActive(zmanimItems?.[index]?.dateTime, this.currentTime || new Date(), design.highlight);
    },
    getZmanimNRowClasses(displayElement, index, zmanimItems) {
      return {
        'zmanim-n-row--active': this.isZmanimNUpcomingItem(displayElement, index, zmanimItems),
      };
    },
    getZmanimNRowStyle(displayElement, index, zmanimItems) {
      const design = this.getZmanimNDesign(displayElement);
      const isActive = this.isZmanimNUpcomingItem(displayElement, index, zmanimItems);
      const style = {};

      if (design.cardView) {
        style.borderColor = design.cardBorderColor;
        style.backgroundColor = this.getZmanimNCardBackgroundColor(design.cardBackgroundColor);
        style.padding = this.getZmanimNCardPadding(design.cardPadding);
      }

      if (isActive && design.viewMode !== 'list') {
        Object.assign(style, getZmanimHighlightStyle(design.highlight));
        style.boxShadow = `0 0 0 1px ${design.upcomingHighlightColor}`;
      } else if (isActive) {
        Object.assign(style, getZmanimHighlightStyle(design.highlight));
      }

      Object.assign(style, this.getZmanimNCardGridStyle(design, index, zmanimItems));

      return style;
    },
    // Per-card grid placement so a trailing partial row of zmanim is centered
    // instead of hanging to one side. Card layout only (the ticker and vertical
    // list are left alone). RTL-safe — the placements are symmetric.
    //
    //  • 2 columns: an odd count leaves the last card alone → span both columns
    //    but keep it one column wide and centered.
    //  • 3 columns: laid out on a 6-sub-column grid (each card spans 2), so full
    //    rows match a plain 3-column grid. A final row of 1 card centers in the
    //    middle; a final row of 2 cards centers as a pair (sub-columns 2–3 & 4–5).
    //
    // The 10px matches the .zmanim-n-display grid gap.
    getZmanimNCardGridStyle(design, index, zmanimItems) {
      if (!design || design.viewMode === 'list') return {};
      const total = Array.isArray(zmanimItems) ? zmanimItems.length : 0;
      const idx = Number(index);
      if (!total || !Number.isFinite(idx)) return {};
      const cols = Number(design.listColumns);

      if (cols === 2) {
        if (total % 2 === 1 && idx === total - 1) {
          return { gridColumn: '1 / -1', justifySelf: 'center', width: 'calc((100% - 10px) / 2)' };
        }
        return {};
      }

      if (cols === 3) {
        const remainder = total % 3;
        const fullCount = total - remainder; // cards filling complete rows
        if (idx < fullCount) {
          // Full-row card → its natural slot: sub-columns 1 / 3 / 5.
          return { gridColumn: `${(idx % 3) * 2 + 1} / span 2`, gridRow: String(Math.floor(idx / 3) + 1) };
        }
        // Leftover card(s) in the final, incomplete row — centered.
        const lastRow = String(fullCount / 3 + 1);
        if (remainder === 1) {
          return { gridColumn: '3 / span 2', gridRow: lastRow }; // dead center
        }
        // remainder === 2 → centered pair: sub-columns 2–3 and 4–5.
        const posInLast = idx - fullCount; // 0 (right, RTL) or 1 (left)
        return { gridColumn: posInLast === 0 ? '2 / span 2' : '4 / span 2', gridRow: lastRow };
      }

      return {};
    },
    getZmanimNFontSize(displayElement, artboard) {
      const design = this.getZmanimNDesign(displayElement);
      if (!design.fontSize) return undefined;
      const adjustedScale = this.scaleFactor * 1.5;
      if (artboard && this.isZmanimNHorizontalList(displayElement) && adjustedScale > 0) {
        // The live ticker intentionally cancels the parent's transform so its
        // authored font size stays fixed on a display. In the Dashboard that
        // cancellation also kept the font full-size while the contained screen
        // and its artboard became a thumbnail, which cropped this short row.
        // Reapply the embedded canvas scale so the preview is a proportional
        // miniature of the 1920px design without changing the live display.
        const embeddedScale = this.embedded ? this.designScale : 1;
        return `${(design.fontSize * 1.25 * embeddedScale) / adjustedScale}px`;
      }
      return `${design.fontSize}px`;
    },
    getZmanimNLabelStyle(displayElement, artboard = null, index = null, zmanimItems = null) {
      const design = this.getZmanimNDesign(displayElement);
      const isActive = this.isZmanimNUpcomingItem(displayElement, index, zmanimItems);
      const highlightTextColor = getZmanimHighlightTextColor(design.highlight);
      return {
        color: isActive ? highlightTextColor : design.headerColor,
        fontSize: this.getZmanimNFontSize(displayElement, artboard),
      };
    },
    getZmanimNTimeStyle(displayElement, artboard = null, index = null, zmanimItems = null) {
      const design = this.getZmanimNDesign(displayElement);
      const isActive = this.isZmanimNUpcomingItem(displayElement, index, zmanimItems);
      const highlightTextColor = getZmanimHighlightTextColor(design.highlight);
      return {
        color: isActive ? highlightTextColor : design.textColor,
        fontSize: this.getZmanimNFontSize(displayElement, artboard),
      };
    },
    isZmanimTimeAfterNow(zmanimList) {
      if (!this.zmanims) return false;

      const value = this.zmanims[key];
      if (!value) return false;

      // Parse the zmanim date string
      const zmanimDate = new Date(value);
      const now = new Date();

      // Return true if zmanimDate is after now, else false
      return zmanimDate > now;
    },
    zmanimAfterNowIndex(zmanimList) {
      if (!Array.isArray(zmanimList)) return -1;

      let nearestIdx = -1;
      let nearestTime = Infinity;
      const nowMinutes = this.getOrgNowMinutes();

      zmanimList.forEach((content, idx) => {
        // Get the zmanim time value (should be an ISO string)
        const value = this.getZmanimDateTime(content.name);

        // const value = '2025-09-02T23:55:16.600Z';
        if (!value) return;

        // Minutes-of-day in the org timezone (matches the displayed clock time).
        const zmanimMinutes = this.zmanMinutesOfDay(value);
        if (!Number.isFinite(zmanimMinutes)) return;

        if (zmanimMinutes > nowMinutes) {
          const diff = zmanimMinutes - nowMinutes;
          if (diff < nearestTime) {
            nearestTime = diff;
            nearestIdx = idx;
          }
        }
      });

      return nearestIdx;
    },
    // {dayOfWeek} on the Date/Time banner. Sunday–Thursday are plain day names,
    // but Friday and Saturday are labelled by the Shabbos window rather than the
    // calendar day: Friday reads ערב שב״ק until Hadlukas Haneiros, שבת קודש from
    // there through Saturday's Motzei, then מוצאי שב״ק for the rest of Saturday
    // night (until Sunday rolls over to יום ראשון). computeIsShabbos() owns that
    // window — candle lighting on Friday, tzeis on Saturday — so the banner can
    // never disagree with the Shabbos-gated elements sharing the screen.
    getBannerDayOfWeekLabel(date = this.currentTime || new Date()) {
      const now = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(now.getTime())) return '';

      // Day index in the org timezone, so the label tracks the screen's location
      // rather than the timezone of the device rendering it.
      const { dayIndex } = this.getDatePartsInTimeZone(now, this.getOrganizationTimeZone());

      if (dayIndex === 5 || dayIndex === 6) {
        if (this.computeIsShabbos(now)) return BANNER_SHABBOS_LABEL;
        return dayIndex === 5 ? BANNER_EREV_SHABBOS_LABEL : BANNER_MOTZEI_SHABBOS_LABEL;
      }

      return BANNER_WEEKDAY_NAMES[dayIndex] || '';
    },
    renderDateTimeBanner(content) {
      content = String(content || '');
      // Current time as h:mm:ss (12-hour) on the screen's own clock — the same
      // timezone every other time on the display is read in.
      const now = this.currentTime;
      const timeStr = this.formatZmanClock(now, { withSeconds: true });

      // Hebrew date parts of the screen's own calendar day
      const hebrewDate = this.$filters.convertToHebrewDateObject(this.getScreenCivilDate(now) || now);

      content = content.replace(/{time}/g, timeStr);
      content = content.replace(/{dayOfWeek}/g, this.getBannerDayOfWeekLabel(now));
      content = content.replace(/{dayOfMonth}/g, [hebrewDate.dayOfMonth, hebrewDate.month].filter(Boolean).join(' '));
      content = content.replace(/{month}/g, hebrewDate.month || '');
      content = content.replace(/{year}/g, hebrewDate.year || '');
      content = content.replace(/{parsha}/g, this.getSafeParshaName());

      content = content.replace(/\bundefined\b/g, '').replace(/\bnull\b/g, '');
      content = content.replace(/[ \t]{2,}/g, ' ');

      return content
    },
    getYurtzeitenImageUrl(photo) {
      return `${STORAGE_URL}/${YURTZEITEN_IMAGES_DIR}/${photo}`
    },
    getDropdownStyle(artboard) {
      return {
        position: 'absolute',
        top: this.embeddedOffsetY + artboard.topPercent * this.imageHeight * 1.1 + 'px',
        left: this.embeddedOffsetX + artboard.leftPercent * this.imageWidth + 'px',
        width: artboard.widthPercent * this.imageWidth + 'px',
        height: artboard.heightPercent * this.imageHeight + 'px',
        border: '1px dashed #2ecc71',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        overflow: 'auto'
      };
    },
    getArtboardStyle(artboard) {
      return {
        position: 'absolute',
        // embeddedOffsetX/Y shift the overlay to match the object-fit:contain
        // letterbox on the dashboard; both are 0 on the full-screen display.
        top: this.embeddedOffsetY + artboard.topPercent * this.imageHeight + 'px',
        left: this.embeddedOffsetX + artboard.leftPercent * this.imageWidth + 'px',
        width: artboard.widthPercent * this.imageWidth + 'px',
        height: artboard.heightPercent * this.imageHeight + 'px',
        border: '1px dashed #2ecc71',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        overflow: 'auto'
      };
    },
    startArtboardCarousel(artboard) {
      // Always anchor the index to the first item up front — even if no
      // elements are ready yet. Otherwise an artboard whose only element is a
      // zman-based roll (whose minyanim resolve AFTER the screen loads, once
      // zmanim are fetched) would leave displayItemIndexes[id] === undefined,
      // and the template's `v-show="displayItemIndexes[id] === index"` would
      // stay false forever, hiding the roll permanently. Carousels are
      // re-started after zmanim load (see mounted) so the timer picks up any
      // elements that appeared in the meantime.
      this.displayItemIndexes[artboard.id] = 0;

      // Cleanup previous timer if exists
      if (this.artboardTimers[artboard.id]) {
        clearTimeout(this.artboardTimers[artboard.id]);
      }

      const elements = this.getDisplayElements(artboard);
      if (!elements.length) return;

      // If only one element, no carousel needed
      if (elements.length <= 1) return;

      const scheduleNext = () => {
        const elements = this.getDisplayElements(artboard);
        if (!elements.length) {
          this.displayItemIndexes[artboard.id] = 0;
          return;
        }
        if (elements.length <= 1) {
          this.displayItemIndexes[artboard.id] = 0;
          return;
        }
        const currentIndex = Math.min(this.displayItemIndexes[artboard.id] || 0, elements.length - 1);
        this.displayItemIndexes[artboard.id] = currentIndex;
        const currentElement = elements[currentIndex] || {};

        const isDonation = currentElement.type === 'Donation' && artboard.features && artboard.features.includes('Donation');
        // Events (full and quick alike) are the elements pushed out of
        // `artboard.events`; each carries `type === 'Event'` and the template it
        // renders through, which is also what gates it into the rotation.
        const isEvent = currentElement.type === 'Event'
          && Boolean(currentElement.eventTemplate)
          && artboard.features && artboard.features.includes('Event');
        const duration = currentElement.type === 'Zmanim_N'
          ? this.getZmanimNRotationDurationMs(currentElement)
          : currentElement._isMinyanRoll
          ? this.getRollRotationDurationMs(currentElement)
          : currentElement.type === 'Poster'
          ? this.getPosterRotationDurationMs()
          : currentElement._isYurtzeitenN
          ? this.getYurtzeitenRotationDurationMs()
          : currentElement._isWeeklySchedule
          ? this.getWeeklyScheduleRotationDurationMs(currentElement)
          : currentElement.type === 'Announcement'
          ? this.getAnnouncementDisplayDurationMs()
          : isDonation
          ? this.getDonationDisplayDurationMs()
          : isEvent
          ? this.getEventDisplayDurationMs()
          : 60000;

        this.artboardTimers[artboard.id] = setTimeout(() => {
          const latestElements = this.getDisplayElements(artboard);
          if (!latestElements.length) {
            this.displayItemIndexes[artboard.id] = 0;
            return;
          }
          if (latestElements.length <= 1) {
            this.displayItemIndexes[artboard.id] = 0;
            return;
          }
          const currentIndex = Math.min(this.displayItemIndexes[artboard.id] || 0, latestElements.length - 1);
          const nextIndex = (currentIndex + 1) % latestElements.length;
          this.displayItemIndexes[artboard.id] = nextIndex;
          this.recalculateNoScrollFit(artboard);
          // The scaled-content's :key includes displayItemIndexes, so the DOM is
          // re-created on every rotation. Re-attach the observer to the new node;
          // this also runs an immediate checkOverflow for the new item's height.
          this.setupOverflowObserver(artboard);
          scheduleNext();
        }, duration);
      };

      // Kick off the recursive timeout carousel
      scheduleNext();
    },
    emitGetScreen() {
      this.$emit('refreshScreen');
    },
    getScreenImage(image) {
      return `${STORAGE_URL}/${SCREEN_IMAGES_DIR}/${image}`;
    },
    formatHebcalDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async getParsha() {
      // The week of the day on screen: the screen's own (or previewed) date.
      const today = this.getScreenCivilDate() || new Date();
      const startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay() + 1); // Monday
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // Sunday

      try {
        const parshaRes = await axios.get(`https://www.hebcal.com/leyning`, {
          params: {
            cfg: 'json',
            start: this.formatHebcalDate(startDate),
            end: this.formatHebcalDate(endDate)
          },
        });

        const todayStr = this.formatHebcalDate(today);
        const parshaItems = (parshaRes && parshaRes.data && Array.isArray(parshaRes.data.items))
          ? parshaRes.data.items
          : [];
        const parshaItem = this.getBestParshaItem(parshaItems, todayStr);
        this.parshaName = this.getMappedParshaName(parshaItem);
      } catch (error) {
        console.error('Failed to fetch parsha', error);
        this.parshaName = '';
      }
    },
    getParshaEnglishName(parshaItem) {
      const name = parshaItem?.name;
      if (!name) return '';
      return (typeof name === 'string' ? name : name.en || '').trim();
    },
    getParshaHebrewName(parshaItem) {
      const name = parshaItem?.name;
      if (!name || typeof name === 'string') return '';
      return name.he || '';
    },
    getParshaLookupCandidates(name) {
      const normalized = String(name || '')
        .trim()
        .replace(/[\u2018\u2019\u02bc]/g, "'")
        .replace(/[\u2010-\u2015]/g, '-')
        .replace(/\s+/g, ' ');
      const withoutPrefix = normalized.replace(/^(Parashat|Parsha|Parshat)\s+/i, '');
      const candidates = new Set([normalized, withoutPrefix]);

      [normalized, withoutPrefix].forEach((candidate) => {
        candidates.add(candidate.replace(/\bNaso\b/g, 'Nasso'));
        candidates.add(candidate.replace(/\bNasso\b/g, 'Naso'));
      });

      return Array.from(candidates).filter(Boolean);
    },
    hasMappedParshaName(parshaItem) {
      const result = this.getParshaEnglishName(parshaItem);
      const parshaNames = PARSHA_NAMES;
      return this.getParshaLookupCandidates(result).some((candidate) => parshaNames[candidate]);
    },
    getBestParshaItem(parshaItems, todayStr) {
      if (!Array.isArray(parshaItems) || !parshaItems.length) return null;

      const todayItem = parshaItems.find((item) => item.date === todayStr);
      if (todayItem?.parshaNum && this.hasMappedParshaName(todayItem)) return todayItem;

      return parshaItems.find((item) => item?.parshaNum && this.hasMappedParshaName(item))
        || parshaItems.find((item) => this.hasMappedParshaName(item))
        || todayItem
        || parshaItems[0];
    },
    stripHebrewVowels(text) {
      return String(text || '')
        // The API joins multi-word parsha names with a maqaf (U+05BE)
        // rather than a space. Convert it to a space first so the word gap
        // survives instead of being dropped with the vowel points below.
        .replace(/־/g, ' ')
        // Remove cantillation marks and niqqud (Hebrew points U+0591..U+05C7).
        .replace(/[֑-ׇ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    },
    withParshaPrefix(name, parshaItem) {
      const value = String(name || '').trim();
      if (!value) return '';
      if (!parshaItem?.parshaNum) return value;
      return value.includes('פרשת') ? value : `פרשת ${value}`;
    },
    getMappedParshaName(parshaItem) {
      if (!parshaItem) return '';
      const result = this.getParshaEnglishName(parshaItem);
      const parshaNames = PARSHA_NAMES;
      const mappedName = this.getParshaLookupCandidates(result)
        .map((candidate) => parshaNames[candidate])
        .find(Boolean);

      if (mappedName) return this.withParshaPrefix(mappedName, parshaItem);

      const hebrewName = this.stripHebrewVowels(this.getParshaHebrewName(parshaItem));
      if (hebrewName) return this.withParshaPrefix(hebrewName, parshaItem);

      return result || '';
    },
    getSafeParshaName() {
      const raw = this.parshaName;
      if (raw == null) return '';
      const value = String(raw).trim();
      if (!value || ['undefined', 'null'].includes(value.toLowerCase())) return '';
      return value;
    },
    // Debug helper: logs the parsha the DateTimeBanner is showing right now
    // alongside the parsha kosher-zmanim computes for the current week's Shabbos.
    async logDateTimeBannerParsha() {
      const displayed = this.getSafeParshaName();
      try {
        const { JewishCalendar, HebrewDateFormatter } = await import('kosher-zmanim');
        // getParshah() is NONE on non-Shabbos days, so step forward to the
        // coming Shabbos (or use today when today already is Shabbos).
        const shabbos = this.getScreenCivilDate() || new Date();
        shabbos.setDate(shabbos.getDate() + ((6 - shabbos.getDay() + 7) % 7));
        const calendar = new JewishCalendar(shabbos);
        calendar.setUseModernHolidays(true);

        const hebrewFormatter = new HebrewDateFormatter();
        hebrewFormatter.setHebrewFormat(true);
        const englishFormatter = new HebrewDateFormatter();
        englishFormatter.setHebrewFormat(false);

        console.log('[DateTimeBanner] Parsha displayed on screen:', displayed);
        console.log('[DateTimeBanner] Parsha from kosher-zmanim (Hebrew):', hebrewFormatter.formatParsha(calendar));
        console.log('[DateTimeBanner] Parsha from kosher-zmanim (English):', englishFormatter.formatParsha(calendar));
      } catch (error) {
        console.log('[DateTimeBanner] Parsha displayed on screen:', displayed);
        console.error('[DateTimeBanner] Failed to compute parsha from kosher-zmanim', error);
      }
    },
    hasFeature(artboard, ...featureNames) {
      const features = Array.isArray(artboard?.features) ? artboard.features : [];
      return featureNames.some((featureName) => features.includes(featureName));
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    getDisplayElements(artboard) {
      const features = artboard.features || [];
      const result = [];

      // Fallback donations and announcements are held back until everything
      // else is in, and go up only when nothing else made it onto the artboard.
      const fallbackItems = [];
      if (features.includes('Donation')) {
        const donations = (artboard.donations || []).filter((donation) => this.isDonationVisibleForActivity(donation));
        result.push(...donations.filter((donation) => !this.isFallbackItem(donation)));
        fallbackItems.push(...donations.filter((donation) => this.isFallbackItem(donation)));
      }
      if (features.includes('Announcement')) {
        const announcements = (artboard.announcements || []).filter((announcement) => this.isAnnouncementVisibleForActivity(announcement));
        result.push(...announcements.filter((announcement) => !this.isFallbackItem(announcement)));
        fallbackItems.push(...announcements.filter((announcement) => this.isFallbackItem(announcement)));
      }
      // Yurtzeiten_N has one organization-owned destination. It intentionally
      // does not require an artboard feature flag: the saved screen/artboard
      // pair is the gate, and every eligible record is aggregated there.
      const yurtzeitenDestination = this.yurtzeitenDisplayDestination;
      const isYurtzeitenDestination =
        yurtzeitenDestination &&
        String(this.screen?.id) === yurtzeitenDestination.screenId &&
        String(artboard?.id) === yurtzeitenDestination.screenArtboardId;
      if (isYurtzeitenDestination && this.yurtzeitenDisplayEligibleRecords.length) {
        // ONE element holding the screenful currently due, not one element per
        // page. The board's own timer owns which page that is, so the rotation
        // survives everything that restarts the artboard carousel — the
        // half-hourly screen poll, a socket push, the Dashboard re-selecting
        // this screen — instead of being knocked back to the first page each
        // time and leaving the later ones never shown. It also means a board
        // that is its artboard's only feature no longer depends on that carousel
        // running at all: with a single element it never starts.
        const pages = this.yurtzeitenDisplayPages;
        const pageIndex = Math.min(Math.max(this.yurtzeitenPageIndex, 0), pages.length - 1);
        result.push({
          id: `yurtzeiten-n-${artboard.id}`,
          type: 'Yurtzeiten_N',
          _isYurtzeitenN: true,
          records: pages[pageIndex] || [],
          pageIndex,
          pageCount: pages.length,
          design: this.yurtzeitenDisplayDesign,
        });
      }
      // The whole gallery becomes ONE element: a carousel that cycles its own
      // photos, rather than each photo competing for a slot in the artboard's
      // element rotation.
      // The Weekly Schedule boards, on an artboard whose Content includes
      // them — gated on the feature flag like every other type — one for each
      // schedule the payload puts on that artboard.
      result.push(...this.getWeeklyScheduleElements(artboard));
      if (features.includes('RecentPhoto')) {
        const photos = (artboard.recentPhotos || [])
          .filter((photo) => this.isRecentPhotoVisible(photo))
          .map((photo) => `${STORAGE_URL}/${RECENT_PHOTO_IMAGES_DIR}/${photo.photo}`);
        if (photos.length) {
          result.push({
            id: `recent-photos-${artboard.id}`,
            type: 'RecentPhoto',
            _isRecentPhotoCarousel: true,
            photos,
          });
        }
      }
      if (features.includes('Minyunim')) result.push(...(artboard.minyanims || []));
      if (features.includes('Zmanim')) result.push(...(artboard.zmanims || []));
      if (features.includes('DateTimeBanner')) result.push(...(artboard.dateTimeBanners || []));
      if (features.includes('Poster')) {
        result.push(...(artboard.posters || []).filter((poster) => this.isPosterVisibleForActivity(poster)));
      }
      // Events are gated on the artboard feature like every other type, and
      // additionally on being linked to an Event Template — see isEventVisible.
      if (features.includes('Event')) {
        result.push(...(artboard.events || []).filter((event) => this.isEventVisible(event)));
      }
      if (features.includes('MinyunimCountdown')) result.push(...(artboard.minyanimCountdowns || []));
      // Minyan Rolls and Upcoming Minyanim are each gated by their own feature
      // flag, exactly like every other element type: an artboard renders rolls
      // only when its `features` lists 'MinyanRoll', and upcoming content only
      // when it lists 'UpcomingMinyanim' (or legacy 'UpcomingMinyan'). The two are independent gates — they only
      // share content (an upcoming element pulls its minyan from a roll), never
      // display gating — so a roll assigned to an artboard does NOT render there
      // unless that artboard also enables the feature.
      if (features.includes('MinyanRoll')) {
        result.push(...this.getActiveMinyanRolls(artboard));
      }
      if (this.hasFeature(artboard, 'UpcomingMinyanim', 'UpcomingMinyan')) {
        result.push(...this.getActiveUpcomingMinyanims(artboard));
      }
      if (features.includes('Zmanim_N')) result.push(...(artboard.zmanims_N || []));

      if (!result.length) result.push(...fallbackItems);

      return result;
    },
    
    async fetchZmanimByZip() {
      console.log('FETCHING ZMANIN')
      try {
        console.log('this.$route.params.postCode', this.$route.query.postCode)
        const geoRes = await axios.get(`https://api.zippopotam.us/us/${this.$route.query.postCode}`);
        const place = geoRes.data.places[0];
        const lat = place.latitude;
        const lon = place.longitude;

        const tzid = 'America/New_York'; // For production, detect dynamically
        const zmanimRes = await axios.get(`https://www.hebcal.com/zmanim`, {
          params: {
            cfg: 'json',
            latitude: lat,
            longitude: lon,
            tzid: tzid,
          },
        });

        this.zmanims = zmanimRes.data?.times;

        console.log('this.zmanims => ', this.zmanims.sunrise)

        const hanachatTefillinISO = this.addMinutesWithOffset(this.zmanims.sunrise, -50);
        const alosHashacharISO = this.addMinutesWithOffset(this.zmanims.sunrise, -72);
        const plagMinchaMGA90ISO = this.addMinutesWithOffset(this.zmanims.sunrise, 361);
        const afterSunset60ISO = this.addMinutesWithOffset(this.zmanims.sunset, 60);

        let updatedZmanims = {
          ...this.zmanims,
          'hanachatTefillin': hanachatTefillinISO,
          'alosHashachar': alosHashacharISO,
          'plagMinchaMGA90': plagMinchaMGA90ISO,
          'afterSunset60': afterSunset60ISO,
        }

        console.log('plagMinchaMGA90ISO => ', this.zmanims.sunrise, plagMinchaMGA90ISO, 361)

        this.zmanims = updatedZmanims

      } catch (e) {
        console.log('error', e)
        // this.$toast.error('Unable to fetch Zmanims.', TOAST_GLOBAL_CONFIG)
      }
    },
    getScreenOrganizationLocationQuery() {
      const { address, postCode } = this.getScreenLocationConfig();
      return [address, postCode].filter(Boolean).join(', ');
    },
    async fetchOpenCageLocationAndZmanim() {
      try {
        const { latitude: cfgLat, longitude: cfgLng, timezone: cfgTimezone } = this.getScreenLocationConfig();
        // The screen's saved lat/lng are authoritative. Use them whenever
        // present, even if no timezone was saved — fall back to the display
        // device's own timezone (the screen runs at the venue) so a configured
        // location still yields kosher-zmanim instead of dropping to geocoding.
        const hasConfiguredCoords = Number.isFinite(cfgLat) && Number.isFinite(cfgLng);

        let locationName;
        let latitude;
        let longitude;
        let timezone;

        if (hasConfiguredCoords) {
          latitude = cfgLat;
          longitude = cfgLng;
          timezone =
            cfgTimezone ||
            Intl.DateTimeFormat().resolvedOptions().timeZone ||
            'UTC';
          locationName =
            this.getScreenOrganizationLocationQuery() ||
            `${latitude}, ${longitude}`;
        } else {
          const organizationLocationQuery = this.getScreenOrganizationLocationQuery();
          let geocodeQuery = organizationLocationQuery;

          if (!geocodeQuery) {
            return null;
          }

          let geocodeRes = await axios.get('https://api.opencagedata.com/geocode/v1/json', {
            params: {
              key: OPENCAGE_API_KEY,
              q: geocodeQuery,
              pretty: 1,
            },
          });

          let result = geocodeRes?.data?.results?.[0];
          if (!result?.geometry) {
            throw new Error('Location not found');
          }

          locationName = result.formatted || geocodeQuery;
          latitude = Number(result.geometry.lat);
          longitude = Number(result.geometry.lng);
          timezone =
            result?.annotations?.timezone?.name ||
            Intl.DateTimeFormat().resolvedOptions().timeZone ||
            'UTC';
        }

        const kosherZmanim = await import('kosher-zmanim');
        const { ComplexZmanimCalendar, GeoLocation, JewishCalendar } = kosherZmanim;
        this.jewishCalendarConstructor = JewishCalendar;
        const geoLocation = new GeoLocation(locationName, latitude, longitude, 0, timezone);
        const zmanimCalendar = new ComplexZmanimCalendar(geoLocation);
        // A new calendar starts on the real today; previewing a date, it is that
        // date's zmanim the display runs on.
        const previewDay = this.previewDate ? parseDateValue(this.previewDate) : null;
        if (previewDay) zmanimCalendar.setDate(toLocalNoon(previewDay));
        this._kosherZmanimCalendar = zmanimCalendar;
        // The Shabbos anchors are cached per week, not per place. A calendar
        // for somewhere else — a schedule link or the Dashboard switching to a
        // screen in another location — has to rebuild them instead of keeping
        // the old place's.
        const zmanimLocationKey = `${latitude}|${longitude}|${timezone}`;
        if (this._zmanimLocationKey !== zmanimLocationKey) {
          this._zmanimLocationKey = zmanimLocationKey;
          this._shabbosAnchorWeekKey = null;
        }
        // A new calendar means a (possibly) new location: drop the cached
        // Weekly Static Zman values so they recompute from this calendar.
        this._weeklyStaticZmanCache = null;

        const kosherZmanimMap = this.buildKosherZmanimMap(zmanimCalendar);
        const sunrise = kosherZmanimMap.sunrise || '';

        const mergedZmanim = {
          ...(this.zmanims || {}),
          ...kosherZmanimMap,
        };

        this.kosherZmanimLookup = kosherZmanimMap;
        this.zmanims = mergedZmanim;
        this.deviceSunrise = sunrise || this.deviceSunrise;
        this.geoLocationName = locationName;
        this.geoLocationCoords = { lat: latitude, lng: longitude };
        this.geoLocationTimezone = timezone;

        // Build / refresh this week's locked Shabbos anchor zmanim (no-op when
        // already built for the current week).
        this.ensureShabbosAnchorZmanim();

        return {
          location: locationName,
          coords: { lat: latitude, lng: longitude },
          timezone,
          zmanim: kosherZmanimMap,
        };
      } catch (error) {
        console.warn('Unable to fetch OpenCage location or kosher zmanim.', error);
        return null;
      }
    },
    // Helper to add/subtract minutes in UTC and format with original offset
    addMinutesWithOffset(originalStr, minutesToAdd) {
      if (!originalStr) return '';
      const str = String(originalStr);
      // Detect the trailing timezone designator: 'Z' (UTC) or '±HH:MM'.
      // kosher-zmanim emits UTC ('...Z') values, so we must not assume a
      // numeric offset — slicing the last 6 chars of a 'Z' string produced a
      // malformed date (e.g. '...:422.824Z' → Invalid Date).
      const suffixMatch = str.match(/(Z|[+-]\d{2}:\d{2})$/);
      const suffix = suffixMatch ? suffixMatch[1] : '';
      let offsetMinutes = 0;
      if (suffix && suffix !== 'Z') {
        const sign = suffix[0] === '-' ? -1 : 1;
        offsetMinutes = sign * (parseInt(suffix.slice(1, 3), 10) * 60 + parseInt(suffix.slice(4, 6), 10));
      }

      // Work in UTC
      const origUtcMs = new Date(str).getTime();
      if (!Number.isFinite(origUtcMs)) return '';
      const shiftedUtcMs = origUtcMs + Number(minutesToAdd) * 60000;

      // Convert to "wall time" in the original offset by adding the offset to UTC,
      // then read components with getUTC* (so we don't use your computer's timezone).
      const wallMs = shiftedUtcMs + offsetMinutes * 60000;
      const wall = new Date(wallMs);

      const pad = n => String(n).padStart(2, '0');
      const yyyy = wall.getUTCFullYear();
      const mm = pad(wall.getUTCMonth() + 1);
      const dd = pad(wall.getUTCDate());
      const hh = pad(wall.getUTCHours());
      const mi = pad(wall.getUTCMinutes());
      const ss = pad(wall.getUTCSeconds());
      const outSuffix = suffix || 'Z'; // preserve the original designator (default UTC)

      return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}${outSuffix}`;
    },
    addMinutesISO(originalStr, minutesToAdd) {
      const value = new Date(originalStr).getTime();
      if (!Number.isFinite(value)) return '';
      return new Date(value + Number(minutesToAdd) * 60000).toISOString();
    },
    getLocalISOStringWithOffset(date, originalStr) {
      // Get the original offset from the string (e.g. "-04:00")
      const offset = originalStr.slice(-6);
      const pad = n => String(n).padStart(2, '0');
      const yyyy = date.getFullYear();
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}${offset}`;
    },
    getLocalISOString(date) {
      // Returns ISO string with local time zone offset
      const tzOffset = -date.getTimezoneOffset();
      const diff = tzOffset >= 0 ? '+' : '-';
      const pad = n => String(Math.floor(Math.abs(n))).padStart(2, '0');
      return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        diff + pad(tzOffset / 60) + ':' + pad(tzOffset % 60);
    },
    getScreen(options = {}) {
      // A silent refresh keeps the current screen on-screen and swaps its content
      // in place — no "Loading Screen..." overlay. Because SET_SCREEN preserves
      // the existing screen.data while isLoading is true, the display never blanks;
      // suppressing screenIsLoading (via isSilentRefreshing) keeps it unnoticeable.
      const silent = options.silent ?? false;
      // Silent refreshes can overlap (a schedule switch landing during the
      // half-hourly poll), so only the latest one may drop the flag — an older
      // one finishing first would otherwise flash the loading overlay.
      const silentToken = silent ? (this._silentRefreshToken || 0) + 1 : null;
      if (silent) {
        this._silentRefreshToken = silentToken;
        this.isSilentRefreshing = true;
      }

      const today = new Date();
      const startDateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 1);
      const endDateObj = new Date();

      const startDate = this.getLocalISOString(startDateObj);
      const endDate = this.getLocalISOString(endDateObj);

      const offsetMinutes = new Date().getTimezoneOffset();

      return this.$store.dispatch(GET_SCREEN, {
        id: this.displayScreenId,
        startDate,
        endDate,
        offset: offsetMinutes
      }).then(async (result) => {
        // Overtaken by a newer fetch (a switch to another screen): nothing was
        // committed, and the newer request does the starting-up.
        if (result === SCREEN_REQUEST_STALE || !this.screen) return result;

        await Promise.allSettled([
          this.getOrganization(),
          this.loadCustomFonts(),
          this.loadZmanimDisplayOverrides(),
        ]);
        await this.loadYurtzeitenDisplay({
          force: true,
          startDate,
          endDate,
        });
        await this.loadWeeklyScheduleDisplay();

        this.screen.artboards.forEach((artboard, idx) => {
          // Shuffle if needed
          // artboard.shuffledElements = this.shuffleArray([
          //   ...artboard.donations,
          //   ...artboard.announcements,
          // ]);

          // this.zmanimsArray.push(...artboard.zmanims)
          // Start carousel for this artboard
          this.startArtboardCarousel(artboard, idx);

        });

        this.updateNearestFutureZmanimIndexes();
        this.syncYurtzeitenPageRotation();

        this.screen.artboards.forEach(artboard => {
          this.checkOverflow(artboard);
          this.recalculateNoScrollFit(artboard);
        });

        if (silent) {
          console.log('REFRESHED');
        }
        return result;
      }).finally(() => {
        if (silent && this._silentRefreshToken === silentToken) {
          this.isSilentRefreshing = false;
        }
      });
    },
    isShowingScreen(id) {
      return Boolean(id) && String(this.screen?.id || '').toLowerCase() === String(id).toLowerCase();
    },
    // Brings the screen asked for (displayScreenId) on air, silently, and keeps
    // trying on a backoff if the fetch fails — a TV left on the previous screen
    // after a dropped request must still catch up with its schedule.
    loadRequestedScreen() {
      if (this.screenSwitchRetryTimer) {
        clearTimeout(this.screenSwitchRetryTimer);
        this.screenSwitchRetryTimer = null;
      }
      const requestedId = this.displayScreenId;
      if (!requestedId || this.screenOverride) return Promise.resolve(false);

      // Nothing was on air before: the screen watcher only rebuilds the zmanim
      // on a change of screen, so a first screen landing late needs it here.
      const hadScreen = Boolean(this.screen);

      const settle = (result) => {
        // A newer request owns the outcome, or the display moved on.
        if (result === SCREEN_REQUEST_STALE || this.displayScreenId !== requestedId) return;

        if (this.isShowingScreen(requestedId)) {
          this.screenSwitchRetryDelay = 0;
          if (!hadScreen) this.fetchOpenCageLocationAndZmanim();
          return;
        }
        // The server answered, and has no such screen (deleted, or a mistyped
        // link): asking again will not change that. A schedule link hears
        // about a removed member over its own socket and switches away.
        if (result === true) {
          this.screenSwitchRetryDelay = 0;
          return;
        }

        this.screenSwitchRetryDelay = Math.min(
          Math.max(this.screenSwitchRetryDelay * 2, 15 * 1000),
          60 * 1000
        );
        this.screenSwitchRetryTimer = setTimeout(() => {
          this.screenSwitchRetryTimer = null;
          this.loadRequestedScreen();
        }, this.screenSwitchRetryDelay);
      };

      return this.getScreen({ silent: true }).then(settle, () => settle(false));
    },
    // The display runs unauthenticated off a screen id, so it fetches the font
    // library for the screen's own organization rather than a signed-in one.
    // The store hands every face to the browser as the list lands, which is what
    // makes a design that points at an uploaded family render in it here.
    loadCustomFonts() {
      const organizationId = this.screen?.organizationId || this.screen?.organization?.id || this.organization?.id;
      if (!organizationId) return;
      this.$store.dispatch(GET_CUSTOM_FONTS, { organizationId });
    },
    async loadZmanimDisplayOverrides() {
      const organizationId = this.screen?.organizationId || this.screen?.organization?.id || this.organization?.id;
      if (!organizationId) return;
      const result = await this.$store.dispatch(GET_ZMANIM_DISPLAY_OVERRIDES_N, { organizationId });
      this.zmanimDisplayOverrides = Array.isArray(result) ? result : [];
      // The Shabbos anchor maps bake in that week's candle / motzei times, so they
      // must be rebuilt now that the Special Zmanim settings are known — this
      // request races the zmanim load, and the anchors may already have been built
      // from the built-in defaults. Invalidating the week key forces a rebuild;
      // it is a cheap no-op until the kosher-zmanim calendar exists.
      this._shabbosAnchorWeekKey = null;
      this.ensureShabbosAnchorZmanim();
      // Weekly Static Zman values can resolve candle/motzei from these settings
      // too, so drop that cache as well — it lazily rebuilds on the next render.
      this._weeklyStaticZmanCache = null;
    },
    checkOverflow(artboard) {
      if (!artboard?.id) return;
      this.$nextTick(() => {
        setTimeout(() => {
          let scrollContentRef = this.$refs['artboardScrollContent' + artboard.id];
          if (Array.isArray(scrollContentRef)) scrollContentRef = scrollContentRef[0];
          if (!scrollContentRef) return;

          const tracks = scrollContentRef.querySelectorAll('.credits-track');
          if (!tracks.length) {
            if (this.isOverflowing[artboard.id] !== false) {
              this.isOverflowing[artboard.id] = false;
            }
            if (this.isOverflowingHorizontally[artboard.id] !== false) {
              this.isOverflowingHorizontally[artboard.id] = false;
            }
            return;
          }

          // Force reflow so measurements reflect the current layout
          scrollContentRef.getBoundingClientRect();

          // Compare in the same space the vertical content is laid out in: the
          // scaled-content box is sized displayed / designScale, and the track's
          // scrollHeight is a layout value unaffected by the scale transform. So
          // the threshold is the artboard's displayed height divided by
          // designScale — resolution-independent (designScale cancels the screen
          // size), so static <-> scroll never oscillates and overflow is judged
          // correctly on every screen. At the baseline width designScale === 1,
          // so this equals the displayed height (unchanged from before).
          const scale = this.designScale || 1;
          const containerHeight = (artboard.heightPercent * this.imageHeight) / scale;
          if (!containerHeight) return; // dimensions not known yet

          // Measure a single track. When overflow is true two copies render
          // for the seamless loop, so measuring the container's scrollHeight
          // would double-count and never report "fits" again.
          const trackHeight = tracks[0].scrollHeight;
          const trackWidth = tracks[0].scrollWidth;

          // Record the single-copy size so getCreditsScrollerStyle() can derive
          // a constant-speed animation duration (distance / defaultScrollSpeed).
          const prevSizes = this.scrollTrackSizes[artboard.id];
          if (!prevSizes || prevSizes.height !== trackHeight || prevSizes.width !== trackWidth) {
            this.scrollTrackSizes[artboard.id] = { height: trackHeight, width: trackWidth };
          }

          // 1px tolerance absorbs sub-pixel rounding so the class doesn't flip on rounding noise.
          const overflows = trackHeight > containerHeight + 1;
          if (this.isOverflowing[artboard.id] !== overflows) {
            this.isOverflowing[artboard.id] = overflows;
          }

          // The same test across instead of down, for the horizontal marquee.
          // Measured against the scroll box's own client width rather than a
          // computed one: both are real boxes in this subtree, so the comparison
          // needs no scale arithmetic and cannot drift from it.
          //
          // A row that already fits has nothing to scroll, and duplicating it
          // for the loop is what put the same card on screen twice side by side.
          const containerWidth = scrollContentRef.clientWidth;
          const overflowsHorizontally = containerWidth
            ? trackWidth > containerWidth + 1
            : false;
          if (this.isOverflowingHorizontally[artboard.id] !== overflowsHorizontally) {
            this.isOverflowingHorizontally[artboard.id] = overflowsHorizontally;
          }
        }, 0);
      });
    },
    setupOverflowObserver(artboard) {
      if (!artboard?.id) return;
      this.teardownOverflowObserver(artboard);

      this.$nextTick(() => {
        let scrollContentRef = this.$refs['artboardScrollContent' + artboard.id];
        if (Array.isArray(scrollContentRef)) scrollContentRef = scrollContentRef[0];
        if (!scrollContentRef) return;

        // Run explicit checks so the initial state is correct even before the observer fires.
        this.checkOverflow(artboard);
        this.recalculateNoScrollFit(artboard);

        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(() => {
          this.checkOverflow(artboard);
          this.recalculateNoScrollFit(artboard);
        });
        observer.observe(scrollContentRef);
        const track = scrollContentRef.querySelector('.credits-track');
        if (track) observer.observe(track);
        const staticZmanimTickerTrack = scrollContentRef.querySelector('.zmanim-n-display--list-horizontal-static .zmanim-n-ticker-track');
        if (staticZmanimTickerTrack) observer.observe(staticZmanimTickerTrack);
        this.overflowObservers[artboard.id] = observer;
      });
    },
    teardownOverflowObserver(artboard) {
      const observer = this.overflowObservers[artboard?.id];
      if (observer) {
        observer.disconnect();
        delete this.overflowObservers[artboard.id];
      }
    },
    // For noscroll artboards: measure the visible content vs. the artboard and
    // compute a shrink-to-fit scale. Returns scale=1 when content fits (no
    // shrinking) and a smaller scale when content overflows. scrollWidth /
    // scrollHeight are layout-based and unaffected by any existing transform,
    // so re-measuring after applying a scale stays stable (no feedback loop).
    recalculateNoScrollFit(artboard) {
      if (!artboard?.id || artboard.scrollDirection !== 'noscroll') return;
      this.$nextTick(() => {
        setTimeout(() => {
          let scrollContentRef = this.$refs['artboardScrollContent' + artboard.id];
          if (Array.isArray(scrollContentRef)) scrollContentRef = scrollContentRef[0];
          if (!scrollContentRef) return;
          const track = scrollContentRef.querySelector('.credits-track');
          if (!track) return;

          const staticZmanimTickerTrack = scrollContentRef.querySelector('.zmanim-n-display--list-horizontal-static .zmanim-n-ticker-track');
          if (staticZmanimTickerTrack) {
            const display = staticZmanimTickerTrack.closest('.zmanim-n-display');
            const displayWidth = display?.clientWidth || scrollContentRef.clientWidth;
            const displayStyle = display && typeof window !== 'undefined' ? window.getComputedStyle(display) : null;
            const horizontalPadding = displayStyle
              ? (parseFloat(displayStyle.paddingLeft) || 0) + (parseFloat(displayStyle.paddingRight) || 0)
              : 0;
            const containerWidth = Math.max(displayWidth - horizontalPadding, 0);
            const contentWidth = staticZmanimTickerTrack.scrollWidth;
            if (!containerWidth || !contentWidth) return;

            const newScale = Math.min(containerWidth / contentWidth, 1);
            const current = this.zmanimNHorizontalFitScales[artboard.id] ?? 1;
            if (Math.abs(current - newScale) >= 0.001) {
              this.zmanimNHorizontalFitScales[artboard.id] = newScale;
            }
            if ((this.noScrollFitScales[artboard.id] ?? 1) !== 1) {
              this.noScrollFitScales[artboard.id] = 1;
            }
            return;
          }

          if ((this.zmanimNHorizontalFitScales[artboard.id] ?? 1) !== 1) {
            this.zmanimNHorizontalFitScales[artboard.id] = 1;
          }

          const containerWidth = scrollContentRef.clientWidth;
          const containerHeight = scrollContentRef.clientHeight;
          const contentWidth = track.scrollWidth;
          const contentHeight = track.scrollHeight;
          if (!containerWidth || !containerHeight || !contentWidth || !contentHeight) return;

          const widthRatio = containerWidth / contentWidth;
          const heightRatio = containerHeight / contentHeight;
          const newScale = Math.min(widthRatio, heightRatio, 1);
          const current = this.noScrollFitScales[artboard.id] ?? 1;
          if (Math.abs(current - newScale) < 0.001) return;

          this.noScrollFitScales[artboard.id] = newScale;
        }, 0);
      });
    },
    getNoScrollTrackStyle(artboard) {
      if (artboard?.scrollDirection !== 'noscroll') return {};
      const scale = this.noScrollFitScales[artboard.id];
      if (!scale || scale >= 1) return {};
      return {
        transform: `scale(${scale})`,
        transformOrigin: 'top center',
      };
    },
    // Whether to render two stacked/side-by-side content copies so the credits
    // scroll loops seamlessly. Zmanim_N (its own ticker) and noscroll never do.
    shouldDuplicateScrollTracks(artboard) {
      if (!artboard?.id) return false;
      if (this.isCurrentZmanimNHorizontalTicker(artboard)) return false;
      if (this.isCurrentRecentPhotoDisplay(artboard)) return false;
      // A yahrzeit row is NEVER duplicated. The second copy exists only to make
      // a scroll loop seamless, and on a memorial board that cost is not payable
      // in any circumstance: it puts the same person on screen twice, side by
      // side, which reads as a fault rather than as a loop. A row too wide for
      // its artboard is clipped instead — the column count and card size are
      // what size it, and both are set in the design.
      if (this.isCurrentYurtzeitenNDisplay(artboard)) return false;

      // Every other feature: a second copy exists only to make a loop seamless,
      // so content that already fits is rendered once. Without this a horizontal
      // artboard showed every item twice side by side.
      const direction = this.getArtboardScrollDirection(artboard);
      if (direction === 'horizontal') {
        return Boolean(this.isOverflowingHorizontally[artboard.id]);
      }
      if (direction === 'vertical') return Boolean(this.isOverflowing[artboard.id]);
      return false; // noscroll
    },
    // Drive the credits-scroll animation duration from the measured content size
    // and the single `defaultScrollSpeed` variable so every feature scrolls at a
    // constant, readable speed (and always reveals all of its content). Zmanim_N
    // is intentionally excluded — it keeps its own rotationSpeed-based duration.
    getCreditsScrollerStyle(artboard) {
      if (!artboard?.id) return {};
      if (this.isCurrentZmanimNHorizontalTicker(artboard)) return {};
      if (this.isCurrentRecentPhotoDisplay(artboard)) return {};

      // Same predicate as the duplication: the animation translates by exactly
      // one copy, so a track rendered as a single copy must not be animated at
      // all — it would slide off its own edge and leave the artboard empty.
      if (!this.shouldDuplicateScrollTracks(artboard)) return {};

      const direction = this.getArtboardScrollDirection(artboard);
      const sizes = this.scrollTrackSizes[artboard.id];
      let distance = 0;
      if (direction === 'vertical') {
        distance = sizes?.height || 0;
      } else if (direction === 'horizontal') {
        distance = sizes?.width || 0;
      } else {
        return {}; // noscroll → no animation
      }
      if (!distance) return {}; // not measured yet → fall back to the CSS default

      const speed = this.effectiveDefaultScrollSpeed > 0 ? this.effectiveDefaultScrollSpeed : 50;
      const duration = Math.max(distance / speed, this.effectiveMinScrollDuration);
      return { animationDuration: `${duration}s` };
    },
    getOrganization() {
      const organizationId =
        this.screen?.organizationId ||
        this.screen?.organization?.id;
      if (!organizationId) return Promise.resolve(false);
      return this.$store.dispatch(GET_ORGANIZATION, { id: organizationId });
    },
    updateNearestFutureZmanimIndexes() {
      if (!this.zmanimsArray) return;
      this.zmanimsArray.forEach((zmanim, idx) => {
        // Use zmanim.id if available, otherwise idx
        const key = zmanim.id || idx;
        this.nearestFutureZmanimIndexes[key] = this.zmanimAfterNowIndex(zmanim.zmanimList);
      });
    },
    updateNearestFutureRoomIndexes() {
      if (!this.minyanimTypes) return;
      this.minyanimTypes.forEach((type, idx) => {
        this.nearestFutureRoomIndexes[idx] = this.getNearestFutureRoomIndex(type.minyanimRooms);
      });
    },
    initiateSocket() {
      if (this.socket) return;
      this.socket = io(API_URL, {
        withCredentials: true,
        transports: ['websocket', 'polling'], // Try WebSockets first, then fallback to polling
      });

      this.socket.on('connect', () => {
        console.log('SOCKET CONNECTED');
      });

      this.socket.on(REFRESH_SCREEN_SOCKET_EVENT, async (data) => {
        const refreshedScreenId = data?.screen?.id;
        const currentScreenId = this.screen?.id || this.displayScreenId;
        if (!refreshedScreenId || String(refreshedScreenId).toLowerCase() !== String(currentScreenId || '').toLowerCase()) return;

        console.log('DISPLAY REFRESH TRIGGERED');
        if (this.screenOverride) {
          // The Dashboard owns the selected screen object. Refresh shared
          // organization settings here, then ask the parent to replace that
          // screen payload without remounting the whole dashboard.
          await Promise.allSettled([this.getOrganization()]);
          this.$emit('screen-refresh');
          return;
        }
        // A schedule link mid-switch: the screen on air is on its way out, and
        // loadRequestedScreen is already bringing in the one asked for.
        if (this.screen && !this.isShowingScreen(this.displayScreenId)) return;
        await this.getScreen({ silent: true });
      });
    },
  },
  created() {
    // Start on the display's own clock (a previewed date, on the Dashboard), so
    // not even the first render reads the wrong day. Whether a previewed time
    // range runs from its start is settled once, here, so the clock never jumps.
    this._previewClockOrigin = Date.now();
    const range = this.previewRange;
    const opening = range
      ? getPreviewOpeningInstant(this.previewDate, this.previewStartTime, this.previewEndTime, this.getOrganizationTimeZone())
      : null;
    this._previewRunsFromRangeStart = Boolean(opening && opening.getTime() === range.from.getTime());
    this.currentTime = this.getDisplayNow();
  },
  async mounted() {
    this._displayMounted = true;
    window.addEventListener('resize', this.handleResize);
    this.today = DAYS_OF_THE_WEEK[(this.getScreenCivilDate() || new Date()).getDay()];
    // await this.fetchZmanimByZip()
    // Load the screen first so screen.organization can drive the OpenCage lookup.
    if (this.screenOverride) {
      this.isBackgroundLoading = false;
      await Promise.allSettled([
        this.getOrganization(),
        this.loadCustomFonts(),
        this.loadZmanimDisplayOverrides(),
      ]);
      await this.loadYurtzeitenDisplay({ force: true });
      await this.loadWeeklyScheduleDisplay();
      // Torn down while those were in flight (the Dashboard re-keys its preview
      // on every screen or date switch): nothing below may start timers that
      // would outlive it.
      if (!this._displayMounted) return;
      this.refreshCurrentScreenArtboards();
    } else {
      await this.getScreen().catch(() => false)
      if (!this._displayMounted) return;
      // The first fetch failed (a TV that booted before its network): keep
      // trying rather than waiting for the half-hourly refresh.
      if (!this.isShowingScreen(this.displayScreenId)) this.loadRequestedScreen();
    }
    await this.fetchOpenCageLocationAndZmanim()
    if (!this._displayMounted) return;
    this.lastDonationActivityShabbosState = this.isDonationShabbosNow();
    // Zmanim are now loaded, so zman-based roll minyanim (and any other elements
    // that depend on zmanim) can resolve. Re-start each artboard's carousel so
    // elements that weren't ready when the screen first loaded are picked up and
    // actually shown (their displayItemIndexes get anchored / their rotation
    // timer starts). Without this a zman-based MinyanRoll never appears.
    if (this.screen?.artboards) {
      this.$nextTick(() => {
        this.screen.artboards.forEach((artboard) => this.startArtboardCarousel(artboard));
        this.syncYurtzeitenPageRotation();
      });
    }
    await this.getParsha()
    if (!this._displayMounted) return;
    this.logDateTimeBannerParsha()
    this.intervalIds.push(setInterval(() => { this.getParsha() }, 43200000));

    // Both the live route and Dashboard's embedded selected-screen renderer
    // listen for the same backend refresh event. Only the live route owns the
    // periodic poll; Dashboard already has its own refresh cadence.
    this.initiateSocket()

    if (!this.screenOverride) {
      // call getScreen every 30 minutes — silent so the screen refreshes in the
      // background without flashing the loading overlay (logs 'REFRESHED').
      this.intervalIds.push(setInterval(() => { this.getScreen({ silent: true }); }, 30 * 60 * 1000)); // 1,800,000 ms
    }

    // keep zmanim refreshed at 5 minutes
    this.intervalIds.push(setInterval(() => {
      // this.fetchZmanimByZip();
      this.fetchOpenCageLocationAndZmanim().then(() => this.handleDonationActivityClockTick());
    }, 5 * 60 * 1000)); // 300,000 ms

    this.intervalIds.push(setInterval(() => {
      this.updateNearestFutureRoomIndexes();
    }, 60000)); // every 1 minute
    this.updateNearestFutureZmanimIndexes();
    this.intervalIds.push(setInterval(() => {
      this.updateNearestFutureZmanimIndexes();
    }, 60000)); // every 1 minute
    this.intervalIds.push(setInterval(() => {
      this.currentTime = this.getDisplayNow();
      this.handleDonationActivityClockTick();
      this.handleFallbackItemClockTick();
    }, 1000));
    this.refreshYurtzeitenDisplayDay();
    this.intervalIds.push(setInterval(() => {
      this.refreshYurtzeitenDisplayDay();
    }, 60000)); // every 1 minute — the yahrzeit window only turns over at midnight
  },
  beforeDestroy() {
    this.cleanupDisplayResources();
  },
  beforeUnmount() {
    this.cleanupDisplayResources();
  },
}
</script>

<style scoped>
/* Make the main content stretch full width */
body, html, #app {
  width: 100vw;
  min-width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

.image-container {
  width: 100vw !important;
  max-width: 100vw !important;
  margin: 0 !important;
  padding: 0 !important;
}

.screen-display-root {
  position: relative;
}

.screen-display-root--embedded {
  display: block;
  flex: 0 0 auto;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
  overflow: visible;
}

.screen-display-root--embedded .image-container {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  overflow: visible;
}

.screen-display-root--embedded .screen-background-image {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: contain;
}

.artboard-wrapper {
  box-sizing: border-box;
}

.artboard-box-inner {
  width: 100%;
  height: 100%;
  overflow: hidden; /* Hide scrollbars and allow credits animation */
  position: relative;
}

.scaled-content {
  box-sizing: border-box;
  overflow: hidden;
}

.image-container {
  margin: 0px!important;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  /* Full viewport height */
  width: 100%;
  background-color: #f3f3f3; /* Optional: Add a background color while loading */
}

.loading-content {
  text-align: center;
}

/* Styles for minyanim roll elements */
.design-preview {
  padding: 16px;
  overflow: hidden;
}


.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10; /* Ensure it appears above the image */
  /* background-color: rgba(0, 0, 0, 0.5); */ /* Optional: Add a semi-transparent background */
  background-color: transparent;
  color: white; /* Optional: Ensure text is visible */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  transition: opacity 0.3s ease-in-out;
}

.navbar .transparent {
  background-color: transparent !important;
}

.hover-area {
  position: fixed;
  top: 0;
  height: 40%;
  width: 100%;
}

.navbar .fullscreen-toggle {
  margin-right: 1%;
}

.navbar .pi {
  font-size: 22px;
  color: #5A5A57;
  cursor: pointer;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  /* Full viewport height */
  width: 100%;
  background-color: #f3f3f3; /* Optional: Add a background color while loading */
}

.loading-content {
  text-align: center;
}

.image-container {
  position: relative;
  display: inline-block;
  margin-top: 1rem;
}

.artboard-box {
  box-sizing: border-box;
}

.btn-custom-primary {
  padding: 0.5rem 1.6rem 0.5rem 1.6rem;
}

.btn-custom-primary .pi-ellipsis-h {
  font-size: 0.9rem;
}

.artboard-wrapper {
  position: absolute;
  /* border: 1px dashed #2ecc71;
  background-color: rgba(255, 255, 255, 0.8); */
  border: none!important;
  background-color: transparent!important;
  overflow: visible !important;
  z-index: 2;
}

.dropdown-container {
  position: absolute;
  top: -43px;
  left: 0;
  right: 0;
  z-index: 3;
}

.artboard-box-inner {
  overflow: hidden !important;  /* Fully hides scrollbars */
  height: 100%;
}

/* Every display item carries Quill's .ql-editor class, whose global CSS forces
   `height: 100%` + `overflow-y: auto` (and, since one axis is non-visible, the
   browser promotes overflow-x to auto too). That turns a plain item — Donation,
   Announcement, DateTimeBanner, Poster, MinyanimCountdown — into an internal,
   height-clamped scroll box, which is doubly wrong: it renders native
   scrollbars, AND it hides the content's true height from recalculateNoScrollFit
   (which measures the parent .credits-track's scrollHeight). With the overflow
   contained inside the item, the track looks like it fits, the shrink-to-fit
   scale stays 1, and a noscroll artboard overflows instead of scaling down.
   Undo both: let the item take its natural height with visible overflow, so the
   real height propagates to the track and the existing noscroll fit-scale (or
   the vertical/horizontal scroll animation) does the fitting — never a
   scrollbar. Scoped to the plain rich-text items only — the structured feature
   items (roll / zmanim-n / upcoming) render their own components, keep their
   overflow:hidden override below, and rely on Quill's height:100% for internal
   layout, so they are deliberately excluded. */
.display-item:not(.roll-display-item):not(.zmanim-n-display-item):not(.upcoming-minyan-display-item):not(.recent-photo-display-item):not(.yurtzeiten-n-display-item) {
  height: auto;
  overflow: visible;
}

.roll-display-item {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* The Weekly Schedule board spans its artboard and keeps its natural height,
   which is what the scroll and no-scroll fitting measure. On a horizontal
   (marquee) track it is as wide as its one line of content instead. */
.weekly-schedule-display-item {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.credits-scroll-horizontal .weekly-schedule-display-item,
.credits-horizontal-static .weekly-schedule-display-item {
  width: max-content;
  max-width: none;
}

.zmanim-n-display-item {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.upcoming-minyan-display-item {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* Recent Photos owns its own stepped/continuous motion, but the frame itself
   must be exactly the artboard's available height. The images inside the
   component stay object-fit: contain, so nothing is cropped when the artboard
   is short or when several photos are visible at once. */
.recent-photo-display-item {
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.credits-recent-photo,
.credits-recent-photo .credits-track,
.credits-recent-photo .recent-photo-display-item {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.credits-recent-photo :deep(.rpc) {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: auto;
}

/* A blank line the template's author left with Enter.
 *
 * TipTap saves it as an empty <p>, and ProseMirror draws that paragraph with a
 * trailing <br> of its own, so inside the editor it holds a full line. Rendered
 * here it has no inline content at all, so it generates no line box, and with
 * Quill's `.ql-editor p { margin: 0 }` it takes up nothing whatsoever — the gap
 * the author left between two fields never reached the screen. An empty
 * inline-block gives the paragraph its line box back: one `line-height` tall,
 * and no characters wide.
 *
 * Keyed off the marker renderEventContent sets before it substitutes, not off
 * `:empty`: a paragraph left empty by a {token} this event has no value for
 * must keep collapsing rather than open a gap — see
 * utils/authored_blank_lines.ts. Announcements and donations need none of this;
 * Quill writes a blank line as <p><br></p>, which draws one on its own. */
.event-template-item :deep([data-blank-line])::before {
  content: '';
  display: inline-block;
}

/* A blank line made on a split row carries that row's inline `display: flex`
   with it — Enter copies a paragraph's attributes onto the one it creates
   (TipTap's `keepOnSplit`, on by default), so this is the ordinary way a blank
   line under a split row arrives. As a flex container the ::before above would
   be a zero-sized flex item and still generate no line box, so the row is laid
   out as the plain blank line it is; holding nothing, it has no pieces left to
   push apart. `!important` because the split style is authored inline, and an
   inline style outranks any selector. */
.event-template-item :deep([data-blank-line][data-split="true"]) {
  display: block !important;
}

/* Photos an Event Template drops in through its {image} token. The layout is
   authored at an arbitrary width, so the photo is bounded by the column it
   lands in rather than by its own natural size. :deep because the markup is
   inserted with v-html and so carries no scope attribute of its own. */
/* A split row carries its own inline flex style from the editor; this only
   keeps its pieces from collapsing to zero width, matching the editor canvas. */
.display-item :deep([data-split="true"]) > * {
  min-width: 0;
}

.display-item :deep(.event-template-photo) {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

/* A photo the template's author gave a size to.
 *
 * The box itself is laid out by the inline geometry the editor saved with it —
 * a width as a PERCENTAGE of the column, and a height as a ratio of that width
 * (see utils/event_template_image.ts). Nothing about that needs a stylesheet;
 * a percentage is exactly what carries the authored proportion from the
 * editor's canvas onto an artboard of any size, on a screen of any resolution,
 * and through the dashboard's scaled-down preview of the same board. This only
 * says how the photo sits inside the box it was given.
 *
 * `contain` rather than `cover` or a plain stretch: a template is written once
 * and drawn for every event that picks it, and the events do not agree about
 * what shape their photos are. Fitting each one inside the authored box means a
 * portrait photo and a landscape one take the identical footprint, so the lines
 * under the photo never move between events — and neither is cropped or pulled
 * out of shape to manage it. */
.display-item :deep(.event-template-photo-slot > .event-template-photo) {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0;
}

/* An event with no photo of its own substitutes the token with nothing, leaving
   the box empty. It has to disappear along with the photo it was holding, or
   every such event would show a sized gap where a picture never arrived —
   the same rule the text tokens have always followed. `!important` because the
   box's `display` is authored inline, and an inline style outranks a selector. */
.display-item :deep(.event-template-photo-slot:empty) {
  display: none !important;
}

/* The board's own box, and the ground the two pages travel over during a
   rotation. It takes its height from the page currently in flow, exactly as it
   did when it held that page directly.

   `position: relative` is what the outgoing page is placed against, and
   `overflow: hidden` does two jobs: a page mid-swipe is clipped to the board
   instead of running out across the artboard, and — just as important — the
   artboard's own measurements never see it. `recalculateNoScrollFit` and
   `checkOverflow` read the track's scrollHeight, a transformed page would be
   part of that, and a board that shrank to half size for the length of every
   swipe is exactly what clipping here prevents. It is excluded from the
   `overflow: visible` rule above for the same reason the other structured
   feature items are: it renders a component of its own, not rich text, and
   nothing here depends on Quill's height. */
.yurtzeiten-n-display-item {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  white-space: normal;
}

/* One page of yahrzeits: the screenful the rotation timer currently has due. */
.yurtzeiten-n-page {
  width: 100%;
}

/* ------------------------- the yahrzeit page swipe -------------------------
 * A rotation used to re-create the board and fade it back in. It now swaps the
 * page inside the board and travels between the two, the way the Direction
 * setting in the Yurtzeiten settings modal describes it — across, right to
 * left, or upward, one row above the next.
 *
 * The outgoing page is taken out of the flow so the two share the same ground
 * rather than stacking; the incoming one stays in flow, so the board is the
 * height of the page arriving throughout. Both are clipped by the board above.
 *
 * `-enter-to` and `-leave-from` are left to the browser: with no transform of
 * their own they are the resting position, which is exactly where each page is
 * travelling to and from.
 */
.yz-page-swap-leave-active,
.yz-page-swipe-horizontal-leave-active,
.yz-page-swipe-vertical-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.yz-page-swipe-horizontal-enter-active,
.yz-page-swipe-horizontal-leave-active,
.yz-page-swipe-vertical-enter-active,
.yz-page-swipe-vertical-leave-active {
  /* Duration is written onto the page inline, from the dwell it has to fit
     inside; this is the value for a page that never got one. */
  transition: transform var(--yz-page-swipe-duration, 700ms) cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

/* Horizontal — "Yahrzeits slide across, right to left": the next row comes in
   at the right edge as the row before it leaves by the left. */
.yz-page-swipe-horizontal-enter-from {
  /* One board's width out, whichever of the two pages is the wider — see
     `holdYurtzeitenPageBox`. The 100% is the page's own width, and stands alone
     for the first swipe of a board that has not had one yet. */
  transform: translateX(max(var(--yz-page-swipe-from-x, 0px), 100%));
}

.yz-page-swipe-horizontal-leave-to {
  transform: translateX(-100%);
}

/* Vertical — "Yahrzeits move upward, one row above the next": the next row
   rises from below as the row before it goes up and out. */
.yz-page-swipe-vertical-enter-from {
  /* One board's height below, whichever of the two pages is the taller. */
  transform: translateY(max(var(--yz-page-swipe-from-y, 0px), 100%));
}

.yz-page-swipe-vertical-leave-to {
  transform: translateY(-100%);
}

.zmanim-n-display-item--horizontal-ticker,
.zmanim-n-display-item--horizontal-ticker > div,
.zmanim-n-display-item--horizontal-ticker .ql-editor {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  display: block;
}

.minyanim-preview-list {
  font-weight: bold;
  font-size: 1rem;
  direction: rtl;
  margin-top: 12px;
}

.minyanim-preview-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 2px;
  font-size: 0.85rem;
  font-weight: 500;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 3px;
}

.minyanim-room {
  margin-left: 8px;
  white-space: nowrap;
}

.minyanim-time {
  margin-right: 8px;
  white-space: nowrap;
}

/* Secondary timestamps (Bruches / Hoidy / Ashrei / Borchy / Netz), scoped to the roll display */
.roll-display-item .minyanim-time {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.15;
}

.roll-display-item .minyanim-secondary-time {
  font-size: 0.7em;
  font-weight: 500;
  opacity: 0.75;
  white-space: nowrap;
}

.minyanim-dots {
  flex: 1 1 auto;
  border-bottom: 1px dotted;
  height: 0.7em;
  margin: 0 4px;
  opacity: 0.7;
  position: relative;
  top: -2px;
}

/* ===== Minyanim Roll — design-driven rendering ===== */
.roll-container {
  margin-bottom: 30px;
}

.roll-title {
  font-weight: 600;
  text-align: center;
  margin-bottom: 8px;
}

.roll-group-header {
  font-weight: 600;
  padding: 4px 8px;
  margin: 8px 0 4px;
  border-radius: 4px;
}

/* Time / Name divider variants (the dotted variant reuses .minyanim-dots) */
.roll-divider--spacer {
  flex: 1 1 auto;
}

.roll-divider--line {
  flex: 1 1 auto;
  height: 0.7em;
  margin: 0 6px;
  border-bottom: 1px solid currentColor;
  opacity: 0.5;
  position: relative;
  top: -2px;
}

.roll-side {
  white-space: nowrap;
}

/* "Underline" field — its own centered line beneath each list row. Matches the
   row's left/right text size and weight (no underline, not bold). */
.roll-underline {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  gap: 2px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  /* Center the whole line; also defeats the text-align:left the roll inherits
     from Quill's .ql-editor on the live display. */
  text-align: center;
  margin-top: 1px;
  padding-bottom: 3px;
}

.roll-underline-value {
  text-decoration: none;
  white-space: nowrap;
}

/* ----- Card view ----- */
.roll-cards {
  margin-top: 12px;
}

.roll-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  min-width: 0;
}

.roll-card-minyan {
  font-weight: 600;
}

.roll-card-room {
  font-size: 0.85em;
  opacity: 0.85;
}

.roll-card .minyanim-time {
  margin-right: 0;
  align-items: center;
}

.roll-card-countdown {
  font-weight: 600;
  font-size: 0.85em;
}

/* ----- Grid-designer card ----- */
.roll-grid {
  width: 100%;
}

.roll-grid-cell {
  min-width: 0;
  word-break: break-word;
}

/* The cell body is injected via v-html, so its nodes need :deep() to be
   reached by this component's scoped styles. */
.roll-grid-cell :deep(p) {
  margin: 0;
}

.roll-grid-cell :deep(img) {
  max-width: 100%;
  height: auto;
}

/* Text-type roll item: rendered as a full-width header band that splits the
   minyanim into sections (identical in card and list view). The authored rich
   text supplies the look; this just spans full width and spaces the sections
   apart. The body is injected via v-html, so its nodes need :deep() to be
   reached by these scoped styles. */
.roll-text-header {
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0 6px;
  word-break: break-word;
}

.roll-text-header:first-child {
  margin-top: 0;
}

.roll-text-header__body {
  width: 100%;
  min-width: 0;
}

.roll-text-header__body :deep(p) {
  margin: 0;
}

.roll-text-header__body :deep(img) {
  max-width: 100%;
  height: auto;
}

.zmanim-n-display {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 10px;
  align-items: stretch;
  padding: 2px;
  box-sizing: border-box;
}

.zmanim-n-display--list-horizontal {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  min-width: 200%;
  gap: 80px;
  overflow: visible;
  direction: ltr;
  white-space: nowrap;
  animation-name: zmanim-n-ticker-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* No-scroll artboard: hold the horizontal list still and scale the actual
   ticker track to fit the artboard width instead of letting hidden overflow
   crop the row. */
.zmanim-n-display--list-horizontal-static {
  display: flex;
  width: 100%;
  min-width: 0;
  justify-content: flex-start;
  gap: 0;
  direction: rtl;
  animation-name: none;
  --zmanim-n-static-horizontal-scale: 1;
}

.zmanim-n-display--list-horizontal-static .zmanim-n-ticker-track {
  margin-inline: auto;
  direction: rtl;
  transform: scale(var(--zmanim-n-static-horizontal-scale, 1));
  transform-origin: right center;
}

/* Drop the trailing separator after the final item so a static row doesn't end
   with a dangling divider symbol (it only exists to space looped marquee copies). */
.zmanim-n-display--list-horizontal-static .zmanim-n-ticker-item:last-child .zmanim-n-divider-symbol {
  display: none;
}

.zmanim-n-display--list-vertical {
  gap: 0;
  align-items: start;
}

.zmanim-n-list-column {
  display: flex;
  flex-direction: column;
  gap: var(--zmanim-n-row-gap, 0px);
  min-width: 0;
}

.zmanim-n-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.zmanim-n-display--card .zmanim-n-row {
  padding: var(--zmanim-n-card-padding, 12px 14px);
  background: var(--zmanim-n-card-background-color, #ffffff);
  border: 1px solid var(--zmanim-n-card-border-color, #e5e7eb);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

/* Grid Designer card (mirrors .roll-grid): the grid fills the card; each cell
   lays out per the chosen grid layout with its {name}/{time}/{countdown} text. */
.zmanim-n-grid {
  width: 100%;
}

.zmanim-n-grid-cell {
  min-width: 0;
  word-break: break-word;
}

.zmanim-n-grid-cell :deep(p) {
  margin: 0;
}

.zmanim-n-grid-cell :deep(img) {
  max-width: 100%;
  height: auto;
}

.zmanim-n-display--list .zmanim-n-row {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.zmanim-n-display--list-vertical .zmanim-n-row + .zmanim-n-row {
  margin-top: var(--zmanim-n-row-overlap, 0px);
}

.zmanim-n-display--list-vertical .zmanim-n-row {
  min-width: 0;
  overflow: hidden;
}

.zmanim-n-display--rows-2 .zmanim-n-row {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
}

.zmanim-n-display--rows-2 .zmanim-n-row .zmanim-n-label,
.zmanim-n-display--rows-2 .zmanim-n-row .zmanim-n-time {
  text-align: center;
  width: 100%;
}

.zmanim-n-display--divider-line.zmanim-n-display--list-vertical .zmanim-n-row:not(:last-child) {
  border-bottom: 1px solid var(--zmanim-n-row-divider-color, currentColor);
}

.zmanim-n-display--divider-dots.zmanim-n-display--list-vertical .zmanim-n-row:not(:last-child) {
  border-bottom: 1px dotted var(--zmanim-n-row-divider-color, currentColor);
}

.zmanim-n-ticker-track {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;
  width: max-content;
  min-width: max-content;
  padding-inline: 18px;
  box-sizing: border-box;
}

.zmanim-n-ticker-item {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: max-content;
  padding: 0 24px;
  white-space: nowrap;
}

.zmanim-n-display--list-horizontal .zmanim-n-ticker-item {
  padding: 0;
}

.zmanim-n-ticker-content {
  display: inline-flex;
  flex-direction: row;
  align-items: baseline;
  gap: 12px;
  direction: rtl;
  min-width: max-content;
  white-space: nowrap;
}

.zmanim-n-time-label-divider {
  display: inline-block;
  min-width: 24px;
  height: 0;
  opacity: 0.85;
  transform: translateY(-0.25em);
}

.zmanim-n-time-label-divider--line {
  min-width: 44px;
  border-top: 2px solid currentColor;
}

.zmanim-n-time-label-divider--dots {
  min-width: 44px;
  border-top: 2px dotted currentColor;
}

.zmanim-n-display--list-vertical .zmanim-n-time-label-divider {
  flex: 1 1 8px;
  min-width: 8px;
  margin-inline: 2px;
  transform: none;
  align-self: center;
}

.zmanim-n-divider-symbol {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding-inline: 16px 0;
  font-weight: 700;
}

.zmanim-n-display--list-horizontal .zmanim-n-divider-symbol {
  margin-inline: 18px;
  padding-inline: 0;
}

.zmanim-n-row--active {
  border-color: #e5e7eb;
}

.zmanim-n-label {
  font-weight: 500;
  text-align: right;
}

.zmanim-n-time {
  font-weight: 700;
  white-space: nowrap;
  text-align: left;
}

.zmanim-n-display--list-vertical .zmanim-n-label {
  flex: 0 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
  line-height: 1.15;
}

.zmanim-n-display--list-vertical .zmanim-n-time {
  flex: 0 0 auto;
  min-width: max-content;
}

@keyframes zmanim-n-ticker-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fadeIn {
  animation: fadeIn 1s forwards;
  display: block;
}

.fadeOut {
  animation: fadeOut 1s forwards;
  display: block; /* Keep the element in the DOM during fadeOut */
}

.credits-scroll {
  display: inline-block;
  /* The animation duration should be proportional to content height for best effect */
  animation: credits-scroll 80s linear infinite;
}

.credits-scroll {
  overflow: hidden!important;        /* Hide overflow */
  scrollbar-width: none;   /* Firefox */
}

.credits-scroll::-webkit-scrollbar {
  display: none;           /* Chrome, Safari, Edge */
}
/* Inner scroller: sized to its own content so the seamless-loop math
 * (translate -50% == exactly one content copy) always holds. The
 * .scaled-content viewport above owns the scale transform and clips the
 * overflow, so this element only ever translates — the two never fight,
 * and tall content is never cut off mid-scroll. */
.credits-scroller {
  box-sizing: border-box;
  width: 100%;
}

/* Track wrapper for duplicated content */
.credits-track {
  flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

/* Top-aligned (non-scrolling) artboard content. Content sits flush to the top
   of the artboard and renders at its natural height; vertical placement is left
   entirely to each feature's own component, not forced to center here. */
.credits-no-scroll {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.credits-no-scroll .credits-track {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.credits-no-scroll .display-item {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* In the vertical scroll modes the track is laid out in a centered flex
 * column, so without an explicit width it (and the display item inside it)
 * shrink-wraps to its content — collapsing a single-column roll/zmanim to a
 * fraction of the artboard. Force full width here, exactly as the no-scroll
 * mode does, so content always spans the whole artboard. (`align-items:
 * center` then has no effect on a full-width child.) */
.credits-vertical-static .credits-track,
.credits-scroll-vertical .credits-track {
  width: 100%;
  max-width: 100%;
}

.credits-vertical-static .display-item,
.credits-scroll-vertical .display-item {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* VERTICAL continuous scroll. animation-duration is supplied inline by
 * getCreditsScrollerStyle() (distance / defaultScrollSpeed) for a constant,
 * readable speed; the value here is only a fallback for the first frame
 * before the content has been measured. */
.credits-scroll-vertical {
  display: flex;
  flex-direction: column;
  width: 100%;
  animation-name: credits-scroll-vertical;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 60s;
  will-change: transform;
}

/* VERTICAL scroll mode, but content fits — render stationary, flush to the
 * top of the artboard. `align-items: stretch` makes the track/content fill the
 * full artboard width (otherwise a 1-column grid shrink-wraps to its content
 * and collapses to a fraction of the width). */
.credits-vertical-static {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@keyframes credits-scroll-vertical {
  0% {
    transform: translateY(0);
  }
  100% {
    /* Move up by half the total height (two copies stacked) == one full copy */
    transform: translateY(-50%);
  }
}

/* A horizontal artboard whose content already fits: one copy, centred, and no
 * animation. The mirror of .credits-vertical-static — there is nothing to
 * scroll, and looping here would put the same item on screen twice. */
.credits-horizontal-static {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.credits-horizontal-static .credits-track {
  width: max-content;
  max-width: 100%;
  overflow: visible;
}

/* HORIZONTAL continuous scroll (marquee). Sized to its content so -50% lands
 * exactly one copy over. animation-duration is supplied inline (see above). */
.credits-scroll-horizontal {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: max-content;
  max-width: none;
  animation-name: credits-scroll-horizontal;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 60s;
  will-change: transform;
}

.credits-scroll-horizontal .credits-track {
  white-space: nowrap; /* keep content in a single line */
  width: max-content;
  max-width: none;
  overflow: visible;
}

@keyframes credits-scroll-horizontal {
  0% {
    transform: translateX(0);
  }
  100% {
    /* Move left by half the total width (two copies side by side) == one copy */
    transform: translateX(-50%);
  }
}
</style>
